var cn = Object.defineProperty;
var dn = (e, t, n) => t in e ? cn(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var q = (e, t, n) => dn(e, typeof t != "symbol" ? t + "" : t, n);
import "@digirati/canvas-panel-web-components";
import { useLocalization as O, ResourceUnavailable as Me, ImageResponsive as hn, Icon as le, GuiButton as Ee, RichText as Ye, GuiLink as Xe, ListingCarousel as fn, useAlignImagesToBase as mn, GuiInput as Je, DelimitedFieldValues as gn, CopyButton as yn, modalControlsMixin as Ke, useEventBus as pn, breakpointsMixin as vn, Modal as bn, VideoPlayer as wn } from "@thegetty-private/getty-ui";
import { extractImageUuid as $e } from "@thegetty-private/linked-data.js";
import { resolveComponent as f, createElementBlock as m, openBlock as u, createCommentVNode as g, createVNode as p, createElementVNode as b, createBlock as v, resolveDynamicComponent as ge, mergeProps as ue, withCtx as E, createTextVNode as $, toDisplayString as A, Fragment as D, markRaw as Cn, renderList as ne, normalizeClass as C, useId as Te, useTemplateRef as In, createSlots as An, normalizeProps as Sn, guardReactiveProps as Mn, Teleport as Le, renderSlot as En, ref as De, normalizeStyle as et, Transition as tt, computed as P } from "vue";
const Tn = "rightsstatements.org/vocab/NoC-US/1.0/", Ln = "rightsstatements.org/vocab/InC/1.0/", Rn = "rightsstatements.org/vocab/CNE/1.0/", Pn = "rightsstatements.org/vocab/InC-RUU/1.0/", On = "rightsstatements.org/vocab/UND/1.0/", kn = "creativecommons.org/publicdomain/zero/1.0/", _ = {
  NO_COPYRIGHT: Tn,
  IN_COPYRIGHT: Ln,
  NOT_EVALUATED: Rn,
  IN_COPYRIGHT_UNIDENTIFIABLE: Pn,
  UNDETERMINED: On,
  ZERO: kn
};
function ae(e, t = "en", n = " ", i = "label") {
  if (!e[i])
    return;
  const s = Object.keys(e[i]);
  let a = s.indexOf(t) != -1 ? s.indexOf(t) : 0;
  return e[i][s[a]].join(n);
}
function ye(e) {
  let t;
  return e.type == "Canvas" && (t = e.id), e.type == "Image" && (t = e.service[0].id || e.service[0]["@id"]), e.type == "Annotation" && (t = e.body[0].id, t.includes("full") && (t = t.split("/").slice(0, -4).join("/"))), t;
}
function qn(e) {
  let t = {}, n = e.reduce((i, s) => {
    let a = Object.keys(s).filter((r) => !i.includes(r));
    return i.concat(a);
  }, []);
  for (let i of n)
    e.forEach((s) => {
      t[i] ? t[i] = t[i].concat(s[i]) : t[i] = s[i];
    });
  return t;
}
function _n(e) {
  const t = e.rights ? e.rights.split("//")[1] : void 0;
  return t && [
    _.IN_COPYRIGHT,
    _.IN_COPYRIGHT_UNIDENTIFIABLE
  ].includes(t);
}
function Dn(e, t, n, i) {
  const s = t ? `${t[0]},` : "full", a = `${$e(e, i)}_${(t == null ? void 0 : t[0]) ?? "full"}.jpg`;
  return `${e}/full/${s}/0/default.jpg?download=${a}&size=${n}`;
}
const nt = {
  name: "ViewerSupport",
  emits: [
    "cp-load-error",
    "currentChoices",
    "fullscreenchange",
    "ready",
    "thumbnailsReady",
    "togglePaged",
    "worldReady",
    "zoom"
  ],
  props: {
    /**
     * The manifest url
     */
    manifestUrl: {
      type: String,
      required: !0
    },
    /**
     * the order index of the canvas in the manifest
     */
    canvasIndex: {
      type: Number,
      default: void 0
    },
    /**
     * Whether to override the default thumbnails from the manifest with full canvases
     */
    useCanvasThumbnails: {
      type: Boolean,
      default: !1
    },
    /**
     * Option for parent to provide canvas id to display
     */
    canvasId: {
      type: String,
      default: void 0
    },
    /**
     * Object for providing optional additional data to image derived from visual item (also accepts canvas uuid)
     * { 	"https://media.getty.edu/iiif/image/b3c4fb26-04de-4ac8-9df7-f020f4f97a51":
     *    {
     *      altText: 'alt text',
     *      canDownload: false,
     *      copyright: 'copyright statement',
     *      descriptiveNote: 'description',
     *      disableContextMenu: false,
     *      isDisplayable: false,
     *      isZoomable: false,
     *      rightsCopyrightStatementText: 'In Copyright. [Terms Of Use](link)',
     *      rightsIconName: 'Copyright'
     *      rightsStatementId: 'rightsstatement.org url,
     *    }
     * }
     */
    imageMetadata: {
      type: Object,
      default: () => ({})
    },
    /**
     * A delimiting string for parsing uuids from non-Getty IIIF image services
     */
    iiifImageUrlPart: {
      type: String,
      default: void 0
    },
    /**
     * Label behavior for thumbnails, uses thumbnail label by default with options
     * to use the range label or concatenate both
     */
    labelSource: {
      type: String,
      default: "default",
      validator: (e) => ["default", "range", "all"].includes(e)
    }
  },
  setup(e) {
    return {
      ...O({
        baseLocaleKey: e == null ? void 0 : e.baseLocaleKey
      })
    };
  },
  data() {
    return {
      locale: this.$i18n.locale ?? "en",
      /* Current manifest in vault */
      manifest: void 0,
      /**
       * Current choices
       * { choice_id: [ choice_object, choice_object] }
       */
      currentChoices: {},
      /**
       * Have display annotations for choices been added?
       */
      displayAnnotationsAdded: !1,
      /**
       * Fetch manifest status error
       */
      errorMessage: void 0,
      /**
       * Stored x/y coords on a mousedown event in order to detect zoom
       */
      clickCoords: {},
      /**
       * canvas panel a11y title attribute
       */
      canvasTitle: void 0
    };
  },
  watch: {
    async manifestUrl() {
      await this.loadManifest();
    }
  },
  computed: {
    /**
     * Returns the canvas id of the image (selected) to be displayed in the viewer (canvas panel only)
     *
     * @return {string} canvas id
     * */
    currentCanvasId() {
      var e;
      if ((e = this.manifest) != null && e.items)
        return this.canvasId ? this.canvasId : this.manifest.items[0].id;
    }
  },
  methods: {
    /**
     * Loads the manifest into vault
     */
    async loadManifest() {
      var e;
      if (this.$el) {
        let t = this.$el.vault.get(this.manifestUrl);
        if (t && ["Collection", "Dataset"].includes(t == null ? void 0 : t.type) && (this.manifest = this.$el.vault.get({
          id: this.manifestUrl,
          type: "Manifest"
        })), !this.manifest) {
          const n = await this.fetchManifest(this.manifestUrl);
          this.manifest = await ((e = this.$el.vault) == null ? void 0 : e.loadManifest(
            this.manifestUrl,
            n
          ));
        }
        this.getThumbnails();
      }
    },
    /**
     * Fetches the manifest json and updates error message
     *
     * @param {string} - manifest url
     * @returns {object|undefined} manifest json
     */
    async fetchManifest(e) {
      const t = await fetch(e);
      let n;
      if (t.status == 200)
        n = await t.json();
      else {
        let i = `${t.status} ${t.statusText}`;
        this.errorMessage = this.translatePart("o-image-viewer.error_message", {
          status: i
        });
      }
      return n;
    },
    /**
     * Returns either alt text provided by parent through additional image data
     * or canvas label property
     *
     * @param {Object} canvas - IIIF Canvas
     * @returns {String} alt text string
     */
    getAltText(e) {
      const t = this.getVisualItem(e), n = this.getImageServiceRef(e);
      return (t == null ? void 0 : t.altText) || this.getLabel(n, this.locale);
    },
    /**
     * Filters an array of IIIF Annotation based on if the annotation body refers to a choice
     *
     * @param {Array} annotations - Array IIF Annotation objects
     * @returns {Array} - IIF Annotation objects
     */
    getChoiceAnnotations(e) {
      return e.filter((n) => this.$el.vault.get(n.body[0].id).type == "Choice");
    },
    /**
     * Handle the zoom event
     * @param {event} e - the zoom event
     * @emits {zoom}
     *
     */
    handleZoom(e) {
      this.$emit("zoom", e);
    },
    /**
     * Handle Ready event
     * @param {event} e - the ready event
     */
    handleReady(e) {
      this.$emit("ready", e), this.manifest || this.loadManifest();
    },
    /**
     * Handle World Ready event
     * @param {event} e - the world-ready event
     */
    handleWorldReady(e) {
      this.$emit("worldReady", e), this.handleZoom(e);
    },
    /**
     * Add display annotations based on annotations that contain choices
     */
    async setChoiceDisplayAnnotations() {
      let e = await this.$el.vault.getState(), t = Object.values(e.iiif.entities.Annotation);
      const n = this.getChoiceAnnotations(t);
      for (let i of n)
        this.addChoiceDisplayAnnotation(i);
    },
    /**
     * Adds display annotation for a choice to the panel
     *
     * @param {object} - vault choice annotation object
     */
    async addChoiceDisplayAnnotation(e) {
      const t = this.$el.createAnnotationDisplay(e);
      t.className = `m-image-viewer__choice--${e.body[0].id}`;
      let n = await this.$el.vault.get(e.body[0].id), i = await this.$el.vault.get(n.items[0].id), s = this.getLabel(i);
      s && (t.title = s), this.$el.annotations.add(t);
    },
    /**
     * Handle click events, handle clicking on display annotations
     *
     * @deprecated not in use with switch to zoom events on single click - DEV-17753
     *
     * @param {event} e - double-click event
     */
    handleDblClick(e) {
      const t = e.composedPath()[0];
      let i = Array.from(t.classList).pop();
      if (i && i.startsWith("m-image-viewer__choice")) {
        const s = i.split("--").pop();
        let a = JSON.parse(JSON.stringify(this.currentChoices)), r = a[s].items[1], o = r.selected;
        this.$el.makeChoice(r.id, {
          deselect: o,
          deselectOthers: o
        }), a[s].items.forEach((l) => {
          l.selected = !l.selected;
        }), this.currentChoices = a;
      }
      this.$emit("currentChoices");
    },
    /**
     * Handle click events, enable mouse control of zoom buttons and account for pan/drag
     *
     * @param {event} e - click event
     */
    clickHandler(e) {
      if (["CANVAS-PANEL", "SEQUENCE-PANEL"].includes(e.target.tagName) && (e.type == "mousedown" && (this.clickCoords = { x: e.x, y: e.y }), e.type == "mouseup" && e.button == 0)) {
        if (this.clickCoords.x != e.x || this.clickCoords.y != e.y)
          return;
        e.metaKey ? this.$el.zoomOut() : this.$el.zoomIn();
      }
    },
    /**
     * Update current choices on choice event
     *
     * @param {event} e - choice event
     */
    handleChoice(e) {
      var t;
      if (((t = e.detail.choice) == null ? void 0 : t.type) == "single-choice") {
        let n = e.detail.choice.partOf.choiceId;
        this.currentChoices[n] = {
          ...e.detail.choice,
          // make sure selected is first in the array
          items: e.detail.choice.items.sort((i) => i.selected ? -1 : 1)
        }, this.$emit("currentChoices", this.currentChoices);
      }
    },
    /**
     * On context menu event (right-click), check whether to prevent menu from displaying
     * @param {e} - context menu event
     */
    handleContextMenu(e) {
      if (e.target.tagName == "CANVAS-PANEL" && this.currentCanvasId) {
        const t = this.$el.vault.get(this.currentCanvasId);
        this.getDisableContextMenu(t) && e.preventDefault();
      }
      e.target.tagName == "SEQUENCE-PANEL" && this.currentSequence && this.currentSequence.map(
        (n) => this.$el.vault.get(this.$el.sequence.items[n].id)
      ).some((n) => _n(n)) && e.preventDefault();
    },
    /**
     * Returns the IIIF Range/Structure that includes the supplied canvas id
     *
     * @param {String} canvasId - Valid canvas id
     * @returns {Object|undefined} - IIIF structure
     */
    getRangeByCanvasId(e) {
      let t = [];
      const n = Object.values(
        this.$el.vault.getState().iiif.entities.Range
      );
      return n && (t = n.filter(
        (i) => i.items && i.items.find((s) => s.id == e)
      )), t[0];
    },
    /**
     * Transforms array of canvases to expected object for thumbnailProps computed prop transform
     *
     * @param {Array} canvases - Array of IIIF canvases
     * @param {string} labelSource - Label behavior for thumbnails, uses thumbnail label by default with options
     * to use the range label or concatenate both if they are available
     *
     *
     * @returns {Object} Canvas Ids mapped to IIIF thumbnail or image content resource objects (or canvases if flagged)
     */
    mapCanvasesToThumbnails(e, t) {
      let n = {};
      return this.$el.vault.get(e).forEach((i) => {
        let s = this.getImageServiceRef(i), a = ye(s);
        if (s.label || (s.label = i.label), this.useCanvasThumbnails)
          n[a] = s;
        else {
          const r = this.getRangeByCanvasId(i.id);
          if (t == "range" && (r != null && r.label) && (s.label = r.label), t == "all" && (r != null && r.label) && (s.concatLabel = qn([
            s.label,
            r.label
          ])), s.type == "Image" && (n[a] = s), s.type == "Annotation") {
            const o = this.$el.vault.get(s.body[0].id), l = o.type == "Choice" ? o.items[0].id : o.id;
            n[a] = {
              id: l,
              label: i.label,
              type: "Image"
            };
          }
          n[a].canvasId = i.id;
        }
      }), n;
    },
    /**
     * Gets the correct locale label from IIIF content resource
     *
     * @param {Object} resource - IIIF Content Resource object
     * @param {String} locale - ISO language string
     * @returns {String} - concatenated label for display
     */
    getLabel(e) {
      return ae(e, this.locale);
    },
    /**
     * Returns the resource that refers to an image service from a canvas
     * @param {object} - IIIF canvas
     *
     * @return {object} - thumbnail, annotation, or defaults to canvas object
     */
    getImageServiceRef(e) {
      var n;
      let t;
      if (this.useCanvasThumbnails)
        t = e;
      else if (e.thumbnail && e.thumbnail.length)
        t = this.$el.vault.get(e.thumbnail[0]);
      else if (e.items && e.items.length) {
        let i = this.$el.vault.get(e.items[0].id);
        t = this.$el.vault.get(((n = i == null ? void 0 : i.items) == null ? void 0 : n[0]) ?? {}) ?? e;
      }
      return JSON.parse(JSON.stringify(t));
    },
    /**
     * Returns whether to disable context menu (right-click) based on canvas
     *
     * @param {Object} canvas - IIIF Canvas
     * @returns {boolean} whether to disable the context menu
     */
    getDisableContextMenu(e) {
      const t = this.getVisualItem(e);
      return (t == null ? void 0 : t.disableContextMenu) === !0;
    },
    /**
     * Returns the image metadata entry derived from the visual item if provided
     * @param {object} canvas - IIIF Canvas
     * @returns {object|undefined}
     */
    getVisualItem(e) {
      const t = this.getImageServiceRef(e), n = ye(t);
      return this.imageMetadata[n] || this.imageMetadata[e.id];
    }
  }
}, I = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [i, s] of t)
    n[i] = s;
  return n;
}, Nn = {
  name: "CanvasViewer",
  components: { ResourceUnavailable: Me },
  mixins: [nt],
  props: {
    /**
     * Whether or not the current canvas is zoomable
     */
    isZoomable: {
      type: Boolean,
      default: !0
    },
    /**
     * Degrees of rotation to apply to the canvas
     */
    rotation: {
      type: Number,
      default: 0
    }
  },
  emits: ["thumbnailsReady", "canvasChange", "cp-load-error"],
  watch: {
    /**
     * @fixme Do we need this
     */
    useCanvasThumbnails() {
      this.getThumbnails();
    }
  },
  methods: {
    /**
     * Handles the change in canvas
     *
     * @param {e} - the canvas change event
     */
    async handleCurrentCanvas(e) {
      var t, n;
      if (await this.$nextTick(), this.currentChoices = {}, (t = e.detail) != null && t.canvas) {
        const i = this.$el.vault.get(e.detail.canvas), s = this.getImageServiceRef(i), a = ye(s), r = this.$el.vault.get(a);
        let o = a, l, d = (n = r == null ? void 0 : r.service) == null ? void 0 : n[0];
        d && (l = d == null ? void 0 : d.sizes, o = d.id ?? o), e.detail.image = a, e.detail.canvasDetails = {
          width: i.width,
          height: i.height,
          serviceUrl: o,
          sizes: l
        };
      }
      this.canvasTitle = this.buildCanvasTitle(), this.$emit("canvasChange", e);
    },
    /**
     * Gets thumbnails from manifest items
     *
     * @emits("thumbnailsReady")
     */
    getThumbnails() {
      var e;
      if (this.manifest) {
        let t = ((e = this.manifest) == null ? void 0 : e.items) ?? [];
        const n = this.mapCanvasesToThumbnails(
          t,
          this.labelSource
        );
        this.$emit("thumbnailsReady", n);
      }
    },
    /**
     * A title for the HTML canvas
     * @return {string | undefined }
     */
    buildCanvasTitle() {
      if (this.currentCanvasId)
        return this.getAltText(this.$el.vault.get(this.currentCanvasId));
    }
  }
}, xn = ["manifest-id", "canvas-id", "interactive", "a11y-title", "rotation"], Fn = {
  key: 0,
  slot: "fallback",
  name: "error-fallback",
  class: "m-image-viewer__error"
};
function Bn(e, t, n, i, s, a) {
  const r = f("ResourceUnavailable");
  return u(), m("canvas-panel", {
    key: n.isZoomable,
    "manifest-id": e.manifestUrl,
    "canvas-id": e.currentCanvasId,
    interactive: n.isZoomable.toString(),
    "a11y-role": "img",
    "a11y-title": e.canvasTitle,
    rotation: n.rotation,
    onReadyOnce: t[0] || (t[0] = (...o) => e.handleReady && e.handleReady(...o)),
    onWorldReady: t[1] || (t[1] = (...o) => e.handleWorldReady && e.handleWorldReady(...o)),
    onZoom: t[2] || (t[2] = (...o) => e.handleZoom && e.handleZoom(...o)),
    onCanvasChange: t[3] || (t[3] = (...o) => a.handleCurrentCanvas && a.handleCurrentCanvas(...o)),
    onMousedown: t[4] || (t[4] = (...o) => e.clickHandler && e.clickHandler(...o)),
    onMouseup: t[5] || (t[5] = (...o) => e.clickHandler && e.clickHandler(...o)),
    onChoice: t[6] || (t[6] = (...o) => e.handleChoice && e.handleChoice(...o)),
    onContextmenu: t[7] || (t[7] = (...o) => e.handleContextMenu && e.handleContextMenu(...o)),
    onCpLoadError: t[8] || (t[8] = (o) => e.$emit("cp-load-error"))
  }, [
    e.errorMessage ? (u(), m("div", Fn, [
      p(r, { "caption-text": e.errorMessage }, null, 8, ["caption-text"])
    ])) : g("", !0)
  ], 40, xn);
}
const Un = /* @__PURE__ */ I(Nn, [["render", Bn]]), zn = {
  name: "SequenceViewer",
  components: { ResourceUnavailable: Me },
  mixins: [nt],
  props: {
    baseLocaleKey: {
      type: String,
      required: !1,
      default: "o-image-viewer"
    },
    /* Current range id for ranges */
    rangeId: {
      type: String,
      default: void 0
    },
    /* Component type */
    componentType: {
      type: String,
      default: void 0
    },
    /* Whether or not to show gallery view */
    showGallery: {
      type: Boolean,
      default: !1
    },
    /* The layout type of the viewer */
    viewerLayout: {
      type: String,
      default: void 0
    }
  },
  emits: [
    "currentChoices",
    "currentSequence",
    "numberOfSlides",
    "slideIndex",
    "thumbnailsReady",
    "cp-load-error",
    "sequenceChange"
  ],
  setup(e) {
    return {
      ...O({
        baseLocaleKey: e == null ? void 0 : e.baseLocaleKey
      })
    };
  },
  data() {
    return {
      /* Gutter between facing pages */
      sequenceMargin: 100,
      /* Item indexes of the current sequence */
      currentSequence: [],
      /**
       * the current position in the sequence
       */
      sequencePosition: 0,
      /**
       * the total # of items in the sequence
       */
      sequenceLength: 0,
      /**
       * The label for the HTML canvas for the facing pages view
       */
      facingPagesLabel: this.translate(
        this.baseLocaleKey + ".alt_text.facing_pages"
      ),
      /**
       * The label for the HTML canvas for choices
       */
      choiceLabel: this.translate(this.baseLocaleKey + ".alt_text.choice")
    };
  },
  computed: {
    /* Initialize range id if undefined for viewing ranges */
    rangeId_() {
      var t, n;
      let e = this.rangeId;
      return this.componentType == "range" && !this.rangeId && (e = (n = (t = this.manifest) == null ? void 0 : t.structures[0]) == null ? void 0 : n.id), e;
    }
  },
  watch: {
    currentCanvasId() {
      this.currentCanvasId && this.$el.sequence && this.$el.sequence.setCurrentCanvasId(this.currentCanvasId);
    },
    /* Reload thumbnails when range updates for viewing ranges */
    rangeId_() {
      this.getThumbnails();
    },
    /**
     * Update manifest and current sequence if layout changes
     *
     * @async
     * @param {string} next - The viewer layout type
     */
    async viewerLayout(e, t) {
      const n = this.$el.sequence.currentSequenceIndex, i = this.$el.sequence.sequence[n];
      if (["individuals", "paged"].includes(e)) {
        const s = this.componentType == "sequence" ? this.manifestUrl : this.rangeId_, a = this.$el.vault.get(s);
        if (await this.$el.vault.modifyEntityField(a, "behavior", e), e == "individuals" && t == "gallery" && this.canvasId)
          this.$el.sequence.setCurrentCanvasId(this.currentCanvasId);
        else if (this.$el.sequence.setCurrentCanvasIndex(i[0]), i[0] < 2) {
          let r = {
            detail: {
              total: this.$el.sequence.sequence.length,
              index: i[0]
            }
          };
          this.handleCurrentSequence(r);
        }
      }
    }
  },
  methods: {
    /**
     * Helper for getting child annotations from canvases with annotation pages
     *
     * @param {array} - IIIF canvases
     *
     * @returns {array} - array of IIIF annotation resources
     */
    getAnnotationsFromCanvas(e) {
      let n = this.$el.vault.get(e.items).reduce(
        (i, s) => i.concat(s.items),
        []
      );
      return this.$el.vault.get(n);
    },
    /**
     * Gets thumbnails from items or current range
     *
     * @emits("thumbnailsReady")
     *
     */
    getThumbnails() {
      if (this.manifest) {
        let e = this.componentType == "range" && this.rangeId_ ? this.$el.vault.get(this.rangeId_) : this.manifest;
        e = (e == null ? void 0 : e.items) ?? [];
        const t = this.mapCanvasesToThumbnails(
          e,
          this.labelSource
        );
        this.$emit("thumbnailsReady", t);
      }
    },
    /**
     * Uses the manifest and sequencePosition to generate a title for
     * the HTML canvas
     *
     * @param {array} canvases - the list of canvases
     *
     * @returns {string} - the a11y-title
     */
    buildCanvasTitle(e) {
      var t;
      if (this.manifest && ((t = this.$el.sequence) != null && t.sequence)) {
        const n = this.buildCanvasLabelObjects(e);
        return this.buildCanvasLabels(n);
      }
    },
    /**
     * Takes a list of objects with a IIIF canvas and its annotations and returns
     * a list of objects with the labels or alt text for each canvas asset
     *
     * @param {array} - an array of objects with IIIF canvases and their annotations
     *
     * @returns {array} - a list of objects with alt text and/or labels about a
     * IIIF canvas
     *
     */
    buildCanvasLabelObjects(e) {
      let t = [];
      return e.forEach((n) => {
        let i = {
          canvasLabel: this.getLabel(n)
        }, s = this.getRangeByCanvasId(n.id);
        s && (i.rangeLabel = this.getLabel(s));
        let a = this.getAnnotationsFromCanvas(n);
        this.getChoiceAnnotations(a).forEach((o) => {
          let l = this.$el.vault.get(o.body[0]), d = this.$el.vault.get(l.items).map((y) => this.getLabel(this.$el.vault.get(y.id)));
          d.length && (i.choiceLabel = d[0]);
        }), t.push(i);
      }), t;
    },
    /**
     * Takes a list of objects with the descriptive text about a canvas to generate
     * a title for the HTML canvas
     *
     * @param {array} - an array of objects with descriptive texts about a canvas
     *
     * @returns {string} - a string for the title of the HTML canvas
     *
     */
    buildCanvasLabels(e) {
      let t = [];
      if (e.forEach((n) => {
        let i = [];
        for (const [s, a] of Object.entries(n))
          s == "canvasLabel" && i.push(a), s == "rangeLabel" && i.push(a), s == "choiceLabel" && (i = i.concat([`with ${a}`, this.choiceLabel]));
        t.push(i.join(" "));
      }), t.length)
        return t.length == 2 ? `${this.facingPagesLabel}: ` + t.join(" and ") : t[0];
    },
    /**
     * handle sequence update - sets metadata about the currently displayed sequence
     *
     * @async
     * @param {event} e -the event
     * @emits numberOfSlides
     * @emits sequenceChange
     * @emits slideIndex
     * @emits currentSequence
     * @emits currentChoice
     *
     */
    async handleCurrentSequence(e) {
      this.sequenceLength = e.detail.total - 1, this.currentChoices = {}, this.sequencePosition = e.detail.index, this.$el.sequence.sequence[this.sequencePosition] == null && (this.sequencePosition = 0, this.$el.sequence.setCurrentCanvasIndex(0));
      let t = this.$el.sequence.sequence[this.sequencePosition];
      this.currentSequence = t;
      const n = this.currentSequence.map(
        (i) => this.$el.vault.get(this.$el.sequence.items[i].id)
      );
      this.canvasTitle = this.buildCanvasTitle(n), this.$emit("numberOfSlides", this.sequenceLength), this.$emit("sequenceChange", n), this.$emit("slideIndex", this.sequencePosition), this.$emit("currentSequence", this.currentSequence), this.$emit("currentChoices", {});
    },
    /**
     * If the loaded manifest does not have an internal value for "behavior",
     * set to "paged" to enable two-up viewing when first loaded
     *
     * @async
     */
    async initializeBehavior() {
      ["range", "sequence"].includes(this.componentType) && this.manifest && (!this.manifest.behavior || this.manifest.behavior.length == 0) && await this.$el.vault.modifyEntityField(
        this.manifest,
        "behavior",
        "paged"
      );
    }
  }
}, jn = ["manifest-id", "margin", "range-id", "a11y-title"], Gn = {
  slot: "fallback",
  class: "m-image-viewer__error"
};
function Zn(e, t, n, i, s, a) {
  const r = f("ResourceUnavailable");
  return u(), m("sequence-panel", {
    "manifest-id": e.manifestUrl,
    margin: s.sequenceMargin,
    "range-id": a.rangeId_,
    "a11y-role": "img",
    "a11y-title": e.canvasTitle,
    onReadyOnce: t[0] || (t[0] = (...o) => e.handleReady && e.handleReady(...o)),
    onWorldReady: t[1] || (t[1] = (...o) => e.handleWorldReady && e.handleWorldReady(...o)),
    onZoom: t[2] || (t[2] = (...o) => e.handleZoom && e.handleZoom(...o)),
    onCpLoadError: t[3] || (t[3] = (o) => e.$emit("cp-load-error")),
    onSequenceChange: t[4] || (t[4] = (...o) => a.handleCurrentSequence && a.handleCurrentSequence(...o)),
    onSequenceOnce: t[5] || (t[5] = (...o) => a.initializeBehavior && a.initializeBehavior(...o)),
    onMousedown: t[6] || (t[6] = (...o) => e.clickHandler && e.clickHandler(...o)),
    onMouseup: t[7] || (t[7] = (...o) => e.clickHandler && e.clickHandler(...o)),
    onChoice: t[8] || (t[8] = (...o) => e.handleChoice && e.handleChoice(...o)),
    onContextmenu: t[9] || (t[9] = (...o) => e.handleContextMenu && e.handleContextMenu(...o))
  }, [
    b("div", Gn, [
      p(r, { "caption-text": e.errorMessage }, null, 8, ["caption-text"])
    ])
  ], 40, jn);
}
const Vn = /* @__PURE__ */ I(zn, [["render", Zn]]), Wn = {
  name: "StaticCanvas",
  props: {
    /**
     * The manifest url
     */
    manifestUrl: {
      type: String,
      default: void 0
    },
    /**
     * The ID of the canvas to display
     */
    canvasId: {
      type: String,
      default: void 0
    },
    /**
     * Canvas height
     */
    canvasHeight: {
      type: Number,
      default: void 0
    },
    /**
     * Canvas width
     */
    canvasWidth: {
      type: Number,
      default: void 0
    },
    /**
     * Canvas panel preset
     */
    preset: {
      type: String,
      default: "responsive"
    },
    /**
     * Canvas alt text
     */
    alt: {
      type: String,
      default: void 0
    },
    /**
     * Canvas caption
     */
    caption: {
      type: String,
      default: void 0
    }
  },
  data() {
    return {
      /**
       * canvas panel a11y title attribute
       */
      canvasTitle: this.alt || this.caption
    };
  }
}, Hn = { class: "a-static-canvas" }, Qn = ["manifest-id", "canvas-id", "height", "width", "preset", "a11y-title"];
function Yn(e, t, n, i, s, a) {
  return u(), m("div", Hn, [
    b("canvas-panel", {
      "manifest-id": n.manifestUrl,
      "canvas-id": n.canvasId,
      height: n.canvasHeight,
      width: n.canvasWidth,
      preset: n.preset,
      "a11y-title": s.canvasTitle,
      "a11y-role": "img"
    }, null, 8, Qn)
  ]);
}
const Xn = /* @__PURE__ */ I(Wn, [["render", Yn]]), Jn = {
  name: "CanvasThumbnail",
  components: {
    ImageResponsive: hn,
    ResourceUnavailable: Me,
    StaticCanvas: Xn
  },
  props: {
    baseLocaleKey: {
      type: String,
      default: "a-thumbnail"
    },
    /**
     * Image Responsive or Static Canvas prop object
     */
    thumbnail: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      /**
       * Whether the image is available
       */
      imageAvailable: !0
    };
  },
  methods: {
    /**
     * Handle image responsive component error event
     */
    handleImageError() {
      this.imageAvailable = !1;
    }
  }
}, Kn = { class: "a-canvas-thumbnail__wrapper" };
function $n(e, t, n, i, s, a) {
  const r = f("ResourceUnavailable");
  return u(), m("div", Kn, [
    s.imageAvailable ? (u(), v(ge(n.thumbnail.type), ue({
      key: 0,
      "data-testid": "thumbnail",
      class: "a-canvas-thumbnail"
    }, n.thumbnail, { "onImageResponsive:LoadError": a.handleImageError }), {
      default: E(() => [
        $(A(n.thumbnail.caption), 1)
      ]),
      _: 1
    }, 16, ["onImageResponsive:LoadError"])) : (u(), m(D, { key: 1 }, [
      p(r, { class: "" }),
      b("figcaption", null, A(n.thumbnail.caption), 1)
    ], 64))
  ]);
}
const it = /* @__PURE__ */ I(Jn, [["render", $n]]), ei = {
  name: "ToolbarGallery",
  components: {
    CanvasThumbnail: it
  },
  props: {
    /* Array of thumbnail component prop objects*/
    thumbnailProps: {
      type: Array,
      required: !1,
      default: () => []
    },
    /**
     * Whether to use static canvases (true) or the image service thumbnail property (false) for thumbnails
     */
    useCanvasThumbnails: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["click"],
  data() {
    return {
      /**
       * Intersection Observer instance
       */
      observer: void 0,
      /**
       * Total entries that have intersected
       */
      totalObserved: 0,
      /**
       * Current y position of gallery unordered list
       */
      scrollY: void 0
    };
  },
  mounted() {
    this.initObserver();
  },
  methods: {
    /**
     * Initialize intesection observer on gallery element
     */
    initObserver() {
      const e = document.querySelector(".a-toolbar-gallery__wrapper"), t = e.querySelector(".a-toolbar-gallery__grid");
      this.observer = Cn(
        new IntersectionObserver((i) => {
          (this.scrollY == null || t.getBoundingClientRect().y < this.scrollY) && (this.totalObserved += i.filter(
            (s) => s.isIntersecting
          ).length), this.scrollY = t.getBoundingClientRect().y;
        })
      );
      const n = e.querySelectorAll("button");
      n.length && n.forEach((i) => {
        this.observer.observe(i);
      });
    }
  }
}, ti = { class: "a-toolbar-gallery" }, ni = { class: "a-toolbar-gallery__wrapper" }, ii = { class: "a-toolbar-gallery__grid" }, ai = ["data-canvas-id"];
function si(e, t, n, i, s, a) {
  const r = f("CanvasThumbnail");
  return u(), m("div", ti, [
    b("div", ni, [
      b("div", ii, [
        (u(!0), m(D, null, ne(n.thumbnailProps, (o, l) => (u(), m("button", {
          key: l,
          class: "a-toolbar-gallery__thumbnail",
          "data-canvas-id": o.canvasId,
          onClick: t[0] || (t[0] = (d) => e.$emit("click", d))
        }, [
          s.totalObserved && l < s.totalObserved ? (u(), v(r, ue({
            key: 0,
            ref_for: !0
          }, { thumbnail: o }), null, 16)) : g("", !0)
        ], 8, ai))), 128))
      ])
    ])
  ]);
}
const ri = /* @__PURE__ */ I(ei, [["render", si]]), oi = {
  name: "ToolbarButton",
  components: {
    GuiButton: Ee,
    Icon: le
  },
  props: {
    /**
     * The base locale key for the record metadata field component
     **/
    name: {
      type: String,
      required: !0
    },
    /**
     * Whether the button is disabled
     */
    disabled: {
      type: Boolean,
      default: !1
    },
    /**
     * The name of the icon
     */
    iconName: {
      type: String,
      required: !0
    },
    /**
     * The CSS variation
     */
    variation: {
      type: String,
      required: !0
    },
    /**
     * Icon aria title (and tooltip)
     */
    ariaTitle: {
      type: String,
      default: void 0
    },
    /**
     * Icon size
     */
    size: {
      type: Number,
      default: void 0
    }
  },
  emits: ["click"]
};
function li(e, t, n, i, s, a) {
  const r = f("Icon"), o = f("GuiButton");
  return u(), v(o, {
    name: n.name,
    modifiers: ["icon", "outline", "image-viewer-toolbar"],
    disabled: n.disabled,
    onClick: t[0] || (t[0] = (l) => e.$emit("click", l))
  }, {
    default: E(() => [
      p(r, {
        name: n.iconName,
        class: C(`m-image-viewer-toolbar__${n.variation}`),
        "aria-title": n.ariaTitle,
        size: n.size
      }, null, 8, ["name", "class", "aria-title", "size"])
    ]),
    _: 1
  }, 8, ["name", "disabled"]);
}
const ce = /* @__PURE__ */ I(oi, [["render", li]]), ui = {
  name: "FullscreenButton",
  components: {
    ToolbarButton: ce
  },
  inject: {
    /**
     * whether the viewer is in full-screen mode
     */
    isFullscreen: {
      type: Boolean,
      default: !1
    },
    /**
     * Whether full screen is available
     */
    fullscreenAvailable: {
      default: !0,
      type: Boolean
    },
    /**
     * the Toolbar Controller
     */
    toolbarController: {}
  },
  props: {
    /**
     * The base locale key for the record metadata field component
     **/
    baseLocaleKey: {
      type: String,
      default: "a-fullscreen-button"
    },
    /**
     * CSS modifiers
     */
    modifiers: {
      type: Array,
      required: !1,
      default: () => []
    }
  },
  setup(e) {
    return {
      ...O({
        baseLocaleKey: e == null ? void 0 : e.baseLocaleKey
      })
    };
  },
  data() {
    return {
      /**
       * Full screen enter aria title
       */
      fullscreenAriaTitle: this.translatePart("fullscreen"),
      /**
       * Full screen exit aria title
       */
      fullscreenExitAriaTitle: this.translatePart("fullscreenExit")
    };
  },
  computed: {
    /**
     * The icon for the fullscreen button (open/close)
     */
    fullscreenIcon() {
      let e = "FullScreenVideo400";
      return this.isFullscreen ? e = "close" : this.isFullscreen && (e = "FullScreenVideoExit400"), e;
    },
    /**
     * Classes to apply to the component
     * @returns {Array} css classes
     */
    classes() {
      let e = [this.baseLocaleKey];
      return this.modifiers.forEach((t) => {
        e.push(`${e[0]}--${t}`);
      }), e;
    }
  }
};
function ci(e, t, n, i, s, a) {
  const r = f("ToolbarButton");
  return u(), m("div", {
    class: C(a.classes)
  }, [
    p(r, {
      name: "enter-full-screen",
      variation: "full-screen",
      "icon-name": a.fullscreenIcon,
      "aria-title": a.isFullscreen ? s.fullscreenExitAriaTitle : s.fullscreenAriaTitle,
      onClick: t[0] || (t[0] = (o) => a.toolbarController.fullScreenChange())
    }, null, 8, ["icon-name", "aria-title"])
  ], 2);
}
const at = /* @__PURE__ */ I(ui, [["render", ci]]), di = {
  name: "ImageToolsButtonGroup",
  components: {
    FullscreenButton: at,
    ToolbarButton: ce
  },
  inject: {
    /**
     * Whether full screen is available
     */
    fullscreenAvailable: {
      default: !0,
      type: Boolean
    },
    /**
     * whether the viewer is in full-screen mode
     */
    isFullscreen: {
      type: Boolean,
      default: !1
    },
    /**
     * Whether the user can zoom in
     */
    canZoomIn: {
      type: Boolean,
      default: !0
    },
    /**
     * whether the user can zoom out
     */
    canZoomOut: {
      type: Boolean,
      default: !0
    },
    /**
     * whether this is a sequence or a canvas
     */
    isSequence: {
      type: Boolean,
      default: !1
    },
    /**
     * Whether the menu panel is shown
     */
    showMenuPanel: {
      type: Boolean,
      default: !1
    },
    /**
     * the viewer layout
     */
    viewerLayout: {
      type: String
    },
    /**
     * The label for the analytics event
     */
    analyticsLabel: {
      type: [String, void 0],
      default: void 0
    },
    /**
     * Whether to render mobile layout
     */
    isMobile: {
      type: Boolean,
      default: !1
    },
    /**
     * The Toolbar controller
     */
    toolbarController: {}
  },
  props: {
    baseLocaleKey: {
      type: String,
      default: "a-image-tools-button-group"
    },
    /**
     * Whether the button are being used in the legacy layout
     */
    isLegacyLayout: {
      type: Boolean,
      default: !1
    },
    /**
     * Whether to only show fullscreen close and hide other controls
     */
    showImageTools: {
      type: Boolean,
      default: !0
    },
    /**
     * Whether or not to enable the rotate button in the toolbar
     */
    showRotate: {
      type: Boolean,
      default: !1
    },
    /**
     * Whether or not to enable the zoom controls in the toolbar
     */
    showZoom: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    return {
      ...O({
        baseLocaleKey: e == null ? void 0 : e.baseLocaleKey
      })
    };
  },
  computed: {
    /**
     * Whether to show the fullscreen control button
     * @returns {boolean}
     */
    showFullscreenButton() {
      return !this.showZoom || this.fullscreenAvailable && !this.showImageTools && !this.isFullscreen ? !1 : this.fullscreenAvailable;
    }
  }
};
function hi(e, t, n, i, s, a) {
  const r = f("ToolbarButton"), o = f("FullscreenButton");
  return u(), m("div", {
    class: C(n.baseLocaleKey)
  }, [
    n.showImageTools ? (u(), m(D, { key: 0 }, [
      n.showZoom ? (u(), m(D, { key: 0 }, [
        p(r, {
          name: "zoom-in",
          variation: "zoomin",
          disabled: a.canZoomIn == !1 || a.viewerLayout == "gallery",
          "icon-name": "ZoomIn",
          onClick: t[0] || (t[0] = (l) => a.toolbarController.zoomIn(a.analyticsLabel))
        }, null, 8, ["disabled"]),
        p(r, {
          name: "zoom-out",
          variation: "zoomout",
          disabled: a.canZoomOut == !1 || a.viewerLayout == "gallery",
          "icon-name": "ZoomOut",
          onClick: t[1] || (t[1] = (l) => a.toolbarController.zoomOut(a.analyticsLabel))
        }, null, 8, ["disabled"])
      ], 64)) : g("", !0),
      !a.isSequence && n.showRotate ? (u(), v(r, {
        key: 1,
        name: "rotate",
        variation: "rotate",
        "icon-name": "Rotate",
        onClick: t[2] || (t[2] = (l) => a.toolbarController.rotate(a.analyticsLabel))
      })) : g("", !0)
    ], 64)) : g("", !0),
    !a.isMobile && a.showFullscreenButton ? (u(), v(o, {
      key: 1,
      modifiers: n.isLegacyLayout ? ["toolbar", "legacy"] : ["toolbar"],
      onClick: t[3] || (t[3] = (l) => a.toolbarController.fullScreenChange(a.analyticsLabel))
    }, null, 8, ["modifiers"])) : g("", !0)
  ], 2);
}
const Re = /* @__PURE__ */ I(di, [["render", hi]]), fi = {
  name: "ImageViewerRightsPanel",
  components: {
    GuiLink: Xe,
    Icon: le,
    RichText: Ye
  },
  props: {
    baseLocaleKey: {
      type: String,
      required: !1,
      default: "m-image-viewer-rights-panel"
    },
    /**
     * Additional image data derived from associated visual item
     *    {
     *      altText: 'alt text',
     *      canDownload: false,
     *      copyright: 'copyright statement',
     *      descriptiveNote: 'description',
     *      disableContextMenu: false,
     *      isDisplayable: false,
     *      isZoomable: false,
     *      rightsCopyrightStatementText: 'In Copyright. [Terms Of Use](link)',
     *      rightsIconName: 'Copyright'
     *      rightsStatementId: 'rightsstatement.org url,
     *    }
     */
    imageDetails: {
      type: Object,
      default: () => {
      }
    }
  },
  setup(e) {
    return {
      ...O({
        baseLocaleKey: e == null ? void 0 : e.baseLocaleKey
      })
    };
  },
  computed: {
    /**
     * Rights statement display string
     * @returns {string}
     */
    rightsStatementDisplay() {
      let e = "";
      if (this.imageDetails.rightsStatementId) {
        const t = this.imageDetails.rightsStatementId.split("//")[1], n = Object.entries(_).find(
          (i) => i[1] == t
        );
        e = this.translate(
          this.baseLocaleKey + "." + n[0]
        );
      }
      return e;
    },
    /**
     * Getty UI icon name corresponding to rights statement
     * @returns {string}
     */
    /**
     * The name of the icon to display beside the rights statement
     *
     * @returns {string} the icon name
     */
    rightsIconName() {
      var t;
      let e;
      switch ((t = this.imageDetails) == null ? void 0 : t.rightsStatementId) {
        case _.NO_COPYRIGHT:
          e = "CopyrightNone";
          break;
        case _.UNDETERMINED:
        case _.NOT_EVALUATED:
          e = "CopyrightOther";
          break;
        case _.ZERO:
          e = "CC0";
          break;
        case _.IN_COPYRIGHT:
        case _.IN_COPYRIGHT_UNIDENTIFIABLE:
        default:
          e = "Copyright";
          break;
      }
      return e;
    }
  }
}, mi = { class: "m-image-viewer-rights-panel" }, gi = { class: "m-image-viewer-rights-panel__rights-copyright" }, yi = {
  key: 0,
  class: "m-image-viewer-rights-panel__copyright"
}, pi = {
  key: 1,
  class: "m-image-viewer-rights-panel__rights-copyright-text"
};
function vi(e, t, n, i, s, a) {
  var d, y, w, h, R, Y;
  const r = f("GuiLink"), o = f("Icon"), l = f("RichText");
  return u(), m("div", mi, [
    b("div", gi, [
      (d = n.imageDetails) != null && d.rightsStatementId ? (u(), m("div", yi, [
        p(r, {
          ref: "rightsLink",
          href: n.imageDetails.rightsStatementId,
          "with-icon": "before",
          "icon-name": a.rightsIconName,
          class: "m-image-viewer-rights-panel__copyright-link"
        }, {
          default: E(() => [
            $(A(a.rightsStatementDisplay), 1)
          ]),
          _: 1
        }, 8, ["href", "icon-name"]),
        (y = n.imageDetails) != null && y.copyright ? (u(), m("span", {
          key: 0,
          ref: "copyrightStatement"
        }, A(n.imageDetails.copyright), 513)) : g("", !0)
      ])) : g("", !0),
      (w = n.imageDetails) != null && w.rightsCopyrightStatementText ? (u(), m("div", pi, [
        (h = n.imageDetails) != null && h.rightsIconName ? (u(), v(o, {
          key: 0,
          name: (R = n.imageDetails) == null ? void 0 : R.rightsIconName,
          class: "m-image-viewer-rights-panel__icon"
        }, null, 8, ["name"])) : g("", !0),
        p(l, {
          inline: !0,
          content: (Y = n.imageDetails) == null ? void 0 : Y.rightsCopyrightStatementText
        }, null, 8, ["content"])
      ])) : g("", !0)
    ])
  ]);
}
const bi = /* @__PURE__ */ I(fi, [["render", vi]]), wi = {
  name: "ImageViewerThumbnailCarousel",
  components: {
    ListingCarousel: fn,
    CanvasThumbnail: it
  },
  props: {
    baseLocaleKey: {
      type: String,
      required: !1,
      default: "m-image-viewer-thumbnails"
    },
    /**
     * The manifest url
     */
    manifestUrl: {
      type: String,
      required: !0
    },
    /**
     * Array of image responsive or static canvas prop objects
     */
    thumbnailProps: {
      type: Array,
      required: !0,
      validator: (e) => e.length > 1
    },
    /**
     * the id of the currently displayed canvas
     */
    canvasId: {
      type: String,
      default: void 0
    },
    /**
     * Increase the top margin to accomomodate the rights panel
     */
    addMarginTop: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["click"],
  setup(e) {
    return mn({
      componentRef: In("carousel"),
      useGrid: !1
    }), {
      ...O({
        baseLocaleKey: e == null ? void 0 : e.baseLocaleKey
      })
    };
  },
  data() {
    return {
      hasControls: !1,
      /* component id */
      componentId: Te()
    };
  },
  computed: {
    /**
     * Classes to apply to wrapper element
     * @returns {string}
     */
    wrapperClasses() {
      let e = "m-image-viewer-thumbnails__wrapper";
      return (this.hasControls || !this.addMarginTop) && (e += ` ${e}--with-controls`), e;
    },
    /**
     * Display and aria label for carousel
     * @returns {string}
     */
    thumbnailCountLabel() {
      var e;
      return this.translatePart("thumbnail_count_label", {
        count: ((e = this.thumbnailProps) == null ? void 0 : e.length) ?? 0
      });
    }
  },
  mounted() {
    this.checkForControls();
  },
  methods: {
    /**
     * check for visible tiny slider controls for spacing purposes
     */
    checkForControls() {
      const e = document.querySelector(".tns-controls");
      e && (this.hasControls = e.style.display !== "none");
    }
  }
}, Ci = ["id"], Ii = { class: "m-image-viewer-thumbnails__carousel" }, Ai = ["data-canvas-uuid", "data-canvas-id"];
function Si(e, t, n, i, s, a) {
  var l, d;
  const r = f("CanvasThumbnail"), o = f("ListingCarousel");
  return u(), m("div", {
    ref: "carousel",
    class: C(a.wrapperClasses)
  }, [
    (l = n.thumbnailProps) != null && l.length ? (u(), m("div", {
      key: 0,
      id: `carousel-label${s.componentId}`,
      class: "m-image-viewer-thumbnails__label"
    }, A(a.thumbnailCountLabel), 9, Ci)) : g("", !0),
    b("div", Ii, [
      p(o, {
        size: "imageviewer",
        items: n.thumbnailProps,
        "list-aria-id": `carousel-label${s.componentId}`
      }, An({ _: 2 }, [
        (d = n.thumbnailProps) != null && d.length ? {
          name: "item",
          fn: E(({ item: y }) => [
            b("button", {
              class: C(
                n.canvasId == y.canvasId ? "m-image-viewer-thumbnails__button" : [
                  "m-image-viewer-thumbnails__button",
                  "m-image-viewer-thumbnails__button--inactive"
                ]
              ),
              "data-canvas-uuid": y.id,
              "data-canvas-id": y.canvasId,
              onClick: t[0] || (t[0] = (w) => e.$emit("click", w))
            }, [
              p(r, Sn(Mn({ thumbnail: y })), null, 16)
            ], 10, Ai)
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["items", "list-aria-id"])
    ])
  ], 2);
}
const Mi = /* @__PURE__ */ I(wi, [["render", Si]]), Ei = {
  name: "ToolbarMenu",
  components: { GuiButton: Ee, Icon: le },
  inject: {
    /**
     * DOM element name of clicked toolbar button/menu
     */
    activeMenu: {
      type: [String, void 0],
      default: void 0
    },
    /**
     * Whether to render mobile layout
     */
    isMobile: {
      type: Boolean,
      default: !1
    }
  },
  props: {
    baseLocaleKey: {
      type: String,
      default: "a-toolbar-menu"
    },
    /**
     * Menu button name
     */
    name: {
      type: String,
      required: !0
    },
    /**
     * Menu button label
     */
    label: {
      type: String,
      required: !0
    },
    /**
     * Whether menu is disabled
     */
    disabled: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * tooltip label
     */
    tooltip: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * Teleport selector
     */
    teleportSelector: {
      type: [String, void 0],
      default: void 0
    },
    /**
     * Icon component variation name
     */
    iconName: {
      type: [String, void 0],
      default: void 0
    }
  },
  setup(e) {
    return {
      ...O({
        baseLocaleKey: e == null ? void 0 : e.baseLocaleKey
      })
    };
  },
  data() {
    return {
      /**
       * If sticky header overlaps tooltip
       */
      isTooltipBelow: !1,
      /**
       * Whether to show menu options
       */
      showMenu: !1
    };
  },
  computed: {
    /**
     * Currently active classes
     *
     * @returns {array} - list of string CSS classes
     */
    activeMenuClasses() {
      const e = ["a-toolbar-menu"];
      return this.showMenu && e.push("a-toolbar-menu--active"), e;
    },
    /**
     * Button aria label
     */
    ariaLabel() {
      return this.translatePart(
        `a-toolbar-menu.toggle.aria-${this.showMenu ? "open" : "close"}`,
        {
          menu: this.label
        }
      );
    }
  },
  watch: {
    activeMenu(e) {
      if (e !== this.name && (this.showMenu = !1), this.showMenu && this.$refs.options) {
        const t = this.$refs.options;
        (t.querySelector("[data-checked=true]") ? t.querySelector("[data-checked=true]") : t.querySelector("input")).focus();
      }
    }
  },
  mounted() {
    this.isMobile && this.name == this.activeMenu && (this.showMenu = !this.showMenu);
  },
  mounted() {
    this.isMobile && this.name == this.activeMenu && (this.showMenu = !this.showMenu);
  },
  methods: {
    /**
     * Calculates tooltip position classes based on list item width +
     * left margin and sticky header height
     *
     * @param {object} - mouseenter event
     */
    handleMouseEnter(e) {
      this.isTooltipBelow = e.clientY < 100;
    }
  }
}, Ti = { class: "a-toolbar-menu__label" }, Li = {
  ref: "options",
  "data-testid": "options",
  class: "a-toolbar-menu__options"
};
function Ri(e, t, n, i, s, a) {
  const r = f("Icon"), o = f("GuiButton");
  return u(), m("div", {
    class: C(a.activeMenuClasses),
    onMouseenter: t[1] || (t[1] = (...l) => a.handleMouseEnter && a.handleMouseEnter(...l))
  }, [
    p(o, {
      name: n.name,
      modifiers: ["outline", "text", "image-viewer-toolbar"],
      "aria-label": a.ariaLabel,
      disabled: n.disabled,
      onClick: t[0] || (t[0] = (l) => s.showMenu = !s.showMenu)
    }, {
      default: E(() => [
        n.iconName ? (u(), v(r, {
          key: 0,
          name: n.iconName,
          "aria-title": e.translatePart(n.iconName)
        }, null, 8, ["name", "aria-title"])) : g("", !0),
        b("span", Ti, A(n.label), 1)
      ]),
      _: 1
    }, 8, ["name", "aria-label", "disabled"]),
    n.disabled && n.tooltip ? (u(), m("span", {
      key: 0,
      class: C({
        "a-toolbar-menu__tooltip": !0,
        "a-toolbar-menu__tooltip--below": s.isTooltipBelow
      })
    }, A(n.tooltip), 3)) : g("", !0),
    s.showMenu ? (u(), v(Le, {
      key: 1,
      disabled: !n.teleportSelector,
      to: n.teleportSelector
    }, [
      b("div", Li, [
        En(e.$slots, "default")
      ], 512)
    ], 8, ["disabled", "to"])) : g("", !0)
  ], 34);
}
const st = /* @__PURE__ */ I(Ei, [["render", Ri]]), Pi = {
  name: "LayoutMenu",
  components: {
    GuiInput: Je,
    ToolbarMenu: st
  },
  inject: {
    /**
     * The manifest url
     */
    manifestUrl: {
      type: String
    },
    /**
     * The available options for the layout menu
     */
    activeLayoutOptions: {
      type: Array,
      default: () => ["individuals", "paged", "gallery"]
    },
    /**
     * the Toolbar Controller
     */
    toolbarController: {}
  },
  props: {
    /**
     * The base locale key for the record metadata field component
     **/
    baseLocaleKey: {
      type: String,
      required: !1,
      default: "a-layout-menu"
    },
    /**
     * The current viewer layout for establishing the selected menu value
     */
    currentSelection: {
      type: String,
      default: "paged"
    },
    /**
     * Teleport selector
     */
    teleportSelector: {
      type: [String, void 0],
      default: void 0
    }
  },
  emits: ["layoutChange"],
  setup(e) {
    return {
      ...O({
        baseLocaleKey: e == null ? void 0 : e.baseLocaleKey
      })
    };
  },
  data() {
    return {
      /**
       * View layout label
       */
      layoutLabel: this.translate(this.baseLocaleKey + ".layout.default"),
      /**
       * Facing Pages layout option label
       */
      facingPagesLabel: this.translate(this.baseLocaleKey + ".paged"),
      /**
       * Gallery layout option label
       */
      galleryLabel: this.translate(this.baseLocaleKey + ".gallery"),
      /**
       * Single Page layout option label
       */
      singlePageLabel: this.translate(this.baseLocaleKey + ".single_page")
    };
  },
  computed: {
    /**
     * Layout menu options
     * @return {object} - menu options
     */
    options() {
      const e = {
        individuals: this.singlePageLabel,
        paged: this.facingPagesLabel,
        gallery: this.galleryLabel
      };
      return Object.keys(e).reduce((n, i) => (this.activeLayoutOptions.includes(i) && (n[i] = e[i]), n), {});
    }
  }
};
function Oi(e, t, n, i, s, a) {
  const r = f("GuiInput"), o = f("ToolbarMenu");
  return u(), v(o, {
    class: "a-layout-menu",
    name: "toggleLayout",
    label: s.layoutLabel,
    "icon-name": "Grid",
    "teleport-selector": n.teleportSelector
  }, {
    default: E(() => [
      p(r, {
        name: "layout",
        type: "radio",
        options: a.options,
        value: n.currentSelection,
        onInput: t[0] || (t[0] = (l) => a.toolbarController.handleLayoutChange(l, a.manifestUrl))
      }, null, 8, ["options", "value"])
    ]),
    _: 1
  }, 8, ["label", "teleport-selector"]);
}
const rt = /* @__PURE__ */ I(Pi, [["render", Oi]]), ki = {
  name: "SequenceLabels",
  inject: {
    viewerLayout: {
      type: String,
      default: ""
    }
  },
  props: {
    /**
     * The base locale key for the record metadata field component
     **/
    baseLocaleKey: {
      type: String,
      required: !1,
      default: "a-sequence-labels"
    },
    /**
     * Item indexes for current sequence
     */
    currentSequence: {
      type: Array,
      required: !1,
      default: () => []
    },
    /**
     * Current range thumbnails
     */
    thumbnailProps: {
      type: Array,
      required: !1,
      default: () => []
    }
  },
  setup(e) {
    return {
      ...O({
        baseLocaleKey: e == null ? void 0 : e.baseLocaleKey
      })
    };
  },
  computed: {
    /**
     * Current sequence labels
     */
    currentSequenceLabels() {
      let e = [];
      return this.thumbnailProps.length && (e = this.currentSequence.map((t, n) => {
        let i = this.thumbnailProps[t].concatLabel || this.thumbnailProps[t].caption;
        return this.currentSequence.length > 1 && (i = this.translatePart(n ? "label.right" : "label.left", {
          label: i
        })), i;
      })), e;
    }
  }
};
function qi(e, t, n, i, s, a) {
  return u(), m("div", {
    ref: "sequenceLabels",
    class: C(`a-sequence-labels a-sequence-labels--${a.viewerLayout}`)
  }, [
    (u(!0), m(D, null, ne(a.currentSequenceLabels, (r, o) => (u(), m("div", {
      key: `${o}-${a.viewerLayout}`,
      class: "a-sequence-labels__label"
    }, A(r), 1))), 128))
  ], 2);
}
const _i = /* @__PURE__ */ I(ki, [["render", qi]]), Di = {
  name: "PrevNextButtonGroup",
  components: {
    ToolbarButton: ce
  },
  inject: {
    /**
     * whether the viewer is in full-screen mode
     */
    isFullscreen: {
      type: Boolean,
      default: !1
    },
    /**
     * whether this is a sequence or a canvas
     */
    isSequence: {
      type: Boolean,
      default: !1
    },
    /**
     * the viewer layout
     */
    viewerLayout: {
      type: String
    },
    /**
     * The label for the analytics event
     */
    analyticsLabel: {
      type: [String, void 0],
      default: void 0
    },
    /**
     * The Toolbar controller
     */
    toolbarController: {}
  },
  props: {
    /**
     * The current position in the sequence or set of canvases
     */
    slideIndex: {
      type: Number,
      default: 0
    },
    /**
     * the length of the sequence or # of canvases in the index
     */
    numberOfSlides: {
      type: Number,
      default: 0
    }
  },
  computed: {
    /**
     * Whether the user can go backward
     */
    canGoPrevious() {
      return this.slideIndex > 0;
    },
    /**
     * Whether the user can go forward
     */
    canGoNext() {
      return this.numberOfSlides > this.slideIndex;
    }
  }
}, Ni = { class: "a-prev-next-button-group" };
function xi(e, t, n, i, s, a) {
  const r = f("ToolbarButton");
  return u(), m("div", Ni, [
    p(r, {
      name: "arrow-left",
      variation: "arrowleft",
      "icon-name": "ArrowLeft",
      size: 18,
      disabled: !a.canGoPrevious || a.viewerLayout == "gallery",
      onClick: t[0] || (t[0] = (o) => a.toolbarController.previous(a.analyticsLabel))
    }, null, 8, ["disabled"]),
    p(r, {
      name: "arrow-right",
      variation: "arrowright",
      "icon-name": "ArrowRight",
      size: 18,
      disabled: !a.canGoNext || a.viewerLayout == "gallery",
      onClick: t[1] || (t[1] = (o) => a.toolbarController.next(a.analyticsLabel))
    }, null, 8, ["disabled"])
  ]);
}
const Fi = /* @__PURE__ */ I(Di, [["render", xi]]), Bi = {
  name: "ChoiceMenu",
  components: {
    ToolbarMenu: st,
    GuiInput: Je
  },
  inject: {
    /**
     * The Viewer Layout
     */
    viewerLayout: { type: String },
    /**
     * the Toolbar Controller
     */
    toolbarController: {}
  },
  props: {
    /**
     * The base locale key for the record metadata field component
     **/
    baseLocaleKey: {
      type: String,
      required: !1,
      default: "a-choice-menu"
    },
    /**
     * Choices available for the current canvas
     */
    currentChoices: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    /**
     * Teleport selector
     */
    teleportSelector: {
      type: [String, void 0],
      default: void 0
    }
  },
  emits: ["click"],
  setup(e) {
    return {
      ...O({
        baseLocaleKey: e == null ? void 0 : e.baseLocaleKey
      })
    };
  },
  data() {
    return {
      locale: this.$i18n.locale ?? "en",
      /**
       * Alternate views menu button label
       */
      choiceLabel: this.translatePart("default")
    };
  },
  computed: {
    /**
     * Choice tooltip
     * @returns {string} - localized tooltip
     */
    choiceTooltip() {
      let e = `tooltip.${this.viewerLayout == "gallery" ? "feature_not_available" : "no_alternate_views"}`;
      return this.translatePart(e);
    }
  },
  methods: {
    /**
     * GuiInput handler to make choices
     * @param {event} e - GuiInput input event
     */
    handleInput(e) {
      e && this.toolbarController.handleChoice(e);
    },
    /**
     * Get menu mini image
     *
     * @param {string} - choice id image
     * @return {string} - menu thumbnail src url
     */
    getMenuThumbnail(e) {
      return `${e.split("/full")[0]}/full/40,/0/default.jpg`;
    },
    /**
     * Returns props for choice checkbox
     *
     * @param {object} choice - Canvas Panel choice event object
     *
     * @returns {object} GuiInput/FormKit checkbox component props
     */
    getChoiceCheckboxProps(e) {
      let [t, n] = e.items, i = 0;
      for (const a of Object.values(this.currentChoices))
        a.partOf.canvasId == e.partOf.canvasId && (i += 1);
      let s = {
        label: ae(n, this.locale),
        sectionsSchema: {
          suffix: {
            $el: "img",
            attrs: { src: this.getMenuThumbnail(n.id) }
          }
        },
        onValue: { id: n.id, deselect: !1, deselectOthers: !0 },
        offValue: { id: t.id, deselect: !1, deselectOthers: !0 }
      };
      return i > 1 && (s.onValue = {
        id: n.id,
        deselect: !1,
        deselectOthers: !1
      }, s.offValue = {
        id: n.id,
        deselect: !0,
        deselectOthers: !0
      }), s;
    }
  }
};
function Ui(e, t, n, i, s, a) {
  const r = f("GuiInput"), o = f("ToolbarMenu");
  return u(), v(o, {
    class: "a-choice-menu",
    name: "toggleChoice",
    label: s.choiceLabel,
    tooltip: a.choiceTooltip,
    disabled: Object.keys(n.currentChoices).length == 0 || a.viewerLayout == "gallery",
    "icon-name": "AlternateViews",
    "teleport-selector": n.teleportSelector
  }, {
    default: E(() => [
      (u(!0), m(D, null, ne(n.currentChoices, (l, d, y) => (u(), v(r, ue({
        key: y,
        type: "checkbox",
        ref_for: !0
      }, a.getChoiceCheckboxProps(l), { onInput: a.handleInput }), null, 16, ["onInput"]))), 128))
    ]),
    _: 1
  }, 8, ["label", "tooltip", "disabled", "teleport-selector"]);
}
const ot = /* @__PURE__ */ I(Bi, [["render", Ui]]), zi = {
  name: "ImageViewerToolbar",
  components: {
    LayoutMenu: rt,
    ChoiceMenu: ot,
    ImageToolsButtonGroup: Re,
    PrevNextButtonGroup: Fi,
    SequenceLabels: _i
  },
  inject: {
    /**
     * whether the viewer is in full-screen mode
     */
    isFullscreen: {
      type: Boolean,
      default: !1
    },
    /**
     * whether this is a sequence or a canvas
     */
    isSequence: {
      type: Boolean,
      default: !1
    },
    /**
     * the viewer layout
     */
    viewerLayout: {
      type: String
    },
    /**
     * The Toolbar controller
     */
    toolbarController: {}
  },
  props: {
    /**
     * The base locale key for the record metadata field component
     **/
    baseLocaleKey: {
      type: String,
      required: !1,
      default: "m-image-viewer-toolbar"
    },
    /**
     * Whether to use legacy layout and show image tool buttons
     */
    useLegacyLayout: {
      type: Boolean,
      default: !1
    },
    /* Current range thumbnails */
    thumbnailProps: {
      type: Array,
      required: !1,
      default: () => []
    },
    /**
     * Whether to show the choice menu
     */
    showChoiceMenu: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * the current choices for the canvas
     */
    currentChoices: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    /**
     * Item indexes for current sequence
     */
    currentSequence: {
      type: Array,
      required: !1,
      default: () => []
    },
    /**
     * The current position in the sequence or set of canvases
     */
    slideIndex: {
      type: Number,
      default: 0
    },
    /**
     * the length of the sequence or # of canvases in the index
     */
    numberOfSlides: {
      type: Number,
      default: 0
    }
  },
  setup(e) {
    return {
      ...O({
        baseLocaleKey: e == null ? void 0 : e.baseLocaleKey
      })
    };
  }
}, ji = {
  key: 0,
  class: "m-image-viewer-toolbar__wrapper"
};
function Gi(e, t, n, i, s, a) {
  const r = f("SequenceLabels"), o = f("ImageToolsButtonGroup"), l = f("ChoiceMenu"), d = f("LayoutMenu"), y = f("PrevNextButtonGroup");
  return n.useLegacyLayout || a.isFullscreen || a.isSequence ? (u(), m("div", ji, [
    a.isSequence && n.currentSequence.length ? (u(), v(r, {
      key: 0,
      "current-sequence": n.currentSequence,
      "thumbnail-props": n.thumbnailProps
    }, null, 8, ["current-sequence", "thumbnail-props"])) : g("", !0),
    b("div", {
      class: C([
        "m-image-viewer-toolbar",
        { "m-image-viewer--legacy-layout": n.useLegacyLayout }
      ])
    }, [
      n.useLegacyLayout ? (u(), m(D, { key: 0 }, [
        p(o, {
          "show-zoom": !0,
          "is-legacy-layout": !0
        }),
        n.showChoiceMenu ? (u(), v(l, {
          key: 0,
          "current-choices": n.currentChoices
        }, null, 8, ["current-choices"])) : g("", !0),
        a.isSequence ? (u(), v(d, {
          key: 1,
          "current-selection": a.viewerLayout
        }, null, 8, ["current-selection"])) : g("", !0)
      ], 64)) : g("", !0),
      n.numberOfSlides > 1 && a.viewerLayout !== "gallery" && (a.isFullscreen || a.isSequence) ? (u(), v(y, {
        key: 1,
        "slide-index": n.slideIndex,
        "number-of-slides": n.numberOfSlides
      }, null, 8, ["slide-index", "number-of-slides"])) : g("", !0)
    ], 2)
  ])) : g("", !0);
}
const lt = /* @__PURE__ */ I(zi, [["render", Gi]]), Zi = "data:image/png;base64,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", Vi = {
  name: "DownloadMenu",
  components: {
    CopyButton: yn,
    DelimitedFieldValues: gn,
    GuiButton: Ee,
    GuiLink: Xe,
    Icon: le,
    RichText: Ye
  },
  inject: {
    /**
     * DOM element name of clicked toolbar button/menu
     */
    activeMenu: {
      type: String,
      default: "toggle-download-menu"
    },
    /**
     * Whether to render mobile layout
     */
    isMobile: {
      type: Boolean,
      default: !1
    }
  },
  provide() {
    return {
      analyticsListener: (e, t, n) => {
        this.logEvent(t);
      }
    };
  },
  props: {
    baseLocaleKey: {
      type: String,
      default: "a-download-menu"
    },
    /**
     * Array of caption fields to populate delimited field values
     */
    captionFields: {
      type: Array,
      default: () => []
    },
    /**
     * Manifest viewer URL
     */
    manifestUrl: {
      type: String,
      required: !0
    },
    /**
     * Current canvas details
     *  {
     *    width: 512,
     *    height: 768,
     *    serviceUrl: URL,
     *    (optional) sizes: [ {width: 512, height: 768}]
     *  }
     */
    canvasDetails: {
      type: [Object, null],
      required: !0
    },
    /**
     * Additional image data derived from associated visual item
     *    {
     *      altText: 'alt text',
     *      canDownload: false,
     *      copyright: 'copyright statement',
     *      descriptiveNote: 'description',
     *      disableContextMenu: false,
     *      isDisplayable: false,
     *      isZoomable: false,
     *      rightsCopyrightStatementText: 'In Copyright. [Terms Of Use](link)',
     *      rightsIconName: 'Copyright'
     *      rightsStatementId: 'rightsstatement.org url,
     *    }
     */
    imageDetails: {
      type: Object,
      default: () => {
      }
    },
    /**
     * Max dimensions for download derivatives
     */
    defaultDownloadSizes: {
      type: Object,
      default: () => ({
        small: [1024],
        large: [3e3],
        full: []
      })
    },
    /**
     * Manifest viewer base url
     */
    manifestViewerEndpoint: {
      type: String,
      default: "https://tools.getty.edu/iiifviewer/"
    },
    /**
     * Text for publication use
     */
    publicationUseStatement: {
      type: String,
      default: void 0
    },
    /**
     * the image url part for parsing a uuid from an image service
     */
    iiifImageUrlPart: {
      type: String,
      default: void 0
    },
    /**
     * Teleport selector
     */
    teleportSelector: {
      type: [String, void 0],
      default: void 0
    },
    /**
     * Image request event input type
     */
    imageRequestType: {
      type: [String, void 0],
      default: void 0,
      validator: (e) => ["button", "action", void 0].includes(e)
    }
  },
  emits: ["imageRequest", "imageDownload"],
  setup(e) {
    return {
      ...O({
        baseLocaleKey: e == null ? void 0 : e.baseLocaleKey
      })
    };
  },
  data() {
    return {
      /**
       * Component id
       */
      componentId: Te(),
      /**
       * Whether or not the download menu is toggled
       */
      showMenu: !1,
      /**
       * Image download button
       */
      downloadButtonLabel: this.translatePart("download_button_label", []),
      /**
       * Image download heading
       */
      downloadHeading: this.translatePart("download_heading"),
      /**
       * Actions heading
       */
      actionsHeading: this.translatePart("actions_heading"),
      /**
       * Mirador link aria label
       */
      miradorLinkAriaLabel: this.translatePart("aria_mirador_link"),
      /**
       * IIIF manifest link
       */
      iiifManifestLinkText: this.translatePart("iiif_manifest"),
      /**
       * IIIF manifest link aria label
       */
      iiifManifestLinkAriaLabel: this.translatePart("aria_iiif_download"),
      /**
       * permissions heading
       */
      permissionHeading: this.translatePart("permission_heading"),
      /**
       * Permission Statemnt (open content)
       */
      permissionStatementText: this.translatePart("permission_statement_text"),
      /**
       * publication use heading
       */
      publicationUseHeading: this.translatePart("publication_use_heading"),
      /**
       * Restrictions heading
       */
      restrictionsHeading: this.translatePart("restrictions_heading"),
      /**
       * Caption heading
       */
      captionHeading: this.translatePart("caption_heading"),
      /**
       * Tracks when the copy button is clicked
       */
      isCaptionCopied: !1,
      /**
       * Manifest viewer URL for Rights Panel
       */
      manifestViewerUrl: this.manifestViewerEndpoint ? `${this.manifestViewerEndpoint}?manifest=${this.manifestUrl}` : void 0,
      /**
       * menu input name
       */
      name: "toggle-download-menu",
      /**
       * Image request button label
       */
      imageRequestButtonLabel: this.translatePart("image_request_button_label"),
      /**
       * Use restrictions button label
       */
      restrictionsButtonLabel: this.translatePart("restrictions_button_label")
    };
  },
  computed: {
    /**
     * Whether or not the image is part of the open content program
     */
    isOpenContent() {
      var e;
      return ![
        this.canvasDetails,
        this.manifestUrl,
        (e = this.imageDetails) == null ? void 0 : e.canDownload
      ].includes(!1);
    },
    /**
     * Download link label
     */
    downloadLinkLabel() {
      let e = this.downloadButtonLabel;
      return this.isMobile ? e : e + this.defaultSize.dimensions;
    },
    /**
     * Checks for whether sizes are provided in manifest and returns object
     * for formatting display and url settings for download links
     * @returns {object} { size: [width, height]}
     */
    downloadSizes() {
      let e = this.defaultDownloadSizes, t = Object.entries(e).length;
      if (this.canvasDetails.sizes && this.canvasDetails.sizes.length > t && this.canvasDetails.sizes[0].width == this.canvasDetails.width && this.canvasDetails.sizes[0].height == this.canvasDetails.height) {
        let n = Object.entries(e).map((i, s) => {
          let a = this.canvasDetails.sizes[t - s];
          return [i[0], [a.width, a.height]];
        });
        e = Object.fromEntries(n);
      }
      return e;
    },
    /**
     * Array of download link objects
     * @returns {object}
     */
    downloadLinks() {
      let e = {};
      for (let t in this.downloadSizes) {
        const n = this.getDimensions(this.downloadSizes[t]);
        if (n) {
          let i = this.translatePart(
            "dimensions",
            n
          ), s = {
            content: this.translatePart(t) + i,
            size: this.translatePart(t),
            dimensions: i,
            ariaLabel: this.translatePart("aria_download_link", {
              dimensions: i
            }),
            href: Dn(
              this.canvasDetails.serviceUrl,
              n,
              t,
              this.iiifImageUrlPart
            )
          };
          e[t] = s;
        }
      }
      return e;
    },
    /**
     * Default size download link object for the current image
     * @returns {object}
     */
    defaultSize() {
      return Object.keys(this.downloadLinks).length < 3 ? this.downloadLinks.full : this.downloadLinks.large || this.downloadLinks.full;
    },
    /**
     * The permission statement for the image from image details
     * @returns {string}
     */
    permissionStatement() {
      return this.permissionStatementText;
    },
    /**
     * Whether or not to render the "actions" section
     * @returns {boolean}
     */
    showActions() {
      return this.isOpenContent || !this.isOpenContent && this.imageRequestType == "action";
    }
  },
  watch: {
    activeMenu(e) {
      e && e !== this.name && e !== "download-image" ? this.showMenu = !1 : e == "default-image-download" && (this.showMenu = !0);
    }
  },
  mounted() {
    this.isMobile && this.activeMenu == this.name && (this.showMenu = !0);
  },
  methods: {
    /**
     * Caption string formatted for copy button
     * @returns {string} - caption text
     */
    getCaptionText() {
      let e = "";
      return this.$refs.caption && this.$refs.caption.innerText && (e = this.$refs.caption.innerText.replaceAll(`

`, `
`)), e;
    },
    /**
     * Derives the dimensions of a derivative image based on the original
     * canvas dimensions and a supplied maximum dimension
     *
     * @param {array} dimensions - [?width, ?height]
     *
     * @returns {array|undefined} [width, height]
     */
    getDimensions(e) {
      if (e.length !== 2) {
        const t = e[0];
        if (e = [this.canvasDetails.width, this.canvasDetails.height], e.every((n) => n <= t))
          return;
        if (t && e.every((n) => n > t)) {
          const n = +(e[0] > e[1]), i = +(e[0] < e[1]), s = e[n], a = e[i];
          e = [Math.round(s * t / a)], e.splice(i, 0, t);
        }
      }
      return e;
    },
    /**
     * Handle copied text event
     * @param {event} - copied text event
     */
    handleCopiedText() {
      this.isCaptionCopied = !this.isCaptionCopied, setTimeout(() => {
        this.isCaptionCopied = !this.isCaptionCopied;
      }, 600);
    },
    /**
     * Image request button event handler
     *
     * @emits {imageRequest}
     */
    handleImageRequest() {
      this.$emit("imageRequest");
    },
    /**
     * Image download link event handler
     *
     * @emits {imageDownload}
     */
    logEvent(e) {
      if (!e.includes("manifest")) {
        const t = {
          id: e.split("?")[0],
          size: e.split("size=")[1]
        };
        this.$emit("imageDownload", t);
      }
    }
  }
}, Wi = {
  key: 0,
  class: "a-download-menu__inner"
}, Hi = {
  key: 0,
  class: "a-download-menu__inner-section a-download-menu__link-list"
}, Qi = { class: "a-download-menu__heading" }, Yi = {
  ref: "image-download-links",
  "data-testid": "downloads",
  "aria-label": "Image Downloads"
}, Xi = {
  key: 1,
  class: "a-download-menu__inner-section a-download-menu__link-list"
}, Ji = { class: "a-download-menu__heading" }, Ki = {
  ref: "image-action-links",
  "data-testid": "actions",
  "aria-label": "Actions"
}, $i = {
  key: 0,
  class: "a-download-menu__image-request-link"
}, ea = {
  key: 1,
  class: "a-download-menu__iiif-link"
}, ta = ["alt"], na = { class: "a-download-menu__inner-section a-download-menu__permissions" }, ia = { class: "a-download-menu__heading" }, aa = {
  key: 2,
  class: "a-download-menu__inner-section a-download-menu__publication-use"
}, sa = { class: "a-download-menu__heading" }, ra = {
  key: 3,
  class: "a-download-menu__inner-section a-download-menu__caption"
}, oa = { class: "a-download-menu__caption-header" }, la = { class: "a-download-menu__heading" };
function ua(e, t, n, i, s, a) {
  const r = f("GuiLink"), o = f("GuiButton"), l = f("Icon"), d = f("RichText"), y = f("CopyButton"), w = f("DelimitedFieldValues");
  return n.canvasDetails ? (u(), m("div", {
    key: 0,
    class: C([
      "a-download-menu",
      {
        "a-download-menu--active": s.showMenu
      }
    ])
  }, [
    n.canvasDetails && a.isOpenContent ? (u(), m("div", {
      key: 0,
      "data-testid": "defaultLink",
      class: "a-download-menu__default-link",
      onClick: t[0] || (t[0] = (h) => s.showMenu = !s.showMenu)
    }, [
      p(r, {
        href: a.defaultSize.href,
        "aria-label": a.defaultSize.ariaLabel,
        "with-icon": "before",
        "icon-name": "download500",
        "icon-size": 16,
        download: ""
      }, {
        default: E(() => [
          $(A(a.downloadLinkLabel), 1)
        ]),
        _: 1
      }, 8, ["href", "aria-label"]),
      p(o, {
        "data-testid": "toggleDownloadMenu",
        name: "toggle-download-menu",
        modifiers: ["text"]
      }, {
        default: E(() => t[2] || (t[2] = [
          b("span", null, null, -1)
        ])),
        _: 1
      })
    ])) : n.imageRequestType == "button" ? (u(), v(o, {
      key: 1,
      class: "a-download-menu__image-request",
      name: "image-request-button",
      modifiers: ["text", "outline", "image-viewer-toolbar"],
      onClick: a.handleImageRequest
    }, {
      default: E(() => [
        $(A(s.imageRequestButtonLabel), 1)
      ]),
      _: 1
    }, 8, ["onClick"])) : (u(), v(o, {
      key: 2,
      name: "toggle-download-menu",
      "data-testid": "toggleRestrictions",
      modifiers: ["text", "outline", "image-viewer-toolbar"],
      onClick: t[1] || (t[1] = (h) => s.showMenu = !s.showMenu)
    }, {
      default: E(() => [
        $(A(s.restrictionsButtonLabel), 1)
      ]),
      _: 1
    })),
    s.showMenu ? (u(), v(Le, {
      key: 3,
      disabled: !n.teleportSelector,
      to: n.teleportSelector
    }, [
      s.showMenu ? (u(), m("div", Wi, [
        a.isOpenContent ? (u(), m("div", Hi, [
          b("div", Qi, A(s.downloadHeading), 1),
          b("ul", Yi, [
            (u(!0), m(D, null, ne(a.downloadLinks, (h) => (u(), m("li", {
              key: h.size
            }, [
              p(r, {
                href: h.href,
                "aria-label": h.ariaLabel,
                "with-icon": "before",
                "icon-name": "download",
                underline: !0,
                download: ""
              }, {
                default: E(() => [
                  $(A(h.content), 1)
                ]),
                _: 2
              }, 1032, ["href", "aria-label"])
            ]))), 128))
          ], 512)
        ])) : g("", !0),
        a.showActions ? (u(), m("div", Xi, [
          b("div", Ji, A(s.actionsHeading), 1),
          b("ul", Ki, [
            n.imageRequestType == "action" && !a.isOpenContent ? (u(), m("li", $i, [
              p(o, {
                name: "toggle-download-menu",
                modifiers: ["text", "image-viewer-toolbar"],
                onClick: a.handleImageRequest
              }, {
                default: E(() => [
                  b("span", null, A(s.imageRequestButtonLabel), 1),
                  p(l, { name: "outbound" })
                ]),
                _: 1
              }, 8, ["onClick"])
            ])) : g("", !0),
            a.isOpenContent ? (u(), m("li", ea, [
              p(r, {
                href: s.manifestViewerUrl,
                "aria-label": s.iiifManifestLinkAriaLabel,
                rel: "nofollow"
              }, {
                default: E(() => [
                  b("img", {
                    src: Zi,
                    class: "iiif-logo",
                    alt: s.miradorLinkAriaLabel
                  }, null, 8, ta)
                ]),
                _: 1
              }, 8, ["href", "aria-label"]),
              p(r, {
                id: `download${s.componentId}`,
                href: n.manifestUrl,
                "aria-label": s.iiifManifestLinkAriaLabel,
                underline: !0,
                rel: "nofollow"
              }, {
                default: E(() => [
                  b("span", null, A(s.iiifManifestLinkText), 1),
                  p(l, { name: "outbound" })
                ]),
                _: 1
              }, 8, ["id", "href", "aria-label"])
            ])) : g("", !0)
          ], 512)
        ])) : g("", !0),
        b("div", na, [
          b("div", ia, A(s.permissionHeading), 1),
          p(d, {
            "data-testid": "permissions",
            content: a.permissionStatement
          }, null, 8, ["content"])
        ]),
        n.publicationUseStatement ? (u(), m("div", aa, [
          b("div", sa, A(s.publicationUseHeading), 1),
          p(d, {
            "data-testid": "publicationUse",
            content: n.publicationUseStatement
          }, null, 8, ["content"])
        ])) : g("", !0),
        n.captionFields.length && a.isOpenContent ? (u(), m("div", ra, [
          b("div", oa, [
            b("div", la, A(s.captionHeading), 1),
            p(y, {
              "text-key": "caption-header",
              text: a.getCaptionText,
              "icon-size": 32,
              onCopiedText: a.handleCopiedText
            }, null, 8, ["text", "onCopiedText"])
          ]),
          b("div", {
            ref: "caption",
            "data-testId": "caption",
            class: C([
              "a-download-menu__caption-content",
              {
                "a-download-menu__caption-content--disabled": s.isCaptionCopied
              }
            ])
          }, [
            (u(!0), m(D, null, ne(n.captionFields, (h, R) => (u(), v(w, {
              key: R,
              values: h,
              delimiter: ", "
            }, null, 8, ["values"]))), 128))
          ], 2)
        ])) : g("", !0)
      ])) : g("", !0)
    ], 8, ["disabled", "to"])) : g("", !0)
  ], 2)) : g("", !0);
}
const ca = /* @__PURE__ */ I(Vi, [["render", ua]]), da = {
  name: "MenuPanel",
  components: {
    ChoiceMenu: ot,
    DownloadMenu: ca,
    FullscreenButton: at,
    LayoutMenu: rt,
    ToolbarButton: ce
  },
  mixins: [Ke],
  inject: {
    /**
     * The manifest url
     */
    manifestUrl: {
      type: [String, void 0],
      default: void 0
    },
    /**
     * whether this is a sequence or a canvas
     */
    isSequence: {
      type: Boolean,
      default: !1
    },
    /**
     * the viewer layout
     */
    viewerLayout: {
      type: String
    },
    /**
     * DOM element name of clicked toolbar button/menu
     */
    activeMenu: {
      type: [String, void 0],
      default: void 0
    },
    /**
     * whether the viewer is in full-screen mode
     */
    isFullscreen: {
      type: Boolean,
      default: !1
    },
    /**
     * Whether to render mobile layout
     */
    isMobile: {
      type: Boolean,
      default: !1
    },
    /**
     * Whether the fullscreen control is available
     */
    fullScreenAvailable: {
      type: Boolean,
      default: !0
    }
  },
  props: {
    /**
     * The base locale key for the record metadata field component
     **/
    baseLocaleKey: {
      type: String,
      default: "m-menu-panel"
    },
    /**
     * Current canvas details
     *  {
     *    width: 512,
     *    height: 768,
     *    serviceUrl: URL,
     *  }
     */
    canvasDetails: {
      type: [Object, null],
      required: !0
    },
    /**
     * Additional image data derived from associated visual item
     *    {
     *      altText: 'alt text',
     *      canDownload: false,
     *      copyright: 'copyright statement',
     *      descriptiveNote: 'description',
     *      disableContextMenu: false,
     *      isDisplayable: false,
     *      isZoomable: false,
     *      rightsCopyrightStatementText: 'In Copyright. [Terms Of Use](link)',
     *      rightsIconName: 'Copyright'
     *      rightsStatementId: 'rightsstatement.org url,
     *    }
     */
    imageDetails: {
      type: Object,
      default: () => {
      }
    },
    /**
     * Array of caption fields to populate delimited field values
     */
    captionFields: {
      type: Array,
      default: () => []
    },
    /**
     * the image url part for parsing a uuid from an image service
     */
    iiifImageUrlPart: {
      type: String,
      default: void 0
    },
    /**
     * the current choices for the canvas
     */
    currentChoices: {
      type: Object,
      default: () => ({})
    },
    /**
     * Text to use for Download Menu Publication Use Statement
     */
    publicationUseStatement: {
      type: String,
      default: void 0
    },
    /**
     * Whether to enable image request action event
     */
    enableImageRequest: {
      type: Boolean,
      default: !1
    },
    /**
     * Whether to show the image request button
     */
    showImageRequestButton: {
      type: Boolean,
      default: !1
    },
    /**
     * Max dimensions for download derivatives
     */
    defaultDownloadSizes: {
      type: Object,
      default: () => ({
        small: [1024],
        large: [3e3],
        full: []
      })
    },
    /**
     * The modal element ID
     */
    modalId: {
      type: String
    }
  },
  emits: ["imageRequest", "imageDownload", "click"],
  data() {
    return {
      teleportSelector: "m-menu-panel__drawer",
      menuPanelNames: ["toggle-download-menu", "toggleLayout", "toggleChoice"]
    };
  },
  computed: {
    /**
     * Menu panel image request type prop
     * @returns {string|undefined} - ['button','action',undefined]
     */
    imageRequestType() {
      return this.showImageRequestButton ? "button" : this.enableImageRequest ? "action" : void 0;
    }
  },
  mounted() {
    document && document.addEventListener("click", this.handleClick);
  },
  unmounted() {
    document && document.removeEventListener("click", this.handleClick);
  },
  methods: {
    /**
     * Closes the modal and resets active menu name
     * @emits click
     */
    handleModalClose(e) {
      this.closePanels(), this.triggerModalClose(this.modalId, e);
    },
    /**
     * Handler for clicking outside menu panel and resetting active menu
     * @param {event} click
     */
    handleClick(e) {
      this.activeMenu && !this.$el.contains(e.target) && !this.menuPanelNames.includes(e.target.name) && this.closePanels();
    },
    /**
     * Emit a click event to reset active menu
     * @emits click
     */
    closePanels() {
      this.$emit("click", {
        target: { tagName: "BUTTON", name: void 0 }
      });
    }
  }
}, ha = { class: "m-menu-panel__drawer-wrapper" };
function fa(e, t, n, i, s, a) {
  var w;
  const r = f("DownloadMenu"), o = f("ChoiceMenu"), l = f("LayoutMenu"), d = f("FullscreenButton"), y = f("ToolbarButton");
  return u(), m("div", {
    class: C([
      "m-menu-panel",
      { "m-menu-panel--active": a.activeMenu && !a.imageRequestType == "button" }
    ]),
    onClick: t[2] || (t[2] = (h) => e.$emit("click", h))
  }, [
    a.isFullscreen ? g("", !0) : (u(), v(r, {
      key: 0,
      class: C([
        "a-toolbar-menu",
        {
          "a-toolbar-menu--request": ((w = n.imageDetails) == null ? void 0 : w.canDownload) == !1 && a.imageRequestType == "button"
        }
      ]),
      "canvas-details": n.canvasDetails,
      "image-details": n.imageDetails,
      "caption-fields": n.captionFields,
      "manifest-url": a.manifestUrl,
      "iiif-image-url-part": n.iiifImageUrlPart,
      "publication-use-statement": n.publicationUseStatement,
      "show-image-request-button": n.showImageRequestButton,
      "default-download-sizes": n.defaultDownloadSizes,
      "image-request-type": a.imageRequestType,
      "teleport-selector": s.teleportSelector ? `.${s.teleportSelector}` : void 0,
      onImageRequest: t[0] || (t[0] = (h) => e.$emit("imageRequest", h)),
      onImageDownload: t[1] || (t[1] = (h) => e.$emit("imageDownload", h))
    }, null, 8, ["class", "canvas-details", "image-details", "caption-fields", "manifest-url", "iiif-image-url-part", "publication-use-statement", "show-image-request-button", "default-download-sizes", "image-request-type", "teleport-selector"])),
    Object.keys(n.currentChoices).length ? (u(), v(o, {
      key: 1,
      "current-choices": n.currentChoices,
      "teleport-selector": s.teleportSelector ? `.${s.teleportSelector}` : void 0
    }, null, 8, ["current-choices", "teleport-selector"])) : g("", !0),
    a.isSequence ? (u(), v(l, {
      key: 2,
      "current-selection": a.viewerLayout,
      "teleport-selector": s.teleportSelector ? `.${s.teleportSelector}` : void 0
    }, null, 8, ["current-selection", "teleport-selector"])) : g("", !0),
    a.isMobile && !a.isFullscreen && a.fullScreenAvailable ? (u(), v(d, {
      key: 3,
      class: C({
        "a-fullscreen-button--menu-panel__active": a.activeMenu && a.isMobile
      }),
      modifiers: ["menu-panel"]
    }, null, 8, ["class"])) : g("", !0),
    b("div", ha, [
      a.isMobile && s.menuPanelNames.includes(a.activeMenu) ? (u(), v(y, {
        key: 0,
        class: "m-menu-panel__modal-close",
        variation: "closemodal",
        name: "close-modal",
        "icon-name": "close",
        onClick: a.handleModalClose
      }, null, 8, ["onClick"])) : g("", !0),
      b("div", {
        class: C(s.teleportSelector)
      }, null, 2)
    ])
  ], 2);
}
const ma = /* @__PURE__ */ I(da, [["render", fa]]), ut = (e) => {
  const t = pn(), n = De({}), i = De({});
  function s(r) {
    n.value[r.action] = n.value[r.action] ? n.value[r.action] + 1 : 1, a(r), i.value[r.action] = i.value[r.action] ? i.value[r.action] + 1 : 1;
  }
  function a(r) {
    t.emit("ImageViewerInteractionEvent", {
      ...r,
      category: "ImageViewer Interaction",
      noninteraction: !0
    });
  }
  return {
    registerEvent: (r) => s(r),
    emittedEvents: i
  };
};
class ct {
  /**
   * The Toolbar Controller
   *
   * @param {object} wrapper - the wrapper element
   * @param {object} analyticsBus - the analytics bus
   */
  constructor(t, n) {
    this.wrapper = t, this.el = () => {
      var i, s, a;
      return ((s = (i = t.$refs) == null ? void 0 : i.panel) == null ? void 0 : s.$el) ?? ((a = t.$refs) == null ? void 0 : a.panel);
    }, this.analyticsBus = n, this.isSequence = t.isSequence;
  }
  /**
   * Processes the Zoom In function
   *
   * @param {string} label - the label
   */
  zoomIn(t) {
    this.el().zoomIn(), this.handleAnalyticsEvent("zoom", t);
  }
  /**
   * Processes the Zoom Out function
   *
   * @param {string} label - the label
   */
  zoomOut(t) {
    this.el().zoomOut(), this.handleAnalyticsEvent("zoom", t);
  }
  /**
   * Processes the Rotate function
   *
   * @param {string} label - the label
   */
  rotate(t) {
    this.wrapper.handleRotate(), this.handleAnalyticsEvent("rotate", t);
  }
  /**
   * Processes the FullScreen change function
   *
   * @param {string} label - the label
   */
  fullScreenChange(t) {
    this.wrapper.handleFullscreenChange(), this.handleAnalyticsEvent("full-screen", t);
  }
  /**
   * Processes the previous function
   *
   * @param {string} label - the label
   */
  previous(t) {
    this.isSequence ? this.el().sequence.previousCanvas() : this.wrapper.slideIndex--, this.handleAnalyticsEvent("previous-canvas", t);
  }
  /**
   * Processes the next function
   *
   * @param {string} label - the label
   */
  next(t) {
    this.isSequence ? this.el().sequence.nextCanvas() : this.wrapper.slideIndex++, this.handleAnalyticsEvent("next-canvas", t);
  }
  /**
   * Processes the Choice event
   *
   * @param {event} e - the choice event
   */
  handleChoice(t) {
    this.el().makeChoice(t.id, {
      deselect: t.deselect,
      deselectOthers: t.deselectOthers
    }), this.el().setAttribute("current-choice", t.id), this.handleAnalyticsEvent("choice", t.id);
  }
  /**
   * Handles layout change event
   * @param {event} - viewer layout
   */
  handleLayoutChange(t, n) {
    this.wrapper.setViewerLayout(t), this.handleAnalyticsEvent("layoutChange", n);
  }
  /**
   * Processes the Analytics Event
   *
   * @param {string} type - the type
   * @param {string} label - the label
   */
  handleAnalyticsEvent(t, n) {
    this.analyticsBus.registerEvent({ action: t, label: n });
  }
  /**
   * Handles gallery thumbnail click event
   * @param {event} - click event
   */
  handleGalleryThumbnailClick(t) {
    var n;
    this.wrapper.handleThumbnailClick(t), this.handleAnalyticsEvent("gallery", (n = t.target.dataset) == null ? void 0 : n.canvasId);
  }
}
const ga = "#000000", ya = ["toggle-download-menu", "toggleLayout", "toggleChoice"], pa = {
  name: "ImageViewer",
  components: {
    CanvasViewer: Un,
    SequenceViewer: Vn,
    ImageToolsButtonGroup: Re,
    ImageViewerRightsPanel: bi,
    ImageViewerThumbnailCarousel: Mi,
    ImageViewerToolbar: lt,
    MenuPanel: ma,
    Modal: bn,
    ToolbarGallery: ri
  },
  mixins: [vn, Ke],
  provide() {
    const e = document.fullscreenEnabled || document.mozFullScreenEnabled || document.documentElement.webkitRequestFullScreen;
    return {
      manifestUrl: this.manifestUrl,
      fullscreenAvailable: e,
      showMenuPanel: this.showMenuPanel,
      // explicitly provide a computed property
      activeMenu: P(() => this.activeMenu),
      analyticsLabel: P(() => this.analyticsLabel),
      canZoomIn: P(() => this.canZoomIn),
      canZoomOut: P(() => this.canZoomOut),
      isMobile: P(() => this.isMobile),
      isFullscreen: P(() => this.isFullscreen),
      isSequence: P(() => this.isSequence),
      viewerLayout: P(() => this.viewerLayout),
      toolbarController: P(() => this.toolbarController)
    };
  },
  props: {
    baseLocaleKey: {
      type: String,
      required: !1,
      default: "o-image-viewer"
    },
    /**
     * The manifest url
     */
    manifestUrl: {
      type: String,
      required: !0
    },
    /**
     * Encoded IIIF content state to set on the panel
     */
    contentState: {
      type: String,
      default: void 0
    },
    /**
     * Option for parent to provide canvas id to display
     */
    canvasId: {
      type: String,
      default: void 0
    },
    /**
     * Range id
     */
    rangeId: {
      type: String,
      default: void 0
    },
    /**
     * Which component to render
     */
    componentType: {
      type: String,
      default: "canvas",
      validator(e) {
        if (e)
          return ["canvas", "sequence", "range"].includes(e);
      }
    },
    /**
     * Boolean for whether toolbar should be displayed and zoom enabled (canvas panel only)
     */
    isZoomable: {
      type: Boolean,
      required: !1,
      default: !0
    },
    /**
     * Whether to render the viewer toolbars
     */
    showToolbar: {
      type: Boolean,
      required: !1,
      default: !0
    },
    /**
     * Whether to use static canvases (true) or the image service thumbnail property (false) for thumbnails
     */
    useCanvasThumbnails: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * CSS custom property color value to set for both panel and Atlas
     */
    backgroundColor: {
      type: String,
      required: !1,
      default: "#73706e"
    },
    /**
     * Valid CSS height value for parent container
     */
    height: {
      type: [String, void 0],
      default: void 0
    },
    /**
     * Whether to show the choice menu
     */
    showChoiceMenu: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * CSS modifiers
     */
    modifiers: {
      type: Array,
      required: !1,
      default: () => []
    },
    /**
     * The available options for the layout menu
     */
    layoutMenuOptions: {
      type: Array,
      required: !1,
      default: () => ["individuals", "paged", "gallery"]
    },
    /**
     * A custom transformation function to enable Bayard
     *
     * @returns {Object}
     *  { type: 'ImageResponsive' | 'StaticCanvas' ... }
     */
    thumbnailRequestTransformer: {
      type: [Function, void 0],
      required: !1,
      default: void 0
    },
    /**
     * Whether to enable the thumbnail carousel
     */
    showThumbnails: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * Valid selector of DOM element in parent component
     * (will enable Vue Teleport of provided)
     */
    teleportSelector: {
      type: String,
      default: void 0
    },
    /**
     * Object for providing optional additional data to image derived from visual item (also accepts canvas uuid)
     * { 	"https://media.getty.edu/iiif/image/b3c4fb26-04de-4ac8-9df7-f020f4f97a51":
     *    {
     *      altText: 'alt text',
     *      canDownload: false,
     *      copyright: 'copyright statement',
     *      descriptiveNote: 'description',
     *      disableContextMenu: false,
     *      isDisplayable: false,
     *      isZoomable: false,
     *      rightsCopyrightStatementText: 'In Copyright. [Terms Of Use](link)',
     *      rightsIconName: 'Copyright'
     *      rightsStatementId: 'rightsstatement.org url,
     *    }
     * }
     */
    imageMetadata: {
      type: Object,
      default: () => ({})
    },
    /**
     * A delimiting string for parsing uuids from non-Getty IIIF image services
     */
    iiifImageUrlPart: {
      type: String,
      default: void 0
    },
    /**
     * Label behavior for thumbnails, uses thumbnail label by default with options
     * to use the range label or concatenate both
     */
    labelSource: {
      type: String,
      default: "default",
      validator: (e) => ["default", "range", "all"].includes(e)
    },
    /**
     * Whether or not to enable the rotate button in the toolbar for canvas viewer
     */
    showRotate: {
      type: Boolean,
      default: !1
    },
    /**
     * Whether or not to render the menu panel plus display rights statement
     */
    showMenuPanel: {
      type: Boolean,
      default: !1
    },
    /**
     * Array of caption fields to populate delimited field values
     *
     * ['value', ['value','value'], { name: 'value', cssClasses: ['css-class'] }]
     */
    captionFields: {
      type: Array,
      default: () => []
    },
    /**
     * Show image request button
     */
    enableImageRequest: {
      type: Boolean,
      default: !1
    },
    /**
     * Return thumbnails only for canvases with associated visual items (canvas panel only)
     */
    filterVisualItems: {
      type: Boolean,
      default: !1
    },
    /**
     * Text to use for Download Menu Publication Use Statement
     */
    publicationUseStatement: {
      type: String,
      default: void 0
    },
    /**
     * Whether to enable legacy bottom toolbar panel
     */
    useLegacyLayout: {
      type: Boolean,
      default: !1
    },
    /**
     * Max dimensions for download derivatives
     */
    defaultDownloadSizes: {
      type: Object,
      default: () => ({
        small: [1024],
        large: [3e3],
        full: []
      })
    },
    /**
     * Whether to use canvas panel's internal skip sizes logic
     */
    skipSizes: {
      type: Boolean,
      default: !1
    },
    /**
     * The event input type for the image request
     */
    imageRequestType: {
      type: [String, void 0],
      default: void 0,
      validator: (e) => ["action", "button", void 0].includes(e)
    },
    /**
     * Whether to set sequence viewer zoom controls per image (true) or per sequence (false)
     */
    sequenceZoomPerImage: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "thumbnailsReady",
    "canvasChange",
    "contentStateChange",
    "imageDownload",
    "imageRequest"
  ],
  setup(e) {
    return {
      ...O({
        baseLocaleKey: e == null ? void 0 : e.baseLocaleKey
      })
    };
  },
  data() {
    return {
      analyticsHandler: ut(),
      toolbarController: void 0,
      locale: this.$i18n.locale ?? "en",
      /**
       * Component id
       */
      componentId: Te(),
      /**
       * Object of canvas id mapped to thumbnail content resources or canvases
       */
      thumbnails: {},
      /**
       * Timeout id for the reset
       */
      timeoutId: void 0,
      /**
       * the setinterval id for the content state watcher
       */
      contentStateIntervalId: void 0,
      /**
       * current content state
       */
      currentContentState: this.contentState,
      /**
       * the layout type of the viewer
       */
      viewerLayout: void 0,
      /**
       * Whether the user can zoom in or not
       */
      canZoomIn: this.isZoomable,
      /**
       * whether the user can zoom out or not
       */
      canZoomOut: !1,
      /**
       *  Whether currently in fullscreen or not
       */
      isFullscreen: !1,
      /**
       * Start canvas for when transitioning to fullscreen (sequence panel only)
       */
      startCanvas: this.canvasId,
      /**
       * Disables keyboard when we have an active menu - allows
       * for navigating the menu with the keyboard
       */
      disableKeyboard: !1,
      /**
       * Default thumbnail height
       */
      canvasHeight: 250,
      /**
       * internal boolean for whether current canvas is zoomable (canvas panel only),
       *
       * this should be set by `handleCanvasChange` when the canvas is loaded and assigned
       */
      isVisualItemZoomable: !1,
      /**
       * Local copy of the parent canvas id
       */
      canvasId_: this.canvasId,
      /**
       * Degrees of rotation to apply to the canvas (canvas panel only)
       */
      rotation: 0,
      /**
       * Download panel canvas details object
       *  {
       *    width: 512,
       *    height: 768,
       *    serviceUrl: URL,
       *  }
       */
      canvasDetails: null,
      /**
       * ImageMetadata entry for visual item associated with current canvas
       */
      imageDetails: void 0,
      /**
       * DOM element name of clicked toolbar button/menu
       */
      activeMenu: void 0,
      // Toolbar data props //
      /**
       * Choice menu options for the current canvas
       * @returns {object}
       */
      currentChoices: {},
      /**
       * Item indexes for the current sequence (sequence panel)
       * @returns {array}
       */
      currentSequence: [],
      /**
       * Total number of canvases (canvas panel) or sequences (sequence panel)
       * @returns {number}
       */
      numberOfSlides: 0,
      /**
       * Index of canvas (canvas panel) or index of carousel slide group (sequence panel)
       * @returns {number|undefined}
       */
      slideIndex: void 0,
      /**
       * Whether to render menu panel in a modal or div
       */
      showModal: !1,
      /**
       * Whether to show the mobile layout
       */
      isMobile: !1,
      /**
       * whether canvas panel has been initialized or not
       */
      initialized: !1
    };
  },
  computed: {
    /**
     * whether to show the toolbar once initialized
     *
     * @returns {boolean}
     */
    showInitializedToolbar() {
      return !(this.initialized == !1 || this.showToolbar == !1);
    },
    /**
     * Returns component name based on type
     *
     * @returns {string}
     */
    componentName() {
      let e = this.componentType == "range" ? "sequence" : this.componentType;
      return `${e[0].toUpperCase()}${e.slice(
        1
      )}Viewer`;
    },
    /**
     * Whether current component is a sequence
     * @returns {boolean}
     */
    isSequence() {
      return this.componentName == "SequenceViewer";
    },
    /**
     * Current background color for both wrapper and Atlas
     *
     * @returns {String} - valid css custom property color value
     */
    panelBackgroundColor() {
      return this.isFullscreen ? ga : this.backgroundColor;
    },
    /**
     * Classes to apply to parent element
     * @returns {Array} css classes
     */
    classes() {
      let e = [this.baseLocaleKey];
      return this.modifiers.forEach((t) => {
        e.push(`${e[0]}--${t}`);
      }), this.height && e.push(`${e[0]}--fixed-height`), this.activeMenu && e.push(`${e[0]}--menu-panel-active`), this.showRightsStatement && e.push(`${e[0]}--with-rights-statement`), e;
    },
    /**
     * Class to apply to toolbar
     */
    toolbarClass() {
      return this.modifiers.includes("light") && this.isFullscreen == !1 ? "g-toolbar-buttons--light" : "g-toolbar-buttons";
    },
    /**
     * Inline styles to apply to container DOM element
     */
    containerInlineStyle() {
      let e = `--background-color: ${this.panelBackgroundColor};`;
      return this.height && (e += e + ` height: ${this.height}`), e;
    },
    /**
     * ImageResponsive or StaticCanvas prop objects based on thumbnails
     * @returns {Array} array of prop objects
     */
    thumbnailProps() {
      let e = Object.entries(this.thumbnails);
      return this.componentType == "canvas" && (e = e.filter(
        ([t, n]) => this.isDisplayable(t, n)
      )), e = e.map((t) => {
        let n = t[1];
        if (typeof this.thumbnailRequestTransformer == "function")
          return this.thumbnailRequestTransformer(n);
        if (n.type == "Canvas")
          return {
            type: "StaticCanvas",
            canvasId: n.id,
            canvasHeight: this.canvasHeight,
            preset: "static",
            ...this.getCaptionAndAlt(t)
          };
        if (n.type == "Image")
          return {
            type: "ImageResponsive",
            id: $e(n.id, this.iiifImageUrlPart),
            canvasId: n.canvasId,
            size: "post_xsmall_variable_height_jpca_restricted",
            ...this.getCaptionAndAlt(t)
          };
      }), e;
    },
    /**
     * The label for the analytics event
     */
    analyticsLabel() {
      var e;
      return this.isSequence ? this.manifestUrl : (e = this.canvasDetails) == null ? void 0 : e.serviceUrl;
    },
    /**
     * Whether to show the thumbnail carousel
     */
    showCarousel() {
      return !this.isFullscreen && this.componentType == "canvas" && this.showThumbnails && this.thumbnailProps.length > 1;
    },
    /**
     * Whether to display the rights statement below canvas panel
     * @returns {boolean}
     */
    showRightsStatement() {
      return this.imageDetails !== void 0 && this.showMenuPanel && !this.isFullscreen;
    }
  },
  watch: {
    contentState() {
      this.setContentState(this.contentState);
    },
    /**
     * Allow parent to update canvas id
     */
    canvasId() {
      this.canvasId_ = this.canvasId;
    },
    /**
     * Enter/exit fullscreen based on prop
     */
    isFullscreen(e) {
      e == !0 && (this.$el.requestFullscreen || this.$el.webkitRequestFullscreen).call(
        this.$el
      ), document.fullscreenElement && e == !1 && document.exitFullscreen();
    },
    /**
     * For canvas viewer and manifest with multiple canvases, set canvas id
     * and numberOfSlides for use in previous/next buttons in fullscreen
     */
    slideIndex() {
      !this.isSequence && this.thumbnailProps.length && (this.numberOfSlides !== this.thumbnailProps.length && (this.numberOfSlides = this.thumbnailProps.length), this.canvasId_ = this.thumbnailProps[this.slideIndex] ? this.thumbnailProps[this.slideIndex].canvasId : this.canvasId_);
    }
  },
  mounted() {
    this.handleResize(), typeof window < "u" && window.addEventListener("resize", this.handleResize, { passive: !0 }), this.toolbarController = new ct(this, this.analyticsHandler), this.watchContentState(), this.currentContentState = this.contentState, this.useLegacyLayout == !0 && console.warn(
      "[@thegetty/image-viewer] Warning: legacy layout mode will be deprecated in a future version"
    ), this.isSequence && !this.sequenceZoomPerImage && this.setSequenceZoom();
  },
  unmounted() {
    clearInterval(this.contentStateIntervalId), clearTimeout(this.timeoutId), typeof window < "u" && window.removeEventListener("resize", this.handleResize, {
      passive: !0
    });
  },
  methods: {
    /**
     * Set current canvas index based on thumbnail click
     */
    handleThumbnailClick(e) {
      var t;
      ((t = e == null ? void 0 : e.target) == null ? void 0 : t.tagName) == "BUTTON" && (this.canvasId_ = e.target.dataset.canvasId), e != null && e.target.classList.contains("a-toolbar-gallery__thumbnail") && (this.viewerLayout = "individuals");
    },
    /**
     * Sets the Viewer layout
     *
     * @param {string} layout
     */
    setViewerLayout(e) {
      this.viewerLayout = e;
    },
    /**
     * Handle Ready event
     * @param {event} e - the ready event
     */
    handleReady(e) {
      var t, n;
      (n = (t = e == null ? void 0 : e.target) == null ? void 0 : t.children) != null && n.namedItem("error-fallback") || (this.initialized = !0), this.canZoomIn = this.isZoomable, this.canZoomOut = !1;
    },
    /**
     * Handle World Ready event
     */
    handleWorldReady() {
      this.canZoomIn = this.isZoomable, this.canZoomOut = !1, this.currentContentState == this.contentState && this.setContentState(this.contentState);
    },
    /**
     * Handle the zoom event
     * @param {event} e - the zoom event
     *
     * sets the 'can zoom in' and 'can-zoom out' logic
     */
    handleZoom(e) {
      this.canZoomIn = e.detail.canZoomIn, this.canZoomOut = e.detail.canZoomOut;
    },
    /**
     * Handle fullscreenchange event and sets isFullscreen
     *
     * @param {event} e - fullscreenchange event
     */
    handleFullscreenChange(e) {
      var t;
      (t = e == null ? void 0 : e.target) != null && t.classList && e.target.classList.contains("o-image-viewer") ? this.isFullscreen && document.fullscreenElement == null && (this.isFullscreen = !1) : this.isFullscreen = !this.isFullscreen;
    },
    /**
     * Handle canvas change event (canvas panel only)
     * @param {event} e - canvas change event
     * @emits ImageViewer#canvasChange
     */
    handleCanvasChange(e) {
      var n, i, s;
      const t = this.imageMetadata[(n = e.detail) == null ? void 0 : n.image] || this.imageMetadata[(i = e.detail) == null ? void 0 : i.canvas];
      if (this.canvasId_ == null && (this.canvasId_ = e.detail.canvas), (s = e.detail) != null && s.canvasDetails && (this.canvasDetails = e.detail.canvasDetails), t && (this.imageDetails = t), (t == null ? void 0 : t.isZoomable) !== void 0 ? this.isVisualItemZoomable = t.isZoomable : this.isVisualItemZoomable != this.isZoomable && (this.isVisualItemZoomable = this.isZoomable), !this.isSequence) {
        let a = this.thumbnailProps.findIndex(
          (r) => r.canvasId == this.canvasId_
        );
        a > -1 && (this.slideIndex = a);
      }
      this.$emit("canvasChange", e);
    },
    /**
     * handles the sequence change event setting zoom level per canvas
     *
     * @param {object} e - sequence change event [canvases]
     *
     */
    handleSequenceChange(e) {
      if (!this.sequenceZoomPerImage)
        return;
      const t = e.map((n) => this.imageMetadata[n == null ? void 0 : n.id]).filter((n) => n);
      this.isVisualItemZoomable = !t.some(
        (n) => (n == null ? void 0 : n.isZoomable) === !1
      ), t.length == 0 && (this.isVisualItemZoomable = !0);
    },
    /**
     * Sets isZoomable for the sequence viewer by evaluating all available visual items
     */
    setSequenceZoom() {
      const e = Object.keys(this.imageMetadata).map(
        (t) => this.imageMetadata[t]
      );
      if (e.length == 0) {
        this.isVisualItemZoomable = !0;
        return;
      }
      this.isVisualItemZoomable = !e.some(
        (t) => (t == null ? void 0 : t.isZoomable) === !1
      );
    },
    /**
     * Sets the start canvas to the current sequence canvas id
     * to keep state when entering/exiting fullscreen - sequence panel specific
     */
    setStartCanvas() {
      var t, n;
      let e = (n = (t = this.$refs) == null ? void 0 : t.panel) == null ? void 0 : n.$el;
      if (e && this.componentType != "canvas") {
        let i = e.sequence.currentSequenceIndex, s = e.sequence.sequence[i][0], a = e.sequence.items[s].id;
        this.startCanvas = a;
      }
    },
    /**
     * Listen for interaction events
     *
     * @param {el} element - the dom element to bind the event to
     */
    /**
     * sets the content state on canvas panel
     *
     * @param {contentState} contentState - the string representation of the content state
     */
    setContentState(e) {
      var t, n;
      this.currentContentState = e, (n = (t = this.$refs) == null ? void 0 : t.panel) == null || n.$el.setContentStateFromText(e);
    },
    /**
     * Watches the contentState and emits the content state on a regular interval, sets the current contentState as it changes
     *
     * @emits {contentStateChange} contentStateChange
     *
     */
    watchContentState() {
      this.contentStateIntervalId = setInterval(() => {
        var t, n, i, s, a, r;
        if (((i = (n = (t = this.$refs) == null ? void 0 : t.panel) == null ? void 0 : n.$el) == null ? void 0 : i.getContentState) == null)
          return;
        const e = (a = (s = this.$refs) == null ? void 0 : s.panel) == null ? void 0 : a.$el.getContentState();
        ((r = this.currentContentState) == null ? void 0 : r.encodedContentState) != (e == null ? void 0 : e.encodedContentState) && (this.currentContentState = e, this.$emit("contentStateChange", e));
      }, 1e3);
    },
    /**
     * Boolean whether or not the canvas should be displayed based on
     * image metadata isDisplayable
     *
     * @param {string} - resource id
     *
     * @returns {boolean}
     */
    isDisplayable(e, t) {
      let n = this.imageMetadata[e] || this.imageMetadata[e.replace("v3.0", "v2.0")] || this.imageMetadata[t.canvasId], i = (n == null ? void 0 : n.isDisplayable) ?? !0;
      if (this.filterVisualItems) {
        let s = n ? i : !1;
        return s || console.warn(`no matching visual item found for ${e}`), s;
      } else
        return i;
    },
    /**
     * Returns the caption and alt text props from a canvas id and thumbnail object
     * based on object and additional canvas data from visual item
     *
     * @param {array} - [uuid, thumbnail or canvas object]
     *
     * @returns {object} - caption and alt text entries if available
     */
    getCaptionAndAlt(e) {
      let [t, n] = e, i = ae(n, this.locale), s = "", a;
      n.concatLabel && (a = ae(
        n,
        this.locale,
        this.translate(this.baseLocaleKey + ".label_delimiter"),
        "concatLabel"
      ));
      const r = this.imageMetadata[t] || this.imageMetadata[n.canvasId];
      r && (s = (r == null ? void 0 : r.altText) ?? s, i = (r == null ? void 0 : r.descriptiveNote) ?? i, s = s == i ? "" : s);
      let o = { caption: i, alt: s };
      return n.concatLabel && (o.concatLabel = a), o;
    },
    /**
     * On rotate event, increments rotation
     */
    handleRotate() {
      this.rotation = this.rotation + 90 === 360 ? 0 : this.rotation + 90;
    },
    /**
     * On menu panel button click, set the name of the active menu and handle
     * menu modal state in mobile
     */
    async handleMenuClick(e) {
      e.target.tagName == "BUTTON" && (this.activeMenu = this.activeMenu == e.target.name ? void 0 : e.target.name, this.isMobile && ya.includes(e.target.name) && (this.showModal || (this.showModal = !this.showModal), await this.$nextTick(), this.showModal ? this.triggerModalOpen(`menu-panel-modal${this.componentId}`, e) : this.triggerModalClose(`menu-panel-modal${this.componentId}`, e)));
    },
    /**
     * Toggle modal
     *
     * @param {event} - afterOpen or afterClose Getty UI event
     */
    handleModalState() {
      this.showModal && this.activeMenu == null && (this.showModal = !1);
    },
    /**
     * On resize callback for setting isMobile
     */
    handleResize() {
      this.isMobile = this.isSmallMinus(), this.isMobile && this.activeMenu && (this.activeMenu = void 0);
    }
  }
}, va = {
  key: 0,
  class: "o-image-viewer__vertical-toolbar g-vertical-toolbar"
};
function ba(e, t, n, i, s, a) {
  const r = f("ToolbarGallery"), o = f("ImageToolsButtonGroup"), l = f("ImageViewerToolbar"), d = f("ImageViewerRightsPanel"), y = f("ImageViewerThumbnailCarousel"), w = f("MenuPanel");
  return u(), m("div", {
    class: C(a.classes),
    style: et(a.containerInlineStyle),
    onFullscreenchange: t[8] || (t[8] = (...h) => a.handleFullscreenChange && a.handleFullscreenChange(...h))
  }, [
    a.isSequence && s.viewerLayout == "gallery" ? (u(), v(r, {
      key: 0,
      "thumbnail-props": a.thumbnailProps,
      "use-canvas-thumbnails": n.useCanvasThumbnails,
      onClick: a.handleThumbnailClick
    }, null, 8, ["thumbnail-props", "use-canvas-thumbnails", "onClick"])) : g("", !0),
    (u(), v(ge(a.componentName), ue({
      ref: "panel",
      "data-testid": "panel",
      class: "o-image-viewer__panel",
      "skip-sizes": n.skipSizes,
      responsive: "true",
      "use-floor-calc": "true"
    }, e.$props, {
      background: a.panelBackgroundColor,
      "viewer-layout": s.viewerLayout,
      "is-fullscreen": s.isFullscreen,
      "active-layout-options": n.layoutMenuOptions,
      "start-canvas": s.startCanvas,
      "disable-keyboard-navigation": s.disableKeyboard,
      "canvas-id": s.canvasId_,
      "is-zoomable": s.isVisualItemZoomable,
      "label-source": n.labelSource,
      "ignore-single-finger-touch": "true",
      "enable-pan-on-wait": "false",
      "pan-on-wait-delay": "40",
      "require-meta-key-for-wheel-zoom": "true",
      rotation: s.rotation,
      onCanvasChange: a.handleCanvasChange,
      onSequenceChange: a.handleSequenceChange,
      onFullscreenchange: a.handleFullscreenChange,
      onReady: a.handleReady,
      onCpLoadError: t[0] || (t[0] = (h) => s.initialized = !1),
      onThumbnailsReady: t[1] || (t[1] = (h) => s.thumbnails = h),
      onWorldReady: a.handleWorldReady,
      onZoom: a.handleZoom,
      onNumberOfSlidesOnce: t[2] || (t[2] = (h) => s.numberOfSlides = h),
      onSlideIndex: t[3] || (t[3] = (h) => s.slideIndex = h),
      onCurrentChoices: t[4] || (t[4] = (h) => s.currentChoices = h),
      onCurrentSequence: t[5] || (t[5] = (h) => s.currentSequence = h)
    }), null, 16, ["skip-sizes", "background", "viewer-layout", "is-fullscreen", "active-layout-options", "start-canvas", "disable-keyboard-navigation", "canvas-id", "is-zoomable", "label-source", "rotation", "onCanvasChange", "onSequenceChange", "onFullscreenchange", "onReady", "onWorldReady", "onZoom"])),
    p(tt, { name: "g-vertical-toolbar__fade" }, {
      default: E(() => [
        a.showInitializedToolbar ? (u(), m("div", va, [
          p(o, {
            class: C(a.toolbarClass),
            "hide-image-tools": n.useLegacyLayout,
            "show-rotate": n.showRotate,
            "show-zoom": s.isVisualItemZoomable
          }, null, 8, ["class", "hide-image-tools", "show-rotate", "show-zoom"])
        ])) : g("", !0)
      ]),
      _: 1
    }),
    a.showInitializedToolbar ? (u(), v(l, {
      key: 1,
      class: C(a.toolbarClass),
      "current-choices": s.currentChoices,
      "current-sequence": s.currentSequence,
      "thumbnail-props": a.thumbnailProps,
      "number-of-slides": s.numberOfSlides,
      "slide-index": s.slideIndex,
      "show-choice-menu": n.showChoiceMenu,
      "show-rotate": n.showRotate,
      "canvas-details": s.canvasDetails,
      "use-legacy-layout": n.useLegacyLayout
    }, null, 8, ["class", "current-choices", "current-sequence", "thumbnail-props", "number-of-slides", "slide-index", "show-choice-menu", "show-rotate", "canvas-details", "use-legacy-layout"])) : g("", !0),
    a.showRightsStatement ? (u(), v(d, {
      key: 2,
      "data-testid": "rightsStatement",
      "image-details": s.imageDetails
    }, null, 8, ["image-details"])) : g("", !0),
    a.showCarousel ? (u(), v(Le, {
      key: 3,
      disabled: !n.showThumbnails || !n.teleportSelector,
      to: n.teleportSelector
    }, [
      p(y, {
        "data-testid": "carousel",
        class: C(a.toolbarClass),
        "manifest-url": n.manifestUrl,
        "thumbnail-props": a.thumbnailProps,
        "canvas-id": s.canvasId_,
        "add-margin-top": n.showMenuPanel,
        onClick: a.handleThumbnailClick
      }, null, 8, ["class", "manifest-url", "thumbnail-props", "canvas-id", "add-margin-top", "onClick"])
    ], 8, ["disabled", "to"])) : g("", !0),
    n.showMenuPanel ? (u(), v(ge(s.isMobile && s.showModal ? "Modal" : "div"), {
      key: 4,
      id: s.showModal ? `menu-panel-modal${s.componentId}` : null,
      class: C(
        s.showModal ? "o-image-viewer__menu-modal" : "o-image-viewer__menu-panel"
      ),
      "show-close-button": !1,
      onAfterOpen: a.handleModalState,
      onAfterClose: a.handleModalState
    }, {
      default: E(() => [
        p(w, {
          "data-testid": "menuPanel",
          class: C(a.toolbarClass),
          "canvas-details": s.canvasDetails,
          "default-download-sizes": n.defaultDownloadSizes,
          "image-details": s.imageDetails,
          "caption-fields": n.captionFields,
          "manifest-url": n.manifestUrl,
          "show-image-request-button": n.enableImageRequest && (n.useLegacyLayout || n.imageRequestType == "button"),
          "enable-image-request": n.enableImageRequest,
          "iiif-image-url-part": n.iiifImageUrlPart,
          "current-choices": s.currentChoices,
          "publication-use-statement": n.publicationUseStatement,
          "modal-id": `menu-panel-modal${s.componentId}`,
          onClick: a.handleMenuClick,
          onImageRequest: t[6] || (t[6] = (h) => e.$emit("imageRequest", h)),
          onImageDownload: t[7] || (t[7] = (h) => e.$emit("imageDownload", h))
        }, null, 8, ["class", "canvas-details", "default-download-sizes", "image-details", "caption-fields", "manifest-url", "show-image-request-button", "enable-image-request", "iiif-image-url-part", "current-choices", "publication-use-statement", "modal-id", "onClick"])
      ]),
      _: 1
    }, 40, ["id", "class", "onAfterOpen", "onAfterClose"])) : g("", !0)
  ], 38);
}
const vr = /* @__PURE__ */ I(pa, [["render", ba]]), wa = "#000000", Ca = {
  name: "ImageServiceViewer",
  components: {
    ImageToolsButtonGroup: Re,
    ImageViewerToolbar: lt
  },
  provide() {
    return {
      // explicitly provide a computed property
      fullscreenAvailable: document.fullscreenEnabled || document.mozFullScreenEnabled || document.documentElement.webkitRequestFullScreen,
      canZoomIn: P(() => this.canZoomIn),
      canZoomOut: P(() => this.canZoomOut),
      isFullscreen: P(() => this.isFullscreen),
      viewerLayout: void 0,
      toolbarController: P(() => this.toolbarController)
    };
  },
  props: {
    /**
     * CSS custom property color value to set for background
     */
    backgroundColor: {
      type: String,
      required: !1,
      default: "#FFFFFF"
    },
    /**
     * Whether to render the viewer toolbar
     */
    showToolbar: {
      type: Boolean,
      default: !1
    },
    /**
     * Whether or not to enable the rotate button in the toolbar for image service viewer
     */
    showRotate: {
      type: Boolean,
      default: !1
    },
    /**
     * CSS modifiers
     */
    modifiers: {
      type: Array,
      required: !1,
      default: () => []
    },
    /**
     * The URL of the image to be displayed
     */
    src: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * The region (x,y,width,height) of a specific portion of the image to display
     */
    region: {
      type: [Object, String],
      required: !1,
      default: void 0
    },
    /**
     * Whether to enable legacy bottom toolbar panel
     */
    useLegacyLayout: {
      type: Boolean,
      default: !1
    },
    /**
     * Canvas panel a11y title attribute
     */
    canvasTitle: {
      type: String,
      default: void 0
    }
  },
  data() {
    return {
      /**
       * the analytics handler
       */
      analyticsHandler: ut(),
      /**
       * The toolbar controller
       */
      toolbarController: void 0,
      /**
       * Whether the user can zoom in or not
       */
      canZoomIn: this.isZoomable,
      /**
       * Whether the user can zoom out or not
       */
      canZoomOut: !1,
      /**
       *  Whether currently in fullscreen or not
       */
      isFullscreen: !1,
      /**
       * Degrees of rotation to apply to the canvas (canvas panel only)
       */
      rotation: 0
    };
  },
  computed: {
    /**
     * Classes to apply to parent element
     * @returns {Array} css classes
     */
    classes() {
      let e = ["m-image-service-viewer"];
      return this.modifiers.forEach((t) => {
        e.push(`m-image-service-viewer--${t}`);
      }), e;
    },
    /**
     * Class to apply to toolbar
     * @returns {String}
     */
    toolbarClass() {
      return this.modifiers.includes("light") && this.isFullscreen == !1 ? "g-toolbar-buttons--light" : "g-toolbar-buttons";
    },
    /**
     * Checks the region prop to see if it needs to be formatted before passing it into image-service
     *
     * @returns {String|undefined}
     */
    formattedRegion() {
      if (this.region)
        return typeof this.region == "object" ? `${this.region.x},${this.region.y},${this.region.w},${this.region.h}` : this.region;
    },
    /**
     * Background color to use for viewer; switches on fullscreen
     *
     * @returns {String} - valid css custom property color value
     */
    viewerBackgroundColor() {
      return this.isFullscreen ? wa : this.backgroundColor;
    }
  },
  watch: {
    /**
     * Enter/exit fullscreen
     */
    isFullscreen(e) {
      e == !0 && (this.$el.requestFullscreen || this.$el.webkitRequestFullscreen).call(
        this.$el
      ), document.fullscreenElement && e == !1 && document.exitFullscreen();
    }
  },
  mounted() {
    this.toolbarController = new ct(this, this.analyticsHandler);
  },
  methods: {
    /**
     * Handler for toolbar fullscreen change event
     *
     * @param {event} e - fullscreenchange event
     */
    handleFullscreenChange() {
      this.isFullscreen = !this.isFullscreen;
    },
    /**
     * Handler for native fullscreenchange events on top level component, like esc to exit fullscreen
     */
    handleNativeFullscreenChange(e) {
      this.isFullscreen && document.fullscreenElement == null && this.handleFullscreenChange(e);
    },
    /**
     * Handle World Ready event - triggers necessary checks
     * @param {event} e - the world-ready event
     */
    handleWorldReady(e) {
      this.handleZoom(e);
    },
    /**
     * Handle the zoom event
     * @param {event} e - the zoom event
     *
     * sets the 'can zoom in' and 'can-zoom out' logic
     */
    handleZoom(e) {
      this.canZoomIn = e.detail.canZoomIn, this.canZoomOut = e.detail.canZoomOut;
    },
    /**
     * On rotate event, increments rotation
     */
    handleRotate() {
      this.rotation = this.rotation + 90 === 360 ? 0 : this.rotation + 90;
    }
  }
}, Ia = ["a11y-title", "background", "src", "region", "interactive", "rotation"], Aa = {
  key: 0,
  class: "m-image-service-viewer__vertical-toolbar g-vertical-toolbar"
};
function Sa(e, t, n, i, s, a) {
  const r = f("ImageToolsButtonGroup"), o = f("ImageViewerToolbar");
  return u(), m("div", {
    class: C(a.classes),
    style: et(`--background-color: ${a.viewerBackgroundColor};`),
    onFullscreenchange: t[2] || (t[2] = (...l) => a.handleNativeFullscreenChange && a.handleNativeFullscreenChange(...l))
  }, [
    b("image-service", {
      ref: "panel",
      class: "m-image-service-viewer__canvas",
      "a11y-role": "img",
      "a11y-title": n.canvasTitle,
      background: a.viewerBackgroundColor,
      src: n.src,
      region: a.formattedRegion,
      interactive: n.showToolbar.toString(),
      rotation: s.rotation,
      "ignore-single-finger-touch": "true",
      "enable-pan-on-wait": "false",
      "pan-on-wait-delay": "40",
      "require-meta-key-for-wheel-zoom": "true",
      onWorldReady: t[0] || (t[0] = (...l) => a.handleWorldReady && a.handleWorldReady(...l)),
      onZoom: t[1] || (t[1] = (...l) => a.handleZoom && a.handleZoom(...l))
    }, null, 40, Ia),
    p(tt, { name: "g-vertical-toolbar__fade" }, {
      default: E(() => [
        n.showToolbar && !n.useLegacyLayout ? (u(), m("div", Aa, [
          p(r, {
            class: C(a.toolbarClass),
            "hide-image-tools": !1,
            "show-zoom": n.showToolbar,
            "show-rotate": n.showRotate
          }, null, 8, ["class", "show-zoom", "show-rotate"])
        ])) : g("", !0)
      ]),
      _: 1
    }),
    n.useLegacyLayout ? (u(), v(o, {
      key: 0,
      class: C(a.toolbarClass),
      "use-legacy-layout": n.useLegacyLayout,
      "show-zoom": n.useLegacyLayout,
      "show-rotate": n.showRotate
    }, null, 8, ["class", "use-legacy-layout", "show-zoom", "show-rotate"])) : g("", !0)
  ], 38);
}
const br = /* @__PURE__ */ I(Ca, [["render", Sa]]);
var Ma = Object.defineProperty, Ea = (e, t, n) => t in e ? Ma(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, se = (e, t, n) => (Ea(e, typeof t != "symbol" ? t + "" : t, n), n);
const c = [];
Object.freeze(c);
const Ta = {
  id: "https://iiif-parser/annotation-page",
  type: "AnnotationPage",
  behavior: c,
  motivation: null,
  label: null,
  thumbnail: c,
  summary: null,
  requiredStatement: null,
  metadata: c,
  rights: null,
  provider: c,
  items: c,
  seeAlso: c,
  homepage: c,
  logo: c,
  rendering: c,
  service: c
}, La = {
  id: "https://iiif-parser/empty-canvas",
  type: "Canvas",
  label: null,
  behavior: c,
  motivation: null,
  thumbnail: c,
  posterCanvas: null,
  accompanyingCanvas: null,
  placeholderCanvas: null,
  summary: null,
  requiredStatement: null,
  metadata: c,
  rights: null,
  navDate: null,
  provider: c,
  items: c,
  annotations: c,
  seeAlso: c,
  homepage: c,
  logo: c,
  partOf: c,
  rendering: c,
  service: c,
  duration: 0,
  height: 0,
  width: 0
}, Ra = {
  id: "https://iiif-parser/empty-collection",
  type: "Collection",
  label: null,
  viewingDirection: "left-to-right",
  behavior: c,
  motivation: null,
  thumbnail: c,
  posterCanvas: null,
  accompanyingCanvas: null,
  placeholderCanvas: null,
  summary: null,
  requiredStatement: null,
  metadata: c,
  rights: null,
  navDate: null,
  provider: c,
  items: c,
  annotations: c,
  seeAlso: c,
  homepage: c,
  logo: c,
  partOf: c,
  rendering: c,
  service: c,
  services: c
}, Pa = {
  id: "https://iiif-parser/empty-manifest",
  type: "Manifest",
  annotations: c,
  behavior: c,
  homepage: c,
  items: c,
  label: null,
  logo: c,
  metadata: c,
  motivation: null,
  navDate: null,
  provider: c,
  partOf: c,
  posterCanvas: null,
  accompanyingCanvas: null,
  placeholderCanvas: null,
  rendering: c,
  requiredStatement: null,
  rights: null,
  seeAlso: c,
  service: c,
  services: c,
  start: null,
  structures: c,
  summary: null,
  thumbnail: c,
  viewingDirection: "left-to-right"
}, Oa = {
  id: "https://iiif-parser/empty-canvas",
  type: "Range",
  label: null,
  behavior: c,
  motivation: null,
  thumbnail: c,
  posterCanvas: null,
  accompanyingCanvas: null,
  placeholderCanvas: null,
  summary: null,
  requiredStatement: null,
  metadata: c,
  rights: null,
  navDate: null,
  provider: c,
  items: c,
  annotations: c,
  seeAlso: c,
  homepage: c,
  logo: c,
  partOf: c,
  rendering: c,
  service: c,
  start: null,
  supplementary: null,
  viewingDirection: "left-to-right"
}, ka = {
  id: "https://iiif-parser/empty-agent",
  type: "Agent",
  label: {},
  logo: c,
  seeAlso: c,
  homepage: c
};
function pe(e) {
  return Array.isArray(e) ? e : [e];
}
const Ne = [
  "Collection",
  "Manifest",
  "Canvas",
  "AnnotationPage",
  "AnnotationCollection",
  "Annotation",
  "ContentResource",
  "Range",
  "Service",
  "Selector",
  "Agent"
];
function qa(e) {
  if (typeof e > "u" || e === null)
    throw new Error("Null or undefined is not a valid entity.");
  if (Array.isArray(e))
    throw new Error("Array is not a valid entity");
  if (typeof e != "object")
    throw new Error(`${typeof e} is not a valid entity`);
  if (typeof e.type == "string") {
    const t = Ne.indexOf(e.type);
    if (t !== -1)
      return Ne[t];
  }
  if (e.profile)
    return "Service";
  throw new Error("Resource type is not known");
}
class Pe {
  constructor(t, n = {}) {
    se(this, "traversals"), se(this, "options"), this.traversals = {
      collection: [],
      manifest: [],
      canvas: [],
      annotationCollection: [],
      annotationPage: [],
      annotation: [],
      contentResource: [],
      choice: [],
      range: [],
      service: [],
      agent: [],
      ...t
    }, this.options = {
      allowUndefinedReturn: !1,
      ...n
    };
  }
  static all(t) {
    return new Pe({
      collection: [t],
      manifest: [t],
      canvas: [t],
      annotationCollection: [t],
      annotationPage: [t],
      annotation: [t],
      contentResource: [t],
      choice: [t],
      range: [t],
      service: [t]
    });
  }
  traverseDescriptive(t) {
    return t.thumbnail && (t.thumbnail = t.thumbnail.map(
      (n) => this.traverseType(n, this.traversals.contentResource)
    )), t.provider && (t.provider = t.provider.map((n) => this.traverseAgent(n))), t;
  }
  traverseLinking(t) {
    return t.seeAlso && (t.seeAlso = t.seeAlso.map((n) => this.traverseType(n, this.traversals.contentResource))), t.service && (t.service = pe(t.service).map(
      (n) => this.traverseType(n, this.traversals.service)
    )), t.services && (t.services = t.services.map((n) => this.traverseType(n, this.traversals.service))), t.logo && (t.logo = t.logo.map((n) => this.traverseType(n, this.traversals.contentResource))), t.homepage && (t.homepage = t.homepage.map(
      (n) => this.traverseType(n, this.traversals.contentResource)
    )), t.partOf && (t.partOf = t.partOf.map((n) => typeof n == "string" || !n.type ? this.traverseType(n, this.traversals.contentResource) : n.type === "Canvas" ? this.traverseType(n, this.traversals.canvas) : n.type === "AnnotationCollection" ? this.traverseType(n, this.traversals.annotationCollection) : n.type === "Collection" ? this.traverseType(n, this.traversals.collection) : this.traverseType(n, this.traversals.contentResource))), t.start && (t.start = t.start ? this.traverseType(t.start, this.traversals.canvas) : null), t.rendering && (t.rendering = t.rendering.map(
      (n) => this.traverseType(n, this.traversals.contentResource)
    )), t.supplementary && (t.supplementary = t.supplementary.map(
      (n) => this.traverseType(n, this.traversals.contentResource)
    )), t;
  }
  traverseCollectionItems(t) {
    return t.items && t.items.map((n) => n.type === "Collection" ? this.traverseCollection(n) : this.traverseManifest(n)), t;
  }
  traverseCollection(t) {
    return this.traverseType(
      this.traverseDescriptive(
        this.traverseInlineAnnotationPages(
          this.traverseLinking(this.traversePosterCanvas(this.traverseCollectionItems(t)))
        )
      ),
      this.traversals.collection
    );
  }
  traverseManifestItems(t) {
    return t.items && (t.items = t.items.map((n) => this.traverseCanvas(n))), t;
  }
  traverseManifestStructures(t) {
    return t.structures && (t.structures = t.structures.map((n) => this.traverseRange(n))), t;
  }
  traverseManifest(t) {
    return this.traverseType(
      this.traverseInlineAnnotationPages(
        this.traverseManifestStructures(
          this.traversePosterCanvas(
            this.traverseDescriptive(this.traverseLinking(this.traverseManifestItems(t)))
          )
        )
      ),
      this.traversals.manifest
    );
  }
  traverseCanvasItems(t) {
    return t.items = (t.items || []).map((n) => this.traverseAnnotationPage(n)), t;
  }
  traverseInlineAnnotationPages(t) {
    return typeof t == "string" || !t || t.annotations && (t.annotations = t.annotations.map((n) => this.traverseAnnotationPage(n))), t;
  }
  traverseCanvas(t) {
    return this.traverseType(
      this.traverseInlineAnnotationPages(
        this.traversePosterCanvas(this.traverseDescriptive(this.traverseLinking(this.traverseCanvasItems(t))))
      ),
      this.traversals.canvas
    );
  }
  traverseAnnotationPageItems(t) {
    return t.items && (t.items = t.items.map((n) => this.traverseAnnotation(n))), t;
  }
  traverseAnnotationPage(t) {
    return this.traverseType(
      this.traverseDescriptive(this.traverseLinking(this.traverseAnnotationPageItems(t))),
      this.traversals.annotationPage
    );
  }
  traverseAnnotationBody(t) {
    return Array.isArray(t.body) ? t.body = t.body.map((n) => this.traverseContentResource(n)) : t.body && (t.body = this.traverseContentResource(t.body)), t;
  }
  traversePosterCanvas(t) {
    return t.posterCanvas && (t.posterCanvas = this.traverseCanvas(t.posterCanvas)), t.placeholderCanvas && (t.placeholderCanvas = this.traverseCanvas(t.placeholderCanvas)), t.accompanyingCanvas && (t.accompanyingCanvas = this.traverseCanvas(t.accompanyingCanvas)), t;
  }
  traverseAnnotation(t) {
    return this.traverseType(
      this.traverseLinking(this.traverseAnnotationBody(t)),
      this.traversals.annotation
    );
  }
  traverseContentResourceLinking(t) {
    return typeof t == "string" || !t || t && t.service && (t.service = pe(
      t.service || []
    ).map((n) => this.traverseType(n, this.traversals.service))), t;
  }
  traverseContentResource(t) {
    return t.type === "Choice" && (t.items = t.items.map((n) => this.traverseContentResource(n))), this.traverseType(
      this.traverseInlineAnnotationPages(this.traverseContentResourceLinking(t)),
      this.traversals.contentResource
    );
  }
  traverseRangeRanges(t) {
    return t.items && (t.items = t.items.map((n) => typeof n == "string" ? this.traverseCanvas({ id: n, type: "Canvas" }) : n.type === "Manifest" ? this.traverseManifest(n) : this.traverseRange(n))), t;
  }
  traverseRange(t) {
    return this.traverseType(
      this.traversePosterCanvas(this.traverseDescriptive(this.traverseLinking(this.traverseRangeRanges(t)))),
      this.traversals.range
    );
  }
  traverseAgent(t) {
    return this.traverseType(
      this.traverseDescriptive(this.traverseLinking(t)),
      this.traversals.agent
    );
  }
  traverseType(t, n) {
    return n.reduce((i, s) => {
      const a = s(i);
      return typeof a > "u" && !this.options.allowUndefinedReturn ? i : a;
    }, t);
  }
  traverseService(t) {
    return this.traverseType(t, this.traversals.service);
  }
  traverseUnknown(t) {
    const n = qa(t);
    switch (n) {
      case "Collection":
        return this.traverseCollection(t);
      case "Manifest":
        return this.traverseManifest(t);
      case "Canvas":
        return this.traverseCanvas(t);
      case "AnnotationPage":
        return this.traverseAnnotationPage(t);
      case "Annotation":
        return this.traverseAnnotation(t);
      case "ContentResource":
        return this.traverseContentResource(t);
      case "Range":
        return this.traverseRange(t);
      case "Service":
        return this.traverseService(t);
      case "Agent":
        return this.traverseAgent(t);
      default:
        throw new Error(`Unknown or unsupported resource type of ${n}`);
    }
  }
}
const xe = [
  "sc:Collection",
  "sc:Manifest",
  "sc:Canvas",
  "sc:AnnotationList",
  "oa:Annotation",
  "sc:Range",
  "sc:Layer",
  "sc:Sequence",
  "oa:Choice",
  "Service",
  "ContentResource"
];
function _a(e) {
  if (typeof e > "u" || e === null)
    throw new Error("Null or undefined is not a valid entity.");
  if (Array.isArray(e))
    throw new Error("Array is not a valid entity");
  if (typeof e != "object")
    throw new Error(`${typeof e} is not a valid entity`);
  if (typeof e["@type"] == "string") {
    const t = xe.indexOf(e["@type"]);
    if (t !== -1)
      return xe[t];
  }
  if (e.profile)
    return "Service";
  if (e.format || e["@type"])
    return "ContentResource";
  throw new Error("Resource type is not known");
}
class Oe {
  constructor(t, n = {}) {
    se(this, "traversals"), se(this, "options"), this.traversals = {
      collection: [],
      manifest: [],
      canvas: [],
      annotationList: [],
      sequence: [],
      annotation: [],
      contentResource: [],
      choice: [],
      range: [],
      service: [],
      layer: [],
      ...t
    }, this.options = {
      convertPropsToArray: !0,
      mergeMemberProperties: !0,
      allowUndefinedReturn: !1,
      ...n
    };
  }
  static all(t) {
    return new Oe({
      collection: [t],
      manifest: [t],
      canvas: [t],
      annotationList: [t],
      sequence: [t],
      annotation: [t],
      contentResource: [t],
      choice: [t],
      range: [t],
      service: [t],
      layer: [t]
    });
  }
  traverseCollection(t) {
    return this.traverseType(
      this.traverseDescriptive(this.traverseLinking(this.traverseCollectionItems(t))),
      this.traversals.collection
    );
  }
  traverseCollectionItems(t) {
    if (this.options.mergeMemberProperties) {
      const n = [
        ...(t.manifests || []).map((i) => typeof i == "string" ? { "@id": i, "@type": "sc:Manifest" } : i),
        ...(t.collections || []).map((i) => typeof i == "string" ? { "@id": i, "@type": "sc:Collection" } : i),
        ...t.members || []
      ];
      delete t.collections, delete t.manifests, t.members = n;
    }
    return t.manifests && (t.manifests = t.manifests.map(
      (n) => this.traverseManifest(
        typeof n == "string" ? { "@id": n, "@type": "sc:Manifest" } : n
      )
    )), t.collections && (t.collections = t.collections.map(
      (n) => this.traverseCollection(
        typeof n == "string" ? { "@id": n, "@type": "sc:Collection" } : n
      )
    )), t.members && (t.members = t.members.map((n) => typeof n == "string" ? n : this.traverseUnknown(n))), t;
  }
  traverseManifest(t) {
    return this.traverseType(
      this.traverseDescriptive(this.traverseLinking(this.traverseManifestItems(t))),
      this.traversals.manifest
    );
  }
  traverseManifestItems(t) {
    return t.sequences && (t.sequences = t.sequences.map((n) => this.traverseSequence(n))), t.structures && (t.structures = t.structures.map((n) => this.traverseRange(n))), t;
  }
  traverseSequence(t) {
    return this.traverseType(
      this.traverseDescriptive(this.traverseLinking(this.traverseSequenceItems(t))),
      this.traversals.sequence
    );
  }
  traverseSequenceItems(t) {
    return t.canvases && (t.canvases = t.canvases.map((n) => this.traverseCanvas(n))), t;
  }
  traverseCanvas(t) {
    return this.traverseType(
      this.traverseDescriptive(this.traverseLinking(this.traverseCanvasItems(t))),
      this.traversals.canvas
    );
  }
  traverseCanvasItems(t) {
    return t.images && (t.images = t.images.map((n) => this.traverseAnnotation(n))), t.otherContent && (t.otherContent = t.otherContent.map((n) => this.traverseAnnotationList(n))), t;
  }
  traverseRange(t) {
    return this.traverseType(
      this.traverseDescriptive(this.traverseLinking(this.traverseRangeItems(t))),
      this.traversals.range
    );
  }
  traverseRangeItems(t) {
    if (this.options.mergeMemberProperties) {
      const n = [
        ...(t.ranges || []).map((i) => typeof i == "string" ? { "@id": i, "@type": "sc:Range" } : i),
        ...(t.canvases || []).map((i) => typeof i == "string" ? { "@id": i, "@type": "sc:Canvas" } : i),
        ...t.members || []
      ];
      delete t.ranges, delete t.canvases, t.members = n.length ? n.map((i) => this.traverseUnknown(i)) : void 0;
    }
    return t;
  }
  traverseAnnotationList(t) {
    const n = typeof t == "string" ? { "@id": t, "@type": "sc:AnnotationList" } : t;
    return this.traverseType(
      this.traverseDescriptive(this.traverseAnnotationListItems(n)),
      this.traversals.annotationList
    );
  }
  traverseAnnotationListItems(t) {
    return t.resources && (t.resources = t.resources.map((n) => this.traverseAnnotation(n))), t;
  }
  traverseAnnotation(t) {
    return this.traverseType(
      this.traverseDescriptive(this.traverseLinking(this.traverseAnnotationItems(t))),
      this.traversals.annotation
    );
  }
  traverseAnnotationItems(t) {
    return t.resource && (Array.isArray(t.resource) ? t.resource = t.resource.map(
      (n) => this.traverseContentResource(n)
    ) : t.resource = this.traverseContentResource(t.resource)), t.on, t;
  }
  traverseLayer(t) {
    return this.traverseType(this.traverseLinking(this.traverseLayerItems(t)), this.traversals.layer);
  }
  traverseLayerItems(t) {
    return t.otherContent && (t.otherContent = t.otherContent.map((n) => this.traverseAnnotationList(n))), t;
  }
  traverseChoice(t) {
    return this.traverseType(this.traverseChoiceItems(t), this.traversals.choice);
  }
  traverseChoiceItems(t) {
    return t.default && t.default !== "rdf:nil" && (t.default = this.traverseContentResource(t.default)), t.item && t.item !== "rdf:nil" && (t.item = t.item.map((n) => this.traverseContentResource(n))), t;
  }
  traverseService(t) {
    return this.traverseType(this.traverseLinking(t), this.traversals.service);
  }
  traverseContentResource(t) {
    return t["@type"] === "oa:Choice" ? this.traverseChoice(t) : this.traverseType(
      this.traverseDescriptive(this.traverseLinking(t)),
      this.traversals.contentResource
    );
  }
  traverseUnknown(t) {
    if (!t["@type"] || typeof t == "string")
      return t;
    switch (_a(t)) {
      case "sc:Collection":
        return this.traverseCollection(t);
      case "sc:Manifest":
        return this.traverseManifest(t);
      case "sc:Canvas":
        return this.traverseCanvas(t);
      case "sc:Sequence":
        return this.traverseSequence(t);
      case "sc:Range":
        return this.traverseRange(t);
      case "oa:Annotation":
        return this.traverseAnnotation(t);
      case "sc:AnnotationList":
        return this.traverseAnnotationList(t);
      case "sc:Layer":
        return this.traverseLayer(t);
      case "Service":
        return this.traverseService(t);
      case "oa:Choice":
        return this.traverseChoice(t);
      case "ContentResource":
        return this.traverseContentResource(t);
    }
    return t.profile ? this.traverseService(t) : t;
  }
  traverseImageResource(t) {
    const n = Array.isArray(t), i = Array.isArray(t) ? t : [t], s = [];
    for (const a of i)
      typeof a == "string" ? s.push(
        this.traverseContentResource({
          "@id": a,
          "@type": "dctypes:Image"
        })
      ) : s.push(this.traverseContentResource(a));
    return !n && !this.options.convertPropsToArray ? s[0] : s;
  }
  traverseDescriptive(t) {
    return t.thumbnail && (t.thumbnail = this.traverseImageResource(t.thumbnail)), t.logo && (t.logo = this.traverseImageResource(t.logo)), t;
  }
  traverseOneOrMoreServices(t) {
    const n = Array.isArray(t), i = Array.isArray(t) ? t : [t], s = [];
    for (const a of i)
      s.push(this.traverseService(a));
    return !n && !this.options.convertPropsToArray ? s[0] : s;
  }
  traverseLinking(t) {
    return t.related && (t.related = this.traverseOneOrManyType(t.related, this.traversals.contentResource)), t.rendering && (t.rendering = this.traverseOneOrManyType(t.rendering, this.traversals.contentResource)), t.service && (t.service = this.traverseOneOrMoreServices(t.service)), t.seeAlso && (t.seeAlso = this.traverseOneOrManyType(t.seeAlso, this.traversals.contentResource)), t.within && (typeof t.within == "string" || (t.within = this.traverseOneOrManyType(
      t.within,
      this.traversals.contentResource
    ))), t.startCanvas && (typeof t.startCanvas == "string" ? t.startCanvas = this.traverseType(
      { "@id": t.startCanvas, "@type": "sc:Canvas" },
      this.traversals.canvas
    ) : t.startCanvas && this.traverseType(t.startCanvas, this.traversals.canvas)), t.contentLayer && (typeof t.contentLayer == "string" ? t.contentLayer = this.traverseLayer({
      "@id": t.contentLayer,
      "@type": "sc:Layer"
    }) : t.contentLayer = this.traverseLayer(t.contentLayer)), t;
  }
  traverseOneOrManyType(t, n) {
    if (!Array.isArray(t))
      if (this.options.convertPropsToArray)
        t = [t];
      else
        return this.traverseType(t, n);
    return t.map((i) => this.traverseType(i, n));
  }
  traverseType(t, n) {
    return n.reduce((i, s) => {
      const a = s(i);
      return typeof a > "u" && !this.options.allowUndefinedReturn ? i : a;
    }, t);
  }
}
const Da = "http://library.stanford.edu/iiif/image-api/compliance.html#level0", dt = "http://library.stanford.edu/iiif/image-api/compliance.html#level1", ht = "http://library.stanford.edu/iiif/image-api/compliance.html#level2", Na = "http://library.stanford.edu/iiif/image-api/conformance.html#level0", ft = "http://library.stanford.edu/iiif/image-api/conformance.html#level1", mt = "http://library.stanford.edu/iiif/image-api/conformance.html#level2", xa = "http://library.stanford.edu/iiif/image-api/1.1/compliance.html#level0", gt = "http://library.stanford.edu/iiif/image-api/1.1/compliance.html#level1", yt = "http://library.stanford.edu/iiif/image-api/1.1/compliance.html#level2", Fa = "http://library.stanford.edu/iiif/image-api/1.1/conformance.html#level0", pt = "http://library.stanford.edu/iiif/image-api/1.1/conformance.html#level1", vt = "http://library.stanford.edu/iiif/image-api/1.1/conformance.html#level2", Ba = "http://iiif.io/api/image/1/level0.json", Ua = "http://iiif.io/api/image/1/profiles/level0.json", bt = "http://iiif.io/api/image/1/level1.json", wt = "http://iiif.io/api/image/1/profiles/level1.json", Ct = "http://iiif.io/api/image/1/level2.json", It = "http://iiif.io/api/image/1/profiles/level2.json", za = "http://iiif.io/api/image/2/level0.json", ja = "http://iiif.io/api/image/2/profiles/level0.json", At = "http://iiif.io/api/image/2/level1.json", St = "http://iiif.io/api/image/2/profiles/level1.json", Mt = "http://iiif.io/api/image/2/level2.json", Et = "http://iiif.io/api/image/2/profiles/level2.json", Ga = "level0", Tt = "level1", Lt = "level2", Za = "http://iiif.io/api/image/2/level0", Rt = "http://iiif.io/api/image/2/level1", Pt = "http://iiif.io/api/image/2/level2", Va = [
  Rt,
  Pt,
  dt,
  ht,
  ft,
  mt,
  gt,
  yt,
  pt,
  vt,
  bt,
  wt,
  Ct,
  It,
  At,
  St,
  Mt,
  Et,
  Tt,
  Lt
], Wa = [
  Za,
  Rt,
  Pt,
  Da,
  dt,
  ht,
  Na,
  ft,
  mt,
  xa,
  gt,
  yt,
  Fa,
  pt,
  vt,
  Ba,
  Ua,
  bt,
  wt,
  Ct,
  It,
  za,
  ja,
  At,
  St,
  Mt,
  Et,
  Ga,
  Tt,
  Lt
], ve = {
  attributionLabel: "Attribution",
  providerId: "http://example.org/provider",
  providerName: "Unknown"
};
function Q(e, t = "none") {
  if (!e)
    return {};
  const n = Array.isArray(e) ? e : [e], i = {};
  for (const s of n) {
    if (typeof s == "string") {
      i[t] = i[t] ? i[t] : [], i[t].push(s || "");
      continue;
    }
    if (!s["@language"]) {
      i[t] = i[t] ? i[t] : [], i[t].push(s["@value"] || "");
      continue;
    }
    const a = s["@language"];
    i[a] = i[a] ? i[a] : [], i[a].push(s["@value"] || "");
  }
  return i;
}
function Ot(e) {
  if (Array.isArray(e))
    return Ot(e.find((t) => typeof t == "string"));
  if (Wa.indexOf(e) !== -1)
    return "level2";
  if (Va.indexOf(e) !== -1)
    return "level1";
  if (typeof e == "string")
    return e;
}
function Ha(e) {
  const t = Array.isArray(e) ? e : [e];
  for (const n of t)
    switch (n) {
      case "http://iiif.io/api/image/2/context.json":
      case "http://library.stanford.edu/iiif/image-api/1.1/compliance.html#level2":
        return "ImageService2";
      case "http://iiif.io/api/image/1/context.json":
      case "http://library.stanford.edu/iiif/image-api/1.1/context.json":
        return "ImageService1";
      case "http://iiif.io/api/annex/openannotation/context.json":
        return "ImageApiSelector";
    }
}
function Qa(e) {
  switch (e) {
    case "http://iiif.io/api/image/2/level0.json":
    case "http://iiif.io/api/image/2/level1.json":
    case "http://iiif.io/api/image/2/level2.json":
      return "ImageService2";
    case "http://iiif.io/api/auth/1/kiosk":
    case "http://iiif.io/api/auth/1/login":
    case "http://iiif.io/api/auth/1/clickthrough":
    case "http://iiif.io/api/auth/1/external":
    case "http://iiif.io/api/auth/0/kiosk":
    case "http://iiif.io/api/auth/0/login":
    case "http://iiif.io/api/auth/0/clickthrough":
    case "http://iiif.io/api/auth/0/external":
      return "AuthCookieService1";
    case "http://iiif.io/api/auth/1/token":
    case "http://iiif.io/api/auth/0/token":
      return "AuthTokenService1";
    case "http://iiif.io/api/auth/1/logout":
    case "http://iiif.io/api/auth/0/logout":
      return "AuthLogoutService1";
    case "http://iiif.io/api/search/1/search":
    case "http://iiif.io/api/search/0/search":
      return "SearchService1";
    case "http://iiif.io/api/search/1/autocomplete":
    case "http://iiif.io/api/search/0/autocomplete":
      return "AutoCompleteService1";
  }
}
function Fe(e) {
  for (const t of ["sc", "oa", "dcterms", "dctypes", "iiif"])
    if (e.startsWith(`${t}:`))
      return e.slice(t.length + 1);
  return e;
}
const Ya = ["Collection", "Manifest", "Annotation", "AnnotationPage", "Range", "Service"];
function ke(e) {
  const t = e["@id"] || e.id;
  let n = e["@type"] || e.type;
  const i = e.profile || void 0, s = e["@context"] || void 0;
  if (i) {
    const a = Qa(i);
    if (a)
      return a;
  }
  if (s) {
    const a = Ha(s);
    if (a)
      return a;
  }
  if (n) {
    if (Array.isArray(n)) {
      if (n.indexOf("oa:CssStylesheet") !== -1)
        return "CssStylesheet";
      if (n.indexOf("cnt:ContentAsText") !== -1)
        return "TextualBody";
      n = n[0];
    }
    for (const a of ["sc", "oa", "dcterms", "dctypes", "iiif"])
      if (n.startsWith(`${a}:`)) {
        n = n.slice(a.length + 1);
        break;
      }
    switch (n) {
      case "Layer":
        return "AnnotationCollection";
      case "AnnotationList":
        return "AnnotationPage";
      case "cnt:ContentAsText":
        return "TextualBody";
    }
  }
  if (n && Ya.indexOf(n) !== -1)
    return n;
  if (e.format) {
    if (e.format.startsWith("image/"))
      return "Image";
    if (e.format.startsWith("text/") || e.format === "application/pdf")
      return "Text";
    if (e.format.startsWith("application/"))
      return "Dataset";
  }
  return t && (t.endsWith(".jpg") || t.endsWith(".png") || t.endsWith(".jpeg")) ? "Image" : n || "unknown";
}
const Xa = /http(s)?:\/\/(creativecommons.org|rightsstatements.org)[^"'\\<\n]+/gm;
function Ja(e) {
  const t = e.match(Xa);
  return t ? t[0] : e;
}
function Ka(e, t = "Rights/License", n = "none") {
  let i = null;
  const s = [], a = Array.isArray(e) ? e : [e];
  for (const r of a) {
    const o = r ? Ja(r) : void 0;
    if (o && (o.indexOf("creativecommons.org") !== -1 || o.indexOf("rightsstatements.org") !== -1)) {
      o.startsWith("https://") ? i = `http://${o.slice(8)}` : i = o;
      continue;
    }
    o && s.push({
      label: { [n]: [t] },
      value: { [n]: [o] }
    });
  }
  return [i, s];
}
const $a = [
  "http://iiif.io/api/presentation/2/context.json",
  "http://iiif.io/api/image/2/context.json",
  "http://iiif.io/api/image/1/context.json",
  "http://library.stanford.edu/iiif/image-api/1.1/context.json",
  "http://iiif.io/api/search/1/context.json",
  "http://iiif.io/api/search/0/context.json",
  "http://iiif.io/api/auth/1/context.json",
  "http://iiif.io/api/auth/0/context.json",
  "http://iiif.io/api/annex/openannotation/context.json"
];
function es(e) {
  if (e) {
    const t = Array.isArray(e) ? e : [e], n = [];
    for (const i of t)
      i === "http://iiif.io/api/presentation/2/context.json" && n.push("http://iiif.io/api/presentation/3/context.json"), $a.indexOf(i) === -1 && n.push(i);
    if (t.length)
      return n.length === 1 ? n[0] : n;
  }
}
function ts(e) {
  return e ? e.map((t) => ({
    label: Q(t.label),
    value: Q(t.value)
  })) : [];
}
function N(e) {
  for (const t in e)
    (typeof e[t] > "u" || e[t] === null) && delete e[t];
  return e;
}
let Be = 0;
function kt(e, t) {
  const n = encodeURI(e.id || e["@id"] || "").trim();
  return n && t ? `${n}/${t}` : n || (Be++, `http://example.org/${e["@type"]}${t ? `/${t}` : ""}/${Be}`);
}
function x(e) {
  const t = [...e.behavior || []];
  e.viewingHint && t.push(e.viewingHint);
  let n;
  return Array.isArray(e.motivation) ? n = e.motivation.map(Fe) : e.motivation && (n = Fe(e.motivation)), {
    "@context": e["@context"] ? es(e["@context"]) : void 0,
    id: (e["@id"] || kt(e)).trim(),
    type: ke(e),
    behavior: t.length ? t : void 0,
    height: e.height ? e.height : void 0,
    width: e.width ? e.width : void 0,
    motivation: n,
    viewingDirection: e.viewingDirection,
    profile: e.profile,
    format: e.format ? e.format : void 0,
    duration: void 0,
    timeMode: void 0
  };
}
function F(e) {
  const [t, n] = Ka(e.license), i = [...e.metadata ? ts(e.metadata) : [], ...n];
  return {
    rights: t,
    metadata: i.length ? i : void 0,
    label: e.label ? Q(e.label) : void 0,
    requiredStatement: e.attribution ? {
      label: Q(ve.attributionLabel),
      value: Q(e.attribution)
    } : void 0,
    navDate: e.navDate,
    summary: e.description ? Q(e.description) : void 0,
    thumbnail: e.thumbnail
  };
}
function ns(e) {
  if (!e.within)
    return;
  const t = Array.isArray(e.within) ? e.within : [e.within], n = [];
  for (const i of t)
    if (typeof i == "string") {
      if (i)
        switch (e["@type"]) {
          case "sc:Manifest":
            n.push({ id: i, type: "Collection" });
            break;
        }
    } else i["@id"] && n.push({
      id: i["@id"],
      type: ke(i)
    });
  return n.length ? n : void 0;
}
function z(e) {
  const t = e.related ? Array.isArray(e.related) ? e.related : [e.related] : [], n = e.contentLayer;
  return {
    provider: e.logo || t.length ? [
      {
        id: ve.providerId,
        type: "Agent",
        homepage: t.length ? [t[0]] : void 0,
        logo: e.logo ? Array.isArray(e.logo) ? e.logo : [e.logo] : void 0,
        label: Q(ve.providerName)
      }
    ] : void 0,
    partOf: ns(e),
    rendering: e.rendering,
    seeAlso: e.seeAlso,
    start: e.startCanvas,
    service: e.service ? pe(e.service) : void 0,
    supplementary: n ? [n] : void 0
  };
}
function is(e) {
  return {
    chars: e.chars,
    format: e.format ? e.format : void 0,
    language: e.language
  };
}
function as(e) {
  return N({
    ...x(e),
    ...F(e),
    ...z(e),
    items: e.members
  });
}
function ss(e) {
  const t = [], n = [];
  for (const s of e.sequences || [])
    s.canvases.length && t.push(...s.canvases), s.behavior && n.push(...s.behavior);
  const i = x(e);
  return n.length && (i.behavior ? i.behavior.push(...n) : i.behavior = n), N({
    ...i,
    ...F(e),
    ...z(e),
    items: t,
    structures: e.structures
  });
}
function rs(e) {
  return N({
    ...x(e),
    ...F(e),
    ...z(e),
    annotations: e.otherContent && e.otherContent.length ? e.otherContent : void 0,
    items: e.images && e.images.length ? [
      {
        id: kt(e, "annotation-page"),
        type: "AnnotationPage",
        items: e.images
      }
    ] : void 0
  });
}
function os(e) {
  return N({
    ...x(e),
    ...F(e),
    ...z(e),
    items: e.resources && e.resources.length ? e.resources : void 0
  });
}
function ls(e) {
  return !e.canvases || e.canvases.length === 0 ? {
    canvases: [],
    behavior: []
  } : {
    canvases: e.canvases,
    behavior: e.viewingHint ? [e.viewingHint] : []
  };
}
function us(e) {
  function t(n) {
    if (Array.isArray(n)) {
      if (n.length > 1)
        return { type: "List", items: n.map(t) };
      n = n[0];
    }
    if (typeof n == "string")
      return encodeURI(n).trim();
    if ("@type" in n) {
      let i;
      if (typeof n.full == "string")
        i = n.full;
      else if (n.full["@type"] === "dctypes:Image")
        i = { id: n.full["@id"], type: "Image" };
      else if (n.full["@type"] === "sc:Canvas")
        i = { id: n.full["@id"], type: "Canvas" };
      else
        throw new Error(`Unsupported source type on annotation: ${n.full["@type"]}`);
      return {
        type: "SpecificResource",
        source: i,
        selector: we(n.selector)
      };
    } else
      return encodeURI(n["@id"]).trim();
  }
  return N({
    ...x(e),
    ...F(e),
    ...z(e),
    target: t(e.on),
    body: Array.isArray(e.resource) ? e.resource.map(be) : be(e.resource)
  });
}
function be(e) {
  const t = e;
  return N({
    ...x(t),
    ...F(t),
    ...z(t),
    ...is(t)
  });
}
function cs(e) {
  const t = [];
  return e.default && e.default !== "rdf:nil" && t.push(e.default), e.item && e.item !== "rdf:nil" && t.push(...e.item), {
    ...x(e),
    ...F(e),
    items: t
  };
}
function ds(e) {
  return N({
    ...x(e),
    ...F(e),
    ...z(e),
    items: e.members
  });
}
function hs(e) {
  const { "@id": t, "@type": n, "@context": i, profile: s, ...a } = e, r = {};
  return t && (r["@id"] = t), r["@type"] = ke(e), r["@type"] === "unknown" && (i && i.length && (r["@context"] = i), r["@type"] = "Service"), s && (r.profile = Ot(s)), N({
    ...r,
    ...a
  });
}
function fs(e) {
  return N({
    ...x(e),
    ...F(e),
    ...z(e)
  });
}
const ms = new Oe({
  collection: [as],
  manifest: [ss],
  canvas: [rs],
  annotationList: [os],
  sequence: [ls],
  annotation: [us],
  contentResource: [be],
  choice: [cs],
  range: [ds],
  service: [hs],
  layer: [fs]
});
function gs(e) {
  return e && e["@context"] && (e["@context"] === "http://iiif.io/api/presentation/2/context.json" || e["@context"].indexOf("http://iiif.io/api/presentation/2/context.json") !== -1 || e["@context"] === "http://www.shared-canvas.org/ns/context.json") || e["@context"] === "http://iiif.io/api/image/2/context.json" ? ms.traverseUnknown(e) : e;
}
function we(e) {
  if ((Array.isArray(e["@type"]) && e["@type"].includes("oa:SvgSelector") || e["@type"] == "oa:SvgSelector") && ("chars" in e || "value" in e))
    return {
      type: "SvgSelector",
      value: "chars" in e ? e.chars : e.value
    };
  if (e["@type"] === "oa:FragmentSelector")
    return {
      type: "FragmentSelector",
      value: e.value
    };
  if (e["@type"] === "oa:Choice")
    return [
      we(e.default),
      ...(Array.isArray(e.item) ? e.item : [e.item]).map(
        we
      )
    ];
  if (e["@type"] == "iiif:ImageApiSelector")
    return {
      type: "ImageApiSelector",
      region: "region" in e ? e.region : void 0,
      rotation: "rotation" in e ? e.rotation : void 0
    };
  throw new Error(`Unsupported selector type: ${e["@type"]}`);
}
function ys() {
  return {
    Collection: {},
    Manifest: {},
    Canvas: {},
    AnnotationPage: {},
    AnnotationCollection: {},
    Annotation: {},
    ContentResource: {},
    Range: {},
    Service: {},
    Selector: {},
    Agent: {}
  };
}
function qt(e, t) {
  if (typeof e == "string")
    return { id: e, type: t };
  if (!e.id)
    throw new Error(`Invalid resource does not have an ID (${t})`);
  return e;
}
function ps(e) {
  return (t, n) => {
    const i = e[t] ? e[t] : {};
    return (s) => {
      const a = qt(s, n || t);
      return a && a.id && t ? (i[a.id] = i[a.id] ? vs(i[a.id], a) : Object.assign({}, a), {
        id: a.id,
        type: t === "ContentResource" ? t : a.type
      }) : a;
    };
  };
}
function Ce(e, t) {
  if (!t)
    return e;
  if (Array.isArray(e)) {
    if (!Array.isArray(t))
      throw new Error("Cannot merge array with non-array");
    const n = [...e];
    for (const i of t)
      if (i != null)
        if (Array.isArray(i))
          n.push(i);
        else if (typeof i == "object" && i.id && i.type) {
          const s = n.findIndex((a) => a.id === i.id && a.type === i.type);
          s >= 0 && (n[s] = Ce(n[s], i));
        } else e.indexOf(i) === -1 && n.push(i);
    return n;
  } else if (typeof e == "object") {
    if (Array.isArray(t) || typeof t != "object")
      throw new Error("Cannot merge object with non-object");
    const n = { ...e };
    for (const [i, s] of Object.entries(t)) {
      const a = n[i];
      a === c || !a ? n[i] = s : n[i] = Ce(a, s);
    }
    return n;
  } else if (e)
    return e;
  return t;
}
function vs(e, t) {
  if (typeof e == "string")
    return e;
  if (t.id !== e.id || t.type !== e.type)
    throw new Error("Can only merge entities with identical identifiers and type!");
  return Ce({ ...e }, t);
}
function bs(e) {
  return (t, n) => (i) => {
    const { id: s, type: a } = qt(i, n || t);
    if (typeof s > "u")
      throw new Error("Found invalid entity without an ID.");
    return t === "ContentResource" ? e[s] = t : e[s] = a, i;
  };
}
function ws(e) {
  const t = JSON.stringify(e);
  let n = 5381, i = t.length;
  for (; i; )
    n = n * 33 ^ t.charCodeAt(--i);
  const a = (n >>> 0).toString(16);
  return a.length % 2 ? "0" + a : a;
}
function de(e) {
  return (t) => typeof t == "string" ? { id: t, type: e } : t.id ? t.type ? t : { type: e, ...t } : { id: `vault://${ws(t)}`, type: e, ...t };
}
function X(e) {
  return (t) => ({
    ...e,
    ...t
  });
}
function J(e) {
  return Array.isArray(e) ? e : [e];
}
function Cs(e) {
  return e.body && (e.body = J(e.body)), e.seeAlso && (e.seeAlso = J(e.seeAlso)), e.body && (e.body = J(e.body)), e.audience && (e.audience = J(e.audience)), e.accessibility && (e.accessibility = J(e.accessibility)), e.motivation && (e.motivation = J(e.motivation)), e;
}
function Is(e) {
  const t = gs(e), n = ys(), i = {}, s = ps(n), a = bs(i), o = new Pe({
    collection: [
      X(Ra),
      a("Collection"),
      s("Collection")
    ],
    manifest: [
      X(Pa),
      a("Manifest"),
      s("Manifest")
    ],
    canvas: [
      X(La),
      a("Canvas"),
      s("Canvas")
    ],
    annotationPage: [
      de("AnnotationPage"),
      X(Ta),
      a("AnnotationPage"),
      s("AnnotationPage")
    ],
    annotation: [
      de("Annotation"),
      Cs,
      a("Annotation"),
      s("Annotation")
    ],
    contentResource: [
      de("ContentResource"),
      a("ContentResource"),
      s("ContentResource")
    ],
    range: [
      X(Oa),
      a("Range", "Canvas"),
      s("Range", "Canvas")
    ],
    agent: [
      X(ka),
      a("Agent"),
      s("Agent")
    ]
  }).traverseUnknown(t);
  return { entities: n, resource: o, mapping: i };
}
const H = "__$UNSET$__", _t = "__$UNWRAP$__";
function As(e, t) {
  const n = e.requests[t], i = e.mapping[t];
  if (!(!i || n && n.resourceUri && !e.entities[i][n.resourceUri]))
    return e.entities[i][n ? n.resourceUri : t];
}
function Ss(e) {
  const t = {};
  for (const [n, i] of e) {
    if (n === _t && i !== H)
      return i;
    i !== H && typeof i < "u" && i !== null && (t[n] = i);
  }
  return t;
}
function Ms(e, t, n) {
  if (!t.type || !t.id)
    throw new Error("Unknown entity");
  if (!n[t.type])
    throw new Error(`Serializer not found for ${t.type}`);
  function i(s) {
    const a = n[s.type];
    if (!a)
      return H;
    const r = As(e, s.id) || (s.id && s.type ? s : null);
    if (!r)
      return H;
    const o = a(r, e, { isTopLevel: t.id === s.id });
    let l = o.next();
    for (; !l.done; ) {
      const d = l.value;
      let y = H;
      if (d)
        if (Array.isArray(d)) {
          const w = [];
          for (const h of d)
            w.push(i(h));
          y = w;
        } else
          y = i(d);
      l = o.next(y);
    }
    return l.value === H ? H : Ss(l.value);
  }
  return i(t);
}
function K(e) {
  if (!e)
    return;
  const t = Object.keys(e);
  if (t.length !== 0) {
    if (t.length === 1) {
      const n = t[0];
      if (!n)
        return "";
      const i = (e[n] || []).join("");
      return n === "@none" || n === "none" || n === "en" ? i : {
        "@language": n,
        "@value": i
      };
    }
    return t.map((n) => ({
      "@language": n,
      "@value": (e[n] || []).join("")
    }));
  }
}
function Dt(e) {
  return Array.isArray(e) ? e.map((t) => Dt(t)) : typeof e == "string" ? e : e.type && e.type === "Canvas" ? e.id : e;
}
function U(e, t = !1) {
  if (e)
    return e.length > 1 && !t ? e : e[0] || void 0;
}
function Es(e) {
  if (e) {
    if (typeof e == "string")
      return {
        "@id": e
      };
    if ("@id" in e) {
      const t = { ...e };
      return delete t["@type"], t;
    }
    return {
      "@context": "http://iiif.io/api/image/2/context.json",
      "@id": e.id,
      profile: `http://iiif.io/api/image/2/profiles/${e.profile}.json`
    };
  }
}
function j(e, t) {
  return [
    ["@id", e.id],
    ["@type", t],
    ["format", e.format],
    ["height", e.height],
    ["width", e.width],
    ["viewingDirection", e.viewingDirection !== "left-to-right" ? e.viewingDirection : void 0]
  ];
}
function* G(e) {
  const t = e.provider ? yield e.provider[0] : void 0;
  return [
    ["label", K(e.label)],
    [
      "metadata",
      e.metadata && e.metadata.length ? e.metadata.map((n) => ({
        label: K(n.label) || "",
        value: K(n.value) || ""
      })) : void 0
    ],
    ["description", K(e.summary)],
    ["thumbnail", U(yield e.thumbnail)],
    ["navDate", e.navDate],
    ["logo", t ? U(t.logo) : void 0],
    ["homepage", t ? t.homepage : void 0],
    ["attribution", e.requiredStatement ? K(e.requiredStatement.value) : void 0]
  ];
}
function* te(e) {
  return [
    ["seeAlso", U(yield e.seeAlso)],
    ["service", U((e.service || []).map(Es))],
    ["rendering", U(yield e.rendering)],
    ["startCanvas", e.start ? e.start.id : void 0]
  ];
}
const Ts = {
  Manifest: function* (e) {
    return [
      ...j(e, "sc:Manifest"),
      ...yield* G(e),
      ...yield* te(e),
      [
        "sequences",
        [
          {
            "@id": `${e.id}/sequence0`,
            "@type": "sc:Sequence",
            canvases: yield e.items
          }
        ]
      ],
      ["structures", yield e.structures]
    ];
  },
  Canvas: function* (e) {
    const n = (yield e.items)[0];
    return [
      ...j(e, "sc:Canvas"),
      ...yield* G(e),
      ...yield* te(e),
      ["images", n ? [n.resources] : void 0],
      [
        "annotations",
        e.annotations && e.annotations.length ? U(yield e.annotations) : void 0
      ]
    ];
  },
  AnnotationPage: function* (e) {
    return [
      ...j(e, "sc:AnnotationList"),
      ...yield* G(e),
      ["resources", e.items && e.items.length ? U(yield e.items) : void 0]
    ];
  },
  Annotation: function* (e) {
    return [
      ["@id", e.id],
      ["@type", "oa:Annotation"],
      ["motivation", "sc:painting"],
      ["on", Dt(e.target)],
      ["resource", U(yield e.body, !0)]
    ];
  },
  ContentResource: function* (e) {
    switch (e.type) {
      case "Image":
        return [
          ...j(e, "dctypes:Image"),
          ...yield* G(e),
          ...yield* te(e)
        ];
      case "Text":
      case "Dataset":
      default:
        return [...j(e, void 0), ...yield* G(e)];
    }
  },
  AnnotationCollection: function* (e) {
    return [
      ["@id", e.id],
      ["@type", "sc:Layer"],
      ["label", K(e.label)]
    ];
  },
  Collection: function* (e) {
    return [
      ...j(e, "sc:Collection"),
      ...yield* G(e),
      ...yield* te(e),
      ["members", yield* e.items]
    ];
  },
  Range: function* (e) {
    const t = [], n = [];
    if (e.items)
      for (const i of e.items) {
        const s = yield i;
        t.push({
          "@id": i.id,
          "@type": i.type,
          label: s ? s.label : void 0,
          within: e.id
        }), i.type === "Canvas" && n.push(i.id);
      }
    return [
      ...j(e, "sc:Range"),
      ...yield* G(e),
      ...yield* te(e),
      ["canvases", n.length === t.length ? n : void 0],
      ["members", n.length !== t.length ? t : void 0]
    ];
  }
};
function Z(e) {
  var t;
  return [
    ["id", (t = e.id) != null && t.startsWith("vault://") ? void 0 : e.id],
    ["type", e.type],
    ["format", e.format],
    ["profile", e.profile],
    ["height", e.height],
    ["width", e.width],
    ["duration", e.duration || void 0],
    ["viewingDirection", e.viewingDirection !== "left-to-right" ? e.viewingDirection : void 0],
    ["behavior", e.behavior && e.behavior.length ? e.behavior : void 0],
    ["timeMode", e.timeMode],
    ["motivation", Array.isArray(e.motivation) ? e.motivation[0] : e.motivation]
  ];
}
function M(e) {
  if (!(!e || e.length === 0))
    return e;
}
function Nt(e) {
  if (e && e.type && e.type === "ImageService2") {
    const { id: t, type: n, profile: i, ...s } = e, a = typeof i == "string" ? i : Array.isArray(i) ? i.find((r) => typeof r == "string") : "";
    return {
      "@id": t,
      "@type": n,
      profile: a ? a.startsWith("http") ? a : `http://iiif.io/api/image/2/${a}.json` : "http://iiif.io/api/image/2/level0.json",
      ...s
    };
  }
  return e;
}
function Ue(e) {
  if (!(!e || e.length === 0))
    return e.map(Nt);
}
function* V(e) {
  return [
    ["label", e.label],
    ["metadata", M(e.metadata)],
    ["summary", e.summary],
    ["requiredStatement", e.requiredStatement],
    ["rights", e.rights],
    ["navDate", e.navDate],
    ["language", e.language],
    ["thumbnail", M(yield e.thumbnail)],
    ["placeholderCanvas", yield e.placeholderCanvas],
    ["accompanyingCanvas", yield e.accompanyingCanvas],
    ["provider", M(yield e.provider)]
  ];
}
function* W(e) {
  return [
    ["seeAlso", M(yield e.seeAlso)],
    ["service", Ue(e.service)],
    ["services", Ue(e.services)],
    ["rendering", M(yield e.rendering)],
    ["supplementary", M(yield e.supplementary)],
    ["homepage", M(yield e.homepage)],
    ["logo", M(yield e.logo)],
    ["partOf", M(yield e.partOf)],
    ["start", e.start]
  ];
}
const Ls = {
  Manifest: function* (e, t, { isTopLevel: n }) {
    return n ? [
      ["@context", "http://iiif.io/api/presentation/3/context.json"],
      ...Z(e),
      ...yield* V(e),
      ...yield* W(e),
      ["items", yield e.items],
      ["structures", M(yield e.structures)],
      ["annotations", M(yield e.annotations)]
    ] : [
      ...Z(e),
      ...yield* V(e)
    ];
  },
  Canvas: function* (e) {
    return [
      ...Z(e),
      ...yield* V(e),
      ...yield* W(e),
      ["items", yield e.items],
      ["annotations", M(yield e.annotations)]
    ];
  },
  Agent: function* (e) {
    return [
      ["id", e.id],
      ["type", "Agent"],
      ["label", e.label],
      ...yield* W(e)
    ];
  },
  AnnotationPage: function* (e) {
    return [
      ...Object.entries(e).map(([n, i]) => [n, Array.isArray(i) ? M(i) : i]).filter(([n, i]) => n !== "items"),
      ...yield* W(e),
      ["items", yield e.items]
    ];
  },
  Service: function* (e) {
    return [[_t, Nt(e)]];
  },
  Annotation: function* (e) {
    const t = Object.entries(e).map(([i, s]) => i === "motivation" ? [i, Array.isArray(s) ? s[0] : s] : [i, Array.isArray(s) ? M(s) : s]).filter(([i]) => i !== "body"), n = yield e.body;
    return [...t, ["body", n.length === 1 ? n[0] : n]];
  },
  ContentResource: function* (e) {
    return [
      ...Z(e),
      ...yield* V(e),
      ...yield* W(e),
      ["annotations", M(yield e.annotations)],
      ["items", M(yield e.items)]
    ];
  },
  AnnotationCollection: function* (e) {
    return [
      ["id", e.id],
      ["type", "AnnotationCollection"],
      ["label", e.label]
    ];
  },
  Collection: function* (e, t, { isTopLevel: n }) {
    return n ? [
      ["@context", "http://iiif.io/api/presentation/3/context.json"],
      ...Z(e),
      ...yield* V(e),
      ...yield* W(e),
      ["items", M(yield e.items)]
    ] : [...Z(e), ...yield* V(e)];
  },
  Range: function* (e) {
    const t = [];
    for (const n of e.items)
      n.type === "Range" ? t.push(yield n) : t.push(n);
    return [
      ...Z(e),
      ...yield* V(e),
      ...yield* W(e),
      ["items", t],
      ["annotations", M(yield e.annotations)]
    ];
  }
};
function xt(e) {
  return e == null;
}
function Ft(e) {
  throw new Error("Argument " + e + " is empty.");
}
function Rs(e) {
  return typeof e == "string" || typeof e == "symbol";
}
function Bt(e) {
  return !Rs(e);
}
function Ut(e) {
  throw new Error("Argument " + e + " is invalid, it should be an action type of type: string | symbol");
}
function Ps(e, t) {
  return xt(e) && Ft(1), Bt(e) && Ut(1), Object.assign(function() {
    var n = t != null ? t.apply(void 0, arguments) : void 0;
    return Object.assign({ type: e }, n);
  }, { getType: function() {
    return e;
  }, toString: function() {
    return e;
  } });
}
function T(e, t, n) {
  return xt(e) && Ft(1), Bt(e) && Ut(1), function() {
    return Ps(e, function() {
      var i = arguments.length <= 0 ? void 0 : arguments[0], s = arguments.length <= 1 ? void 0 : arguments[1];
      return Object.assign({}, i !== void 0 && { payload: i }, {}, s !== void 0 && { meta: s });
    });
  };
}
function ie(e) {
  "@babel/helpers - typeof";
  return ie = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ie(e);
}
function Os(e, t) {
  if (ie(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var i = n.call(e, t);
    if (ie(i) != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function ks(e) {
  var t = Os(e, "string");
  return ie(t) == "symbol" ? t : t + "";
}
function qs(e, t, n) {
  return (t = ks(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function ze(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    t && (i = i.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function je(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ze(Object(n), !0).forEach(function(i) {
      qs(e, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ze(Object(n)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return e;
}
function L(e) {
  return "Minified Redux error #" + e + "; visit https://redux.js.org/Errors?code=" + e + " for the full message or use the non-minified dev environment for full errors. ";
}
var Ge = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}(), he = function() {
  return Math.random().toString(36).substring(7).split("").join(".");
}, re = {
  INIT: "@@redux/INIT" + he(),
  REPLACE: "@@redux/REPLACE" + he(),
  PROBE_UNKNOWN_ACTION: function() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + he();
  }
};
function _s(e) {
  if (typeof e != "object" || e === null) return !1;
  for (var t = e; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t;
}
function zt(e, t, n) {
  var i;
  if (typeof t == "function" && typeof n == "function" || typeof n == "function" && typeof arguments[3] == "function")
    throw new Error(L(0));
  if (typeof t == "function" && typeof n > "u" && (n = t, t = void 0), typeof n < "u") {
    if (typeof n != "function")
      throw new Error(L(1));
    return n(zt)(e, t);
  }
  if (typeof e != "function")
    throw new Error(L(2));
  var s = e, a = t, r = [], o = r, l = !1;
  function d() {
    o === r && (o = r.slice());
  }
  function y() {
    if (l)
      throw new Error(L(3));
    return a;
  }
  function w(S) {
    if (typeof S != "function")
      throw new Error(L(4));
    if (l)
      throw new Error(L(5));
    var k = !0;
    return d(), o.push(S), function() {
      if (k) {
        if (l)
          throw new Error(L(6));
        k = !1, d();
        var B = o.indexOf(S);
        o.splice(B, 1), r = null;
      }
    };
  }
  function h(S) {
    if (!_s(S))
      throw new Error(L(7));
    if (typeof S.type > "u")
      throw new Error(L(8));
    if (l)
      throw new Error(L(9));
    try {
      l = !0, a = s(a, S);
    } finally {
      l = !1;
    }
    for (var k = r = o, ee = 0; ee < k.length; ee++) {
      var B = k[ee];
      B();
    }
    return S;
  }
  function R(S) {
    if (typeof S != "function")
      throw new Error(L(10));
    s = S, h({
      type: re.REPLACE
    });
  }
  function Y() {
    var S, k = w;
    return S = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function(B) {
        if (typeof B != "object" || B === null)
          throw new Error(L(11));
        function _e() {
          B.next && B.next(y());
        }
        _e();
        var un = k(_e);
        return {
          unsubscribe: un
        };
      }
    }, S[Ge] = function() {
      return this;
    }, S;
  }
  return h({
    type: re.INIT
  }), i = {
    dispatch: h,
    subscribe: w,
    getState: y,
    replaceReducer: R
  }, i[Ge] = Y, i;
}
function Ds(e) {
  Object.keys(e).forEach(function(t) {
    var n = e[t], i = n(void 0, {
      type: re.INIT
    });
    if (typeof i > "u")
      throw new Error(L(12));
    if (typeof n(void 0, {
      type: re.PROBE_UNKNOWN_ACTION()
    }) > "u")
      throw new Error(L(13));
  });
}
function jt(e) {
  for (var t = Object.keys(e), n = {}, i = 0; i < t.length; i++) {
    var s = t[i];
    typeof e[s] == "function" && (n[s] = e[s]);
  }
  var a = Object.keys(n), r;
  try {
    Ds(n);
  } catch (o) {
    r = o;
  }
  return function(l, d) {
    if (l === void 0 && (l = {}), r)
      throw r;
    for (var y = !1, w = {}, h = 0; h < a.length; h++) {
      var R = a[h], Y = n[R], S = l[R], k = Y(S, d);
      if (typeof k > "u")
        throw d && d.type, new Error(L(14));
      w[R] = k, y = y || k !== S;
    }
    return y = y || a.length !== Object.keys(l).length, y ? w : l;
  };
}
function oe() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return t.length === 0 ? function(i) {
    return i;
  } : t.length === 1 ? t[0] : t.reduce(function(i, s) {
    return function() {
      return i(s.apply(void 0, arguments));
    };
  });
}
function Ze() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return function(i) {
    return function() {
      var s = i.apply(void 0, arguments), a = function() {
        throw new Error(L(15));
      }, r = {
        getState: s.getState,
        dispatch: function() {
          return a.apply(void 0, arguments);
        }
      }, o = t.map(function(l) {
        return l(r);
      });
      return a = oe.apply(void 0, o)(s.dispatch), je(je({}, s), {}, {
        dispatch: a
      });
    };
  };
}
const Gt = "@iiif/IMPORT_ENTITIES", Zt = "@iiif/MODIFY_ENTITY_FIELD", Vt = "@iiif/REORDER_ENTITY_FIELD", Wt = "@iiif/ADD_REFERENCE", Ht = "@iiif/REMOVE_REFERENCE", Qt = T(Gt)(), Ns = T(Zt)(), xs = T(Vt)(), Fs = T(Wt)(), Bs = T(Ht)(), Us = { importEntities: Qt, modifyEntityField: Ns, reorderEntityField: xs, addReference: Fs, removeReference: Bs }, Yt = "@iiif/ADD_MAPPING", Xt = "@iiif/ADD_MAPPINGS", zs = T(Yt)(), js = T(Xt)(), Jt = "@iiif/SET_META_VALUE", Kt = "@iiif/SET_META_VALUE_DYNAMIC", $t = "@iiif/UNSET_META_VALUE", Gs = T(Jt)(), Zs = T(Kt)(), Vs = T($t)(), Ve = {
  setMetaValue: Gs,
  setMetaValueDynamic: Zs,
  unsetMetaValue: Vs
}, Ie = "RESOURCE_ERROR", en = "RESOURCE_LOADING", Ae = "RESOURCE_READY", tn = "@iiif/REQUEST_RESOURCE", nn = "@iiif/REQUEST_ERROR", an = "@iiif/REQUEST_MISMATCH", sn = "@iiif/REQUEST_COMPLETE", rn = "@iiif/REQUEST_OFFLINE_RESOURCE", Ws = T(tn)(), on = T(nn)(), Hs = T(an)(), Qs = T(sn)();
T(rn)();
const qe = "@iiif/BATCH", ln = "@iiif/BATCH_IMPORT", Se = T(qe)();
T(ln)();
const Ys = (e, t) => {
  const { entities: n, resource: i, mapping: s } = Is(t);
  if (i.id === void 0)
    return [on({ id: e, message: "ID is not defined in resource." })];
  const a = [Qt({ entities: n }), js({ mapping: s })];
  return i.id !== e && (a.push(zs({ id: e, type: i.type })), a.push(Hs({ requestId: e, actualId: i.id }))), a.push(Qs({ id: e })), a;
}, We = Number.isNaN || function(t) {
  return typeof t == "number" && t !== t;
};
function Xs(e, t) {
  return !!(e === t || We(e) && We(t));
}
function He(e, t) {
  if (!Array.isArray(e) || !Array.isArray(t))
    return e === t;
  if (e.length !== t.length)
    return !1;
  for (let n = 0; n < e.length; n++)
    if (!Xs(e[n], t[n]))
      return !1;
  return !0;
}
function fe(e, t) {
  const n = e.iiif.requests[t], i = e.iiif.mapping[t];
  if (!(!i || !e.iiif.entities[i][n.resourceUri]))
    return e.iiif.entities[i][n.resourceUri];
}
function Qe(e, t, { waitTimeout: n = 30 } = {}) {
  return async (i, s) => {
    const a = e.getState(), r = a.iiif.requests[i];
    if (r)
      switch (r.loadingState) {
        case Ie:
          break;
        case en: {
          let o, l = !1;
          try {
            const d = await Promise.race([
              new Promise((y, w) => {
                l || (o = e.subscribe(() => {
                  const h = e.getState();
                  if (h.iiif.requests[i].loadingState === Ie) {
                    w();
                    return;
                  }
                  if (h.iiif.requests[i].loadingState === Ae) {
                    const R = fe(h, i);
                    R ? y(R) : w();
                  }
                }));
              }),
              new Promise((y, w) => setTimeout(() => {
                l = !0, w();
              }, n * 60))
            ]);
            if (o && o(), d)
              return d;
          } catch {
            o && o();
            break;
          }
          break;
        }
        case Ae: {
          const o = fe(a, i);
          if (o)
            return o;
          break;
        }
      }
    e.dispatch(Ws({ id: i }));
    try {
      const o = await t(i, s);
      !o.id && !o["@id"] && (o["@type"] && (o["@id"] = i), o.id = i);
      const l = Ys(i, o);
      return e.dispatch(Se({ actions: l })), fe(e.getState(), i);
    } catch (o) {
      throw e.dispatch(on({ id: i, message: o.toString() })), o;
    }
  };
}
function Js() {
  return {
    Collection: {},
    Manifest: {},
    Canvas: {},
    AnnotationPage: {},
    AnnotationCollection: {},
    Annotation: {},
    ContentResource: {},
    Range: {},
    Service: {},
    Selector: {},
    Agent: {}
  };
}
const Ks = (e = {}, t) => {
  switch (t.type) {
    case Yt:
      return {
        ...e,
        [t.payload.id]: t.payload.type
      };
    case Xt:
      return {
        ...e,
        ...t.payload.mapping
      };
    default:
      return e;
  }
};
function me(e, t, n, i) {
  return !(!e[n] || !e[n][t] || !e[n][t][i] || !Array.isArray(e[n][t][i]));
}
function $s(e, t) {
  const n = {}, i = [];
  for (const [s, a] of Object.entries(e || {})) {
    i.push(s);
    const r = (t || {})[s];
    if (!r || r.length === 0) {
      n[s] = a;
      continue;
    }
    n[s] = r;
  }
  for (const [s, a] of Object.entries(t || {}))
    i.indexOf(s) === -1 && (n[s] = a);
  return n;
}
const er = (e = Js(), t) => {
  var n;
  switch (t.type) {
    case Zt: {
      if (!e[t.payload.type] || !e[t.payload.type][t.payload.id])
        return e;
      const i = e[t.payload.type][t.payload.id];
      return typeof i == "string" ? e : {
        ...e,
        [t.payload.type]: {
          ...e[t.payload.type],
          [t.payload.id]: {
            ...i,
            [t.payload.key]: t.payload.value
          }
        }
      };
    }
    case Vt: {
      if (!me(e, t.payload.id, t.payload.type, t.payload.key))
        return e;
      const i = e[t.payload.type][t.payload.id];
      if (typeof i == "string")
        return e;
      const s = Array.from(i[t.payload.key]), [a] = s.splice(t.payload.startIndex, 1);
      return s.splice(t.payload.endIndex, 0, a), {
        ...e,
        [t.payload.type]: {
          ...e[t.payload.type],
          [t.payload.id]: {
            ...i,
            [t.payload.key]: s
          }
        }
      };
    }
    case Gt: {
      const i = Object.keys(t.payload.entities), s = { ...e };
      for (const a of i) {
        const r = t.payload.entities[a], o = { ...e[a] || {} };
        let l = !1;
        const d = Object.keys(r || {}) || [];
        if (r && d) {
          for (const y of d)
            l = !0, o[y] = e[a][y] ? $s(e[a][y], r[y]) : r[y];
          l && (s[a] = o);
        }
      }
      return s;
    }
    case Wt: {
      if (!me(e, t.payload.id, t.payload.type, t.payload.key))
        return e;
      const i = e[t.payload.type][t.payload.id], s = Array.from(i[t.payload.key]);
      return s.splice(t.payload.index || s.length + 1, 0, t.payload.reference), {
        ...e,
        [t.payload.type]: {
          ...e[t.payload.type],
          [t.payload.id]: {
            ...i,
            [t.payload.key]: s
          }
        }
      };
    }
    case Ht: {
      if (!me(e, t.payload.id, t.payload.type, t.payload.key))
        return e;
      const i = e[t.payload.type][t.payload.id], s = Array.from(i[t.payload.key]), a = t.payload.index || s.findIndex((r) => r && r.id === t.payload.reference.id);
      return a === -1 || ((n = s[a]) == null ? void 0 : n.id) !== t.payload.reference.id ? e : (s.splice(a, 1), {
        ...e,
        [t.payload.type]: {
          ...e[t.payload.type],
          [t.payload.id]: {
            ...i,
            [t.payload.key]: s
          }
        }
      });
    }
    default:
      return e;
  }
}, tr = (e = {}, t) => {
  switch (t.type) {
    case tn:
    case rn:
      return {
        ...e,
        [t.payload.id]: {
          requestUri: t.payload.id,
          loadingState: en,
          uriMismatch: !1,
          resourceUri: t.payload.id
        }
      };
    case an:
      return {
        ...e,
        [t.payload.requestId]: {
          ...e[t.payload.requestId] || {},
          uriMismatch: !0,
          resourceUri: t.payload.actualId
        },
        [t.payload.actualId]: {
          requestUri: t.payload.requestId,
          loadingState: e[t.payload.requestId].loadingState,
          uriMismatch: !0,
          resourceUri: t.payload.actualId
        }
      };
    case nn:
      return {
        ...e,
        [t.payload.id]: {
          ...e[t.payload.id] || {},
          loadingState: Ie,
          error: t.payload.message
        }
      };
    case sn:
      return {
        ...e,
        [t.payload.id]: {
          ...e[t.payload.id] || {},
          loadingState: Ae,
          error: void 0
        }
      };
  }
  return e;
}, nr = (e = {}, t) => {
  const { id: n, updateValue: i, value: s, meta: a, key: r } = t && t.payload || {};
  switch (t.type) {
    case Jt:
      return {
        ...e,
        [n]: {
          ...e[n] || {},
          [a]: {
            ...e[n] ? e[n][a] || {} : {},
            [r]: s
          }
        }
      };
    case Kt:
      return {
        ...e,
        [n]: {
          ...e[n] || {},
          [a]: {
            ...e[n] ? e[n][a] || {} : {},
            [r]: e[n] && e[n][a] ? i(e[n][a][r]) : i(void 0)
          }
        }
      };
    case $t:
      return e[n] && e[n][a] && e[n][a][r] ? {
        ...e,
        [n]: {
          ...e[n] || {},
          [a]: {
            ...e[n] ? e[n][a] || {} : {},
            [r]: void 0
          }
        }
      } : e;
    default:
      return e;
  }
};
function ir(e) {
  return (t, n) => n && n.type === qe ? n.payload.actions.reduce(e, t) : n && n.type === ln ? n.payload.state : e(t, n);
}
const ar = jt({
  mapping: Ks,
  entities: er,
  requests: tr,
  meta: nr
}), sr = typeof window < "u" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || oe;
function rr(e = {}) {
  const {
    enableDevtools: t = !0,
    iiifStoreName: n = "iiif",
    defaultState: i = {},
    extraMiddleware: s = [],
    customReducers: a = {}
  } = e, r = jt({ [n]: ar, ...a });
  return zt(ir(r), i, t ? sr(Ze(...s)) : oe(Ze(...s)));
}
function or(e) {
  return { all: e = e || /* @__PURE__ */ new Map(), on: function(t, n) {
    var i = e.get(t);
    i ? i.push(n) : e.set(t, [n]);
  }, off: function(t, n) {
    var i = e.get(t);
    i && (n ? i.splice(i.indexOf(n) >>> 0, 1) : e.set(t, []));
  }, emit: function(t, n) {
    var i = e.get(t);
    i && i.slice().map(function(s) {
      s(n);
    }), (i = e.get("*")) && i.slice().map(function(s) {
      s(t, n);
    });
  } };
}
class lr {
  constructor(t, n) {
    q(this, "options");
    q(this, "store");
    q(this, "emitter");
    q(this, "isBatching", !1);
    q(this, "batchQueue", []);
    q(this, "remoteFetcher");
    q(this, "staticFetcher");
    q(this, "defaultFetcher", (t) => fetch(t).then((n) => n.json()));
    q(this, "middleware", (t) => (n) => (i) => {
      if (i.type === qe) {
        for (const r of i.payload.actions)
          this.emitter.emit(r.type, { realAction: r, state: t.getState() });
        const a = n(i);
        for (const r of i.payload.actions)
          this.emitter.emit(`after:${i.type}`, { action: i, state: a });
        return a;
      }
      this.emitter.emit(i.type, { action: i, state: t.getState() });
      const s = n(i);
      return this.emitter.emit(`after:${i.type}`, { action: i, state: s }), s;
    });
    this.options = Object.assign({
      reducers: {},
      middleware: [],
      defaultState: {},
      customFetcher: this.defaultFetcher,
      enableDevtools: !0
    }, t || {}), this.store = n || rr({
      customReducers: this.options.reducers,
      extraMiddleware: [...this.options.middleware, this.middleware],
      defaultState: this.options.defaultState,
      enableDevtools: this.options.enableDevtools
    }), this.emitter = or(), this.remoteFetcher = Qe(this.store, this.options.customFetcher), this.staticFetcher = Qe(this.store, (i, s) => s);
  }
  batch(t) {
    this.isBatching = !0;
    try {
      t(this), this.store.dispatch(Se({ actions: this.batchQueue }));
    } catch (n) {
      throw this.batchQueue = [], this.isBatching = !1, n;
    }
    this.batchQueue = [], this.isBatching = !1;
  }
  async asyncBatch(t) {
    this.isBatching = !0;
    try {
      await t(this), this.store.dispatch(Se({ actions: this.batchQueue }));
    } catch (n) {
      throw this.batchQueue = [], this.isBatching = !1, n;
    }
    this.batchQueue = [], this.isBatching = !1;
  }
  modifyEntityField(t, n, i) {
    this.dispatch(Us.modifyEntityField({
      id: t.id,
      type: t.type,
      key: n,
      value: i
    }));
  }
  dispatch(t) {
    this.isBatching ? this.batchQueue.push(t) : this.store.dispatch(t);
  }
  serialize(t, n) {
    return Ms(this.getState().iiif, t, n);
  }
  toPresentation2(t) {
    return this.serialize(t, Ts);
  }
  toPresentation3(t) {
    return this.serialize(t, Ls);
  }
  hydrate(t, n) {
    return this.get(t, n, { skipSelfReturn: !1 });
  }
  get(t, n, i = {}) {
    typeof n != "string" && (i = n || {}, n = void 0);
    const { skipSelfReturn: s = !0 } = i || {};
    if (Array.isArray(t))
      return t.map((d) => this.get(d, i));
    const a = this.getState();
    if (typeof t == "string") {
      const d = n || a.iiif.mapping[t];
      if (!d)
        return s ? null : { id: t, type: "unknown" };
      t = { id: t, type: d };
    }
    const r = n || t.type, o = t.id, l = a.iiif.entities[r];
    if (!l) {
      const d = a.iiif.requests[o];
      return d && d.resourceUri !== o ? this.get(d.resourceUri, i) : s ? null : t;
    }
    return l[t.id] || (s ? null : t);
  }
  select(t) {
    return t(this.getState());
  }
  getStore() {
    return this.store;
  }
  getState() {
    return this.store.getState();
  }
  loadManifest(t, n) {
    const i = typeof t == "string" ? t : t.id;
    return this.load(i, n);
  }
  loadCollection(t, n) {
    const i = typeof t == "string" ? t : t.id;
    return this.load(i, n);
  }
  load(t, n) {
    const i = typeof t == "string" ? t : t.id;
    return n ? this.staticFetcher(i, n) : this.remoteFetcher(i);
  }
  areInputsEqual(t, n) {
    return He(t, n);
  }
  subscribe(t, n, i) {
    typeof i > "u" && (typeof n > "u" || n === !1 || n === !0) && (i = n, n = t, t = (a) => a);
    let s = i ? null : t(this.store.getState());
    return i || n(s, this), this.store.subscribe(() => {
      const a = this.store.getState(), r = t(a);
      s !== r && !He(s, r) && n(r, this), s = r;
    });
  }
  async ensureLoaded(t) {
    const n = typeof t == "string" ? t : t.id;
    this.requestStatus(n) || await this.load(n);
  }
  requestStatus(t) {
    return this.select((n) => n.iiif.requests[t]);
  }
  getResourceMeta(t, n) {
    const i = this.getState().iiif.meta[t];
    if (i)
      return n ? i[n] : i;
  }
  setMetaValue([t, n, i], s) {
    this.dispatch(typeof s == "function" ? Ve.setMetaValueDynamic({
      id: t,
      meta: n,
      key: i,
      updateValue: s
    }) : Ve.setMetaValue({
      id: t,
      meta: n,
      key: i,
      value: s
    }));
  }
}
const ur = {
  name: "VideoViewer",
  components: { VideoPlayer: wn },
  props: {
    /**
     * the Url of the manifest
     */
    manifestUrl: {
      type: String,
      default: void 0
    }
  },
  data() {
    return {
      /**
       * the manifest
       */
      manifest: void 0,
      /**
       * the url of the video file to play
       */
      videoSource: void 0,
      /**
       * the url of the subtitles and caption tracks
       */
      tracks: void 0
    };
  },
  watch: {
    manifestUrl() {
      this.loadVideoManifest();
    }
  },
  mounted() {
    this.loadVideoManifest();
  },
  methods: {
    /**
     * loads a video into the viewer from a manifest
     */
    async loadVideoManifest() {
      if (this.$el.vault || (this.$el.vault = new lr()), this.manifest = this.$el.vault.get({
        id: this.manifestUrl,
        type: "Manifest"
      }), !this.manifest) {
        await this.fetchManifest();
        const e = this.$el.vault.get(this.manifest.items[0]), t = this.getVideoService(e);
        this.videoSource = [
          {
            type: "application/x-mpegURL",
            src: t
          }
        ], this.tracks = this.getVideoTracks(e);
      }
    },
    /**
     * Fetches the manifest and loads into vault (NB: duplicates logic in viewerSupport)
     */
    async fetchManifest() {
      var n;
      const e = await fetch(this.manifestUrl);
      let t;
      e.status == 200 && (t = await e.json(), this.manifest = await ((n = this.$el.vault) == null ? void 0 : n.loadManifest(
        this.manifestUrl,
        t
      )));
    },
    /**
     * Extracts the video service from a canvas
     *
     * @param canvas
     *
     * @returns {String} - the ID of the video service
     */
    getVideoService(e) {
      let t = this.$el.vault.get(e.items[0].id);
      return this.$el.vault.get(t.items[0].id).body[0].id;
    },
    /**
     * Get the caption and/or description tracks for a canvas
     *
     * @param canvas
     *
     * @returns {Array} - an array of objects describing the description and caption tracks
     */
    getVideoTracks(e) {
      let t = [];
      const n = this.$el.vault.get(e.rendering[0]);
      if (n) {
        let s = {
          label: "Audio Description",
          kind: "description",
          srclang: "en",
          src: n.id,
          default: !1
        };
        t.push(s);
      }
      return this.$el.vault.get(e.annotations).forEach((s) => {
        let a = this.$el.vault.get(s.items[0].id);
        if (a.motivation.includes("supplementing")) {
          let r = {
            label: "Captions",
            kind: "caption",
            srclang: "en",
            src: a.body.id,
            default: !1
          };
          t.push(r);
        }
      }), t;
    }
  }
};
function cr(e, t, n, i, s, a) {
  const r = f("VideoPlayer");
  return s.videoSource ? (u(), v(r, {
    key: 0,
    sources: s.videoSource,
    tracks: s.tracks
  }, null, 8, ["sources", "tracks"])) : g("", !0);
}
const wr = /* @__PURE__ */ I(ur, [["render", cr]]), dr = {
  "o-image-viewer": { error_message: "There was an error loading the image (Error: {status})", label_delimiter: ", ", alt_text: { facing_pages: "Facing Pages", choice: "that has an alternate view" } },
  "a-choice-menu": { default: "Alternate views", tooltip: { no_alternate_views: "This page does not have any alternate views", feature_not_available: "This feature is only available in single and facing pages" } },
  "a-fullscreen-button": { fullscreen: "Full Screen", fullscreenExit: "Exit Full Screen" },
  "a-toolbar-menu": { toggle: { "aria-open": "Close Menu: {menu}", "aria-close": "Open Menu: {menu}" }, AlternateViews: "Alternate Views", Grid: "Layout" },
  "a-sequence-labels": { label: { left: "Left: {label}", right: "Right: {label}" } },
  "a-layout-menu": { gallery: "Grid", paged: "Facing Pages", single_page: "Single Page", layout: { default: "Layout" } },
  "a-image-tools-button-group": { fullscreen: "Full Screen", fullscreenExit: "Exit Full Screen" },
  "a-resource-unavailable": { image: { alt_text: "Image graphic with strikethrough", caption: "Image not available" } },
  "a-download-menu": { dimensions: " ({0} x {1} px)", download_button_label: "Download image", small: "Presentation/study", large: "Large Image", full: "Highest Resolution", ariaResolution: "Download {resolution}", aria_download_link: "Download link for {dimensions} image", aria_mirador_link: "Draggable link for IIIF manifest", aria_iiif_download: "Download link for IIIF Manifest", download_heading: "Downloads", actions_heading: "Actions", permission_heading: "Permission", publication_use_heading: "Publication use", restrictions_heading: "Digital Use Restrictions", caption_heading: "Caption Information", iiif_manifest: "IIIF Manifest", image_request_button_label: "Request this image", restrictions_button_label: "Digital use and restrictions" },
  "m-image-viewer-rights-panel": { image_request_button_label: "Order this image", COPYRIGHT_UNIDENTIFIABLE: "In Copyright - Rights-holder(s) unlocatable or unidentifiable", IN_COPYRIGHT_UNIDENTIFIABLE: "In Copyright - Rights-holder(s) unlocatable or unidentifiable", UNDETERMINED: "Copyright Undetermined", COPYRIGHT_UNDETERMINED: "Copyright Undetermined", IN_COPYRIGHT: "In Copyright", NO_COPYRIGHT: "No Copyright - United States", NOT_EVALUATED: "Copyright not evaluated", ZERO: "Public Domain" },
  "m-image-viewer-thumbnails": { thumbnail_count_label: "{ '' } | {count} image | { count } images" }
}, hr = { en: dr }, Cr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  messages: hr
}, Symbol.toStringTag, { value: "Module" }));
export {
  br as ImageServiceViewer,
  vr as ImageViewer,
  wr as VideoViewer,
  Cr as locales
};
